/* eslint-disable no-unused-vars */
import Dexie from "dexie";

// export var externalURL = "https://digitalonboarding.accessbankplc.com"; // UAT
export var externalURL = "https://bwdigitalonboardingbc.accessbankplc.com"; // LIVE
// export var externalURL = "https://41.198.138.246"; // UAT
// export var externalURL = "https://41.198.138.243"; // LIVE
// export var externalURL = "https://bwdigitalonboardingbc.accessbankplc.com"; // LIVE
// export var externalURL = "https://df62-106-51-13-2.ngrok-free.app/";

//UAT
// if (
//   externalURL.includes("localhost") ||
//   externalURL.includes("41.198.138.246") ||
//   externalURL.includes("digitalonboarding")
// ) {
//   // debugger
//   externalURL = externalURL + ":4443/";
// }

if (
  externalURL.includes("localhost") ||
  externalURL.includes("41.198.138.243") ||
  externalURL.includes("bwdigitalonboardingbc")
) {
  externalURL = externalURL + ":4443/";
  // externalURL = externalURL + ":88/";
}

// if(baseUrl.includes("localhost") || baseUrl.includes("bwuatdigitalonboarding")){

//     baseUrl = baseUrl + ":4443/";
// }
export var Version = "v2.0.3";//LIVE
// export var Version = "v2.0.8";//UAT
export var formJsonValue = [];
export var formImage = [];
var cookieName = "Accessbank";
export const db = new Dexie("AccessBankDB_" + Version);
//var baseUrl = "https://10.201.2.147" //UI
var baseUrl = "https://41.198.138.246:4443"; //UAT
// var baseUrl = "https://41.198.138.243:443" //original

export var disabledFields = ["Application Date", "Branch Name", "Branch Code"];
export var SavedFormDisabledFields = [
  "AccountType",
  "Application Date",
  "Branch Name",
  "Branch Code",
];
db.version(1).stores({
  // ClientSyncQueue: "SyncQueuePKID,ClientPKID,TableName",
  ClientSyncQueue: "++SyncQueuePKID,FormID,SurveyID,CreatedDate,TagName",
  AppSettings: "ServerPKID,LocalSyncDateTime,ClientPKID,UserId",
  User: "UserId,IsLoggedIn,TokenId,UserName,Password",
  TbSurvey:
    "++pkId,ClientPKID,SurveyID,SurveyName,CreatedDate,UserId,IsSubmitted,IsSaved,FormulaFunction",
  TbSurveyQuestions:
    "++pkId,QuestionID,QuestionName,QuestionType,QuestionOrder,SurveyID,SectionId,IsConditionQuestion,ConditionSectionId, ConditionType, ConditionValue1, TotCount, IsRepeatSection, RepeatSectionId, FieldVar,FormulaExpression, IsFormulaQuestion, IsSearchable, DefaultValue, HierarchyQuestionOrder,MinValue,MaxValue,TextLength,ErrorText,RegEx,IsMandatory,ValidationCondition,hide",
  TbQuestionOptions:
    "++pkId,OptionID,OptionValue,OptionText,SurveyID,QuestionID,QuestionType,QuestionText,ParentID",
  TbAnswers:
    "++AnswerID,Answer,QuestionID,QuestionType,SurveyID,UserID,OptionID,FormID,FormName,FormCreatedDate,FormCreatedby,EntryId,EntryName,EntryCreatedDate,EntryCreatedBy,FileName,OrginalFileName,Blob,files,ContentType,RepeatOrder",
  TbSurveyForm:
    "++pkId,FormID,Name,SurveyID,CreatedDate,CreatedBy,IsActive,IsSubmitted,IsSaved,UserID,SectionCount",
  TbSurveySection:
    "++pkId,SectionId, Name, CreatedDate, UpdatedDate, CreatedBy, UpdatedBy, IsActive, SurveyId, SectionOrder, ParentSectionId,TotCount",
  TbNotifications:
    "++NtID,Notification,IsRead,UserId,CreatedDate,CreatedBy,Link",
  TbSurveyFormEntry:
    "++pkId,EntryId, EntryName,SurveyID, FormId, CreatedDate, UpdatedDate, CreatedBy, UpdatedBy, IsActive,IsSubmitted,IsSaved,SectionCount,UserID",
  TbMasterTable: "++PkId,ItemId,ItemName,ItemParentId,TableName",
  // TbGenz:
  //   "++PkId,DSALoginID,DSALoginPwd,DSAUserId,PWAUserSessionStatus,PWAUserSessionId,PWAUserBranchCode,PWAUserBranchName,loginType,LoginUserID,UserId,mobilenumber,firstname,lastname,email,howdidyouknow,video,pancardphoto,aadharphoto,aadharbackphoto,token,nameinkyc,sexinkyc,fathernameinkyc,dobinkyc,idnoinkyc,aadharnoinkyc,pannoinkyc,nationalityinkyc,placeofbirthinkyc,liveness,aadharaddressinkyc,companypannoinkyc,doorblocknoinkyc,nameofvillageinkyc,roadstreetpostofficeinkyc,arealocalityinkyc,towncitydistrictinkyc,itrpanstateinkyc,pinzipcodeinkyc,facematch,facematchPercentage,branch,producttype,basedob,consentForm,termsandCondition,aadharaddressinkyc1,aadharaddressinkyc2,aadharaddressinkyc3,aadharaddressinkyc4,aadharstateinkyc,aadharreference,totuploadCount,otpNumber,otpcorrelationid,eyeblink,headlefttilt,headrighttilt,livenessuploadcount,branchstate",
  
  TbGenz:
    "++PkId,DSALoginID,DSALoginPwd,DSAUserId,PWAUserSessionStatus,PWAUserBranchCode,PWAUserBranchName,loginType,LoginUserID,UserId,mobilenumber,firstname,lastname,email,howdidyouknow,video,pancardphoto,aadharphoto,aadharbackphoto,token,nameinkyc,sexinkyc,fathernameinkyc,dobinkyc,idnoinkyc,aadharnoinkyc,pannoinkyc,nationalityinkyc,placeofbirthinkyc,liveness,aadharaddressinkyc,companypannoinkyc,doorblocknoinkyc,nameofvillageinkyc,roadstreetpostofficeinkyc,arealocalityinkyc,towncitydistrictinkyc,itrpanstateinkyc,pinzipcodeinkyc,facematch,facematchPercentage,branch,producttype,basedob,consentForm,termsandCondition,aadharaddressinkyc1,aadharaddressinkyc2,aadharaddressinkyc3,aadharaddressinkyc4,aadharstateinkyc,aadharreference,totuploadCount,otpNumber,otpcorrelationid,eyeblink,headlefttilt,headrighttilt,livenessuploadcount,branchstate",
  
    TbUUID:
    "++PkId,UUID,Name,MobileNumber,EmailId,EKYCFlag,AadhaarNo,AadhaarName,AadhaarGender,AadhaarDOB",
});

// db.open().catch(function(error) {
//     console.error('Failed to open database: ' + error);
//   });
import CryptoJS from "crypto-js";
import router from "@/router";
import axios from "axios";
import $ from "jquery";

export default { db };
import Vue from "vue";
import { colors } from "vuetify/lib";
import { getSessionId } from '@/services/sessionservice';
export const sunidhiPlugin = {
  install(app) {
    const sunidhi = Vue.observable({
      sessionIdErrorMsg: "Sorry! Please try again.1", //Session ID not getting from Server  //825-livness sessioid //facematch 1463
      exceptionalGeneralError: "Something went wrong. Please try again later.", //Session ID not getting from Server
      exceptionalNetworkError:
        "Service Unavailable due to network issue. Please try again later.1", //Session ID not getting from Server
      emailOtp11: "",
      emailOtp12: "",
      emailOtp13: "",
      emailOtp14: "",
      emailOtp15: "",
      emailOtp16: "",
      isDisableInitOTPProceedBtn: true,
      submitstatus: false,
      FinalTimestamp: [],
      aml2waitTime: 5000,
      backbuttonpressed: false,

      getbackbuttonpressed() {
        return this.backbuttonpressed;
      },
      setbackbuttonpressed(value) {
        this.backbuttonpressed = value;
      },
      // Version: "v2.0.8",
      Version: "v2.0.3",
      cookieName: "Accessbank",
      baseUrl: baseUrl,
      keyValue: "Yk5fJ9Cdq5djTaxagPEteg==",
      decryptedDSAUserID: "",
      PwaUserType: "DSA",
      isInvalidOTP: false,
      invaldOTPErrMsg: "",
      Occupation: [],
       portfolioOptions: [],
      channelAqOptions: [],
      industryOptions: [],
      kycOptions: [],
      legstatOptions: [],
      referralsOptions: [],
      resstatusOptions: [],
      salesOriOptions: [],
      segmentOptions: [],
      segmentCOptions: [],
      segmentNameOptions: [],
      accountOfficerNameOptions: [],
      EmploymentStatus: [],
      ISDcode: [],
      Branch: [],
      title: [],
      Gender: [],
      maritalStatus: [],
      City: [],
      NearestCity: [],
      State: [],
      ISDCode: [],
      ResidentStatus: [],
      CurrenciesAllowed: [],
      CountryCode: [],
      CustomerType: [],
      District: [],
      CurrentAccountClass: [],
      SavingsAccountClass: [],
      CallAccountClass: [],
      TransactionalAccountClass: [],
      AccountClass: [],
      LiteKYCAccountType: [],
      FullKYCAccountType: [],
      AccountType: [],
      logoutBtnDisp: false,
      isDispLogoutPopUp: false,
      currentAcctType: [],
      catchaData: "",
      vasurveyid: 1,
      EmployedProofDocument: [],
      SelfEmployedProofDocument: [],
      PensionerProofDocument: [],
      UnEmployedProofDocument: [],
      verifyUserNameErrMsg: "",
      mailOtpCount: 0,
      FullKYCAccoutClass: [],
      isActive: true,
      isDisabled: false,
      isdisableProceedBtn: true,
      externalURL,
      formJsonValue,
      formImage,

      // async checkDBVersion() {
      //     try {
      //       const databases = await Dexie.getDatabaseNames();
      //       console.log("dbbbb::::", databases);
      //       const dbName = 'AccessBankDB_' + this.Version;

      //       for (let i = 0; i < databases.length; i++) {
      //         if (databases[i] !== dbName && dbName.includes('AccessBankDB')) {
      //           const dbToDelete = new Dexie(databases[i]);
      //           await dbToDelete.delete();
      //           console.log(`Deleted old database: ${databases[i]}`);
      //         }
      //       }
      //     } catch (error) {
      //       console.error('Error deleting old databases:', error);

      //       // Additional handling based on the error type
      //       if (error instanceof DOMException) {
      //         console.error('DOMException occurred. Check storage permissions and limits.');
      //         // Provide user feedback about storage issues
      //       } else {
      //         // Handle other types of errors
      //         // Show generic error message to users
      //       }
      //     }
      //   },

      async checkDBVersion() {
        var isNew = false;
        const databases = await Dexie.getDatabaseNames();
        var dbName = "AccessBankDB_" + this.Version;
        for (var i = 0; i < databases.length; i++) {
          if (databases[i] != dbName && dbName.includes("AccessBankDB")) {
            var dbold = new Dexie(databases[i]);
            dbold.delete();
            sunidhi.logoutBtnDisp = false;
            router.replace({ name: "LoginPage" });
          }
        }
      },

      async ValidatePWADSALoginId(UserID) {
        var self = this;
        var genzdata = await this.db.TbGenz.where("UserId").anyOf(1).toArray();
        var ForgotPwdDSAUserIDDecrypted = "";

        try {
          const response = await axios.post(
            this.externalURL + "ValidatePWADSALoginId/",
            null,
            {
              headers: {
                PWADSALoginId: UserID,
                PwaUserType: this.PwaUserType, // DSA
                // PWAUserSessionId: genzdata[0].PWAUserSessionId,
                PWAUserSessionId: getSessionId(),
                "ngrok-skip-browser-warning": "69420",
              },
              responseType: "application/text",
            }
          );

          const data = response.data;

          if (data && data.PWAUserAuthenticationStatus) {
            switch (data.PWAUserAuthenticationStatus) {
              case "76": // success
                var loginType = data.PasswordUpdateType;
                if (data.PWAUserUserId != null) {
                  ForgotPwdDSAUserIDDecrypted = await this.decryptValue(
                    data.PWAUserUserId,
                    this.keyValue
                  );
                  ForgotPwdDSAUserIDDecrypted =
                    ForgotPwdDSAUserIDDecrypted.trimEnd();
                }
                var genzdata1 = await this.db.TbGenz.where("UserId")
                  .anyOf(1)
                  .toArray();
                if (genzdata1 != null && genzdata1.length > 0) {
                  await this.db.TbGenz.update(genzdata1[0].PkId, {
                    loginType: loginType,
                    DSAUserId: ForgotPwdDSAUserIDDecrypted,
                  });
                } else {
                  await this.db.TbGenz.put({
                    UserId: 1,
                    loginType: loginType,
                    DSAUserId: ForgotPwdDSAUserIDDecrypted,
                  });
                  genzdata1 = await this.db.TbGenz.where("UserId")
                    .anyOf(1)
                    .toArray();
                }
                setTimeout(() => {
                  self.PreLoader = false;
                }, 500);

                router.push({ name: "OtpPage" });
                setTimeout(() => {
                  self.PreLoader = false;
                }, 500);

                break;

              case "101":
                setTimeout(() => {
                  self.PreLoader = false;
                  // verifyUserNameErrMsg = "Please enter a valid Username"
                }, 500);

                alert("Please enter a valid Credentials");
                setTimeout(() => {
                  self.PreLoader = false;
                  // verifyUserNameErrMsg = "Please enter a valid Username"
                }, 500);

                break;
            }
            setTimeout(() => {
              self.PreLoader = false;
            }, 500);
          }
        } catch (error) {
          if(error === 'Duplicate session'){
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          }
          setTimeout(() => {
            self.PreLoader = false;
          }, 500);
          alert("Error in Changing the Password");
        }
      },

      async encryptValue(plainText, base64Key) {
        // const payload = "hello"
        var derived_key = CryptoJS.enc.Base64.parse(base64Key);
        var iv = CryptoJS.enc.Utf8.parse("1020304050607080");
        // var encryptedValue = CryptoJS.AES.encrypt(plainText, derived_key, {iv: iv, mode: CryptoJS.mode.CBC}).toString();
        var encrypted = CryptoJS.AES.encrypt(plainText, derived_key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        encrypted = encrypted.toString();
        var decryptedData = await this.decryptValue(encrypted, this.keyValue);
        return encrypted;
      },

      async decryptValue(encryptedText, base64Key) {
        var derived_key = CryptoJS.enc.Base64.parse(base64Key);
        var iv = CryptoJS.enc.Utf8.parse("1020304050607080");
        var d_test = CryptoJS.AES.decrypt(encryptedText, derived_key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
        });
        var d_test1 = d_test.toString(CryptoJS.enc.Utf8);
        // console.log("decrypt value:", d_test1);
        return d_test1;
      },

      async getISDcode() {
        var url =
          this.externalURL +
          "get_lookup_value/?lookupType=ISDCode&lookupString=";

        try {
          const response = await axios.post(url, {
            headers: {
              "ngrok-skip-browser-warning": "69420",
            },
          });

          if (response.data && response.data.length > 0) {
            var ids = response.data.map((o) => o.LookUpCode);
            this.ISDcode = response.data.filter(
              ({ LookUpCode }, index) => !ids.includes(LookUpCode, index + 1)
            );
          }
        } catch (error) {
          console.log(error);
        }
      },

      async resendEmailOtp(mobileNo, emailId, userid, self) {
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        // var url = externalURL +"SendOTP/?PWAUserSessionId=" + genzdata[0].PWAUserSessionId;
        var url = externalURL + "SendOTP/";
        var test = mobileNo.replace(/[+-]/g, "");

        var formJson = {
          SMSToAddress: mobileNo,
          MailToAddress: emailId,
          UserID: userid,
          OTPSource: "REGOTP",
          MailOTPSourceSubject: "RegMailOTPSubject",
          SMSOTPSource: "RegSMSOTP",
          MailOTPSource: "RegMailOTP",
          // PWAUserSessionId: genzdata[0].PWAUserSessionId,
          PWAUserSessionId: getSessionId(),
        };
        try {
          const response = await axios.post(url, formJson, {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "ngrok-skip-browser-warning": "69420",
              'DSAUserId': genzdata[0].DSAUserId
            },
          });

          const data = response.data;

          if (data.PWAUserSessionStatus === "expired") {
            setTimeout(() => {
              self.PreLoader = false;
            }, 500);
            sunidhi.logoutBtnDisp = false;
            router.push({ name: "SessionTimeout" });
          }

          if (data.PWAUserSessionStatus === "Active") {
            if (data && data.message) {
              self.otpMessageE = data.message.OTPDeliveryStatusMessage;
              this.DisableInitOTPProceedBtn = true;
            }
          }

          if (!self.isModalVisible) {
            console.log("DONE");
            self.openModal();
          }
        } catch (error) {
          if(error === 'Duplicate session'){
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          }
          console.log("Failed to send OTP");
          self.otpTimerMail = "";
          console.error("Error:", error);
        }
      },

      async verifyOtp(mobileNo, emailId, mobOtp, self) {
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        this.PreLoader = true;
        var vaerror = 0;
        if (!self.emailSuccess) {
          // var url = externalURL+"ValidateOTP/?PWAUserSessionId=" + genzdata[0].PWAUserSessionId;
          var url = externalURL + "ValidateOTP/";
          var formJsonEmail = {
            OTPNumber: mobOtp,
            MailToAddress: emailId,
            SMSToAddress: mobileNo,
            OTPSource: "REGOTP",
            // PWAUserSessionId: genzdata[0].PWAUserSessionId,
            PWAUserSessionId: getSessionId(),
            'DSAUserId': genzdata[0].DSAUserId,
            UserID: genzdata[0].token,
          };
          try {
            const response = await axios.post(url, formJsonEmail, {
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "Access-Control-Allow-Origin": "*",
                // "Access-Control-Allow-Methods": "GET,POST",
                // "Access-Control-Allow-Headers":
                //   "Origin, X-Requested-With, Content-Type, Accept",
              },
            });

            const data = response.data;

            if (data.PWAUserSessionStatus === "expired") {
              setTimeout(() => {
                self.PreLoader = false;
              }, 500);
              sunidhi.logoutBtnDisp = false;
              router.push({ name: "SessionTimeout" });
            }

            if (data.PWAUserSessionStatus === "Active") {
              if (data.message) {
                if (data.message.OTPVerificationStatus === "70") {
                  self.emailSuccess = true;
                  sunidhi.logoutBtnDisp = true;
                  // router.push({ name: "liveness_landingPage", params: { userid: self.userid } });
                  router.push({ name: "liveness_landingPage" });

                  return true;
                } else {
                  this.mailOtpCount++;
                  if (this.mailOtpCount < 2) {
                    self.otpMailerrormsg = data.message.OTPVerificationMessage;
                    sunidhi.emailOtp11 = "";
                    sunidhi.emailOtp12 = "";
                    sunidhi.emailOtp13 = "";
                    sunidhi.emailOtp14 = "";
                    sunidhi.emailOtp15 = "";
                    sunidhi.emailOtp16 = "";
                    vaerror = 1;
                    self.otpEmail = true;
                    this.isDisableInitOTPProceedBtn = true;

                    setTimeout(() => {
                      this.PreLoader = false;
                    }, 500);
                    return false;
                  } else if (this.mailOtpCount === 2) {
                    self.otpMailerrormsg =
                      "Incorrect OTP entered. Remaining 1 attempt left";
                    sunidhi.emailOtp11 = "";
                    sunidhi.emailOtp12 = "";
                    sunidhi.emailOtp13 = "";
                    sunidhi.emailOtp14 = "";
                    sunidhi.emailOtp15 = "";
                    sunidhi.emailOtp16 = "";
                    self.otpEmail = true;
                    this.isDisableInitOTPProceedBtn = true;
                  } else if (this.mailOtpCount > 2) {
                    sunidhi.logoutBtnDisp = true;
                    alert(
                      "You have reached maximum invalid attempts. Please re-enter the details again."
                    );
                    router.push({ name: "menuSelection" });
                    // window.location.reload(true);
                  }
                }
              }

              setTimeout(() => {
                this.PreLoader = false;
              }, 500);
            }
          } catch (error) {
            console.log("error:", error);
          }
        }

        if (self.emailSuccess) {
          setTimeout(() => {
            this.PreLoader = false;
          }, 500);
          // this.logoutBtnDisp = 'true';
          // console.log("enterliveness");
          // // router.push({ name: "liveness_landingPage", params: { userid: self.userid } });
          // router.push({ name: "liveness_landingPage" });
        }
      },

      SyncDB(type) {
        var messageChannel = new MessageChannel();

        messageChannel.port1.onmessage = function (event) {
          if (event.data.error) {
            // reject(event.data.error);
          } else {
            //resolve(event.data);
            //   ;
            app.$router.app.$emit("syncdone", { a: 1 });
            console.log(event.data);
          }
        };

        // Send message to service worker along with port for reply
        //navigator.serviceWorker.controller.postMessage("Client 1 says '" + msg + "'", [msg_chan.port2]);

        //messageChannel.port1.addEventListener('message', replyHandler);
        navigator.serviceWorker.controller.postMessage(
          { callfn: "sync-" + type },
          [messageChannel.port2]
        );
        //function replyHandler(event) {
        //    console.log(event.data); // this comes from the ServiceWorker
        //}
      },

      S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      },

      //  getGuid() {
      //     var guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
      //     return guid;
      // },

      IDGenerator() {
        this.length = 12;
        this.timestamp = +new Date();

        var _getRandomInt = function (min, max) {
          return Math.floor(Math.random() * (max - min + 1)) + min;
        };
        var ts = this.timestamp.toString();
        var parts = ts.split("").reverse();
        var id = "";

        for (var i = 0; i < this.length; ++i) {
          var index = _getRandomInt(0, parts.length - 1);
          id += parts[index];
        }

        return id;
      },

      // async SyncFromServer(syncDone) {

      //     try {

      //         var serverId = 0;
      //         var val = 0;

      //         var data = await db.User.where("IsLoggedIn").equals(1).toArray();
      //         if (data != null && data.length > 0) {
      //             val = data[0].UserId;
      //         }
      //         await db.AppSettings.where("UserId").equals(parseInt(val)).each(friend => serverId = friend.ServerPKID > serverId ? friend.ServerPKID : serverId);
      //         var url = 'MobileWebService/SyncFromServer?userId=' + (val != null ? Number(val) : 0) + '&serverId=' + serverId;
      //         let response;
      //         var AppSettings = await db.AppSettings.toArray();
      //         if (AppSettings.length == 0) {
      //             response = await fetch(url, {
      //                 method: 'GET'
      //             });
      //         }
      //         let result;
      //         if (response != null) {

      //             result = await response.json();

      //         }
      //         if (result != null && result.ItemList[0] != null && result.ItemList[0].length > 0) {
      //             await db.AppSettings.put({ ServerPKID: result.ItemList[0][result.ItemList[0].length - 1].SyncDBId, LocalSyncDateTime: new Date(), ClientPKID: "", UserId: val });
      //             db.TbSurvey.bulkPut(result.ItemList[0]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {

      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[1] != null && result.ItemList[1].length > 0) {
      //             db.TbSurveyQuestions.bulkPut(result.ItemList[1]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[2] != null && result.ItemList[2].length > 0) {
      //             db.TbQuestionOptions.bulkPut(result.ItemList[2]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[3] != null && result.ItemList[3].length > 0) {
      //             db.TbSurveySection.bulkPut(result.ItemList[3]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[4] != null && result.ItemList[4].length > 0) {
      //             db.TbNotifications.bulkPut(result.ItemList[4]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[5] != null && result.ItemList[5].length > 0) {
      //             db.TbMasterTable.bulkPut(result.ItemList[5]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }
      //         if (result != null && result.ItemList[6] != null && result.ItemList[6].length > 0) {
      //             db.TbAnswers.bulkPut(result.ItemList[6]).then(function (lastKey) {
      //                 console.log("Last data's id was: " + lastKey);
      //             }).catch(Dexie.BulkError, function (e) {
      //                 console.error("Some data did not succeed. However, " +
      //                     actTable.length - e.failures.length + " data was added successfully");
      //             });
      //         }

      //         var surveyId = [];
      //         var Answers = [];
      //         var FormAnswers = [];
      //         var FormAnswersList = [];
      //         await db.TbSurvey.each(item => surveyId.push(item.SurveyID));
      //         var TbAnswers = await db.TbAnswers.toArray();
      //         if (TbAnswers.length > 0) {
      //             if (surveyId.length > 0) {
      //                 for (const id of surveyId) {
      //                     var ans = TbAnswers.filter(x => x.SurveyID == id);
      //                     ans.length > 0 ? Answers.push(ans) : ans;
      //                 }
      //             }
      //             Answers.forEach(function (val, i) {
      //                 FormAnswers[i] = val.filter(x => x.FormID != 0)
      //             })
      //             for (const ans of FormAnswers) {
      //                 FormAnswersList.push([...new Map(ans.map(item => [item.FormID, item])).values()]);
      //             }
      //             if (FormAnswersList.length > 0) {
      //                 for (const list of FormAnswersList) {
      //                     if (list.length > 0) {
      //                         for (var x = 0; x < list.length; x++) {
      //                             var form = await db.TbSurveyForm.where("FormID").equals(list[x].FormID).toArray();
      //                             if (form.length == 0) {
      //                                 var pkId = await db.TbSurveyForm.put({ FormID: list[x].FormID, Name: list[x].FormName, SurveyID: list[x].SurveyID, CreatedDate: list[x].FormCreatedDate, CreatedBy: list[x].FormCreatedby, IsActive: true, IsSubmitted: true, IsSaved: false, UserID: list[x].UserID });
      //                             }
      //                         }
      //                     }
      //                 }
      //             }
      //             var EntryAnswers = [];
      //             Answers.forEach(function (val, i) {
      //                 EntryAnswers[i] = val.filter(x => x.EntryId != 0)
      //             })
      //             var EntryAnswersList = [];
      //             for (const ans of EntryAnswers) {
      //                 EntryAnswersList.push([...new Map(ans.map(item => [item.EntryId, item])).values()]);
      //             }

      //             if (EntryAnswersList.length > 0) {
      //                 for (const list of EntryAnswersList) {
      //                     if (list.length > 0) {
      //                         for (var x = 0; x < list.length; x++) {
      //                             var entry = await db.TbSurveyFormEntry.where("EntryId").equals(list[x].EntryId).toArray();
      //                             if (entry.length == 0) {
      //                                 var pkId = await db.TbSurveyFormEntry.put({ EntryId: list[x].EntryId, EntryName: list[x].EntryName, FormId: list[x].FormID, CreatedDate: list[x].EntryCreatedDate, CreatedBy: list[x].EntryCreatedBy, IsActive: true, IsSubmitted: true, IsSaved: false, UserID: list[x].UserID, SurveyID: list[x].SurveyID });
      //                             }
      //                         }
      //                     }
      //                 }
      //             }

      //         }
      //         var ansarr = TbAnswers.filter(function (x) {
      //             return x.QuestionType == "Image" || x.QuestionType == "CaptureImage" || x.QuestionType == "ProofOfResidence" || x.QuestionType == "ProofOfUtilityBill" || x.QuestionType == "ProofForSourceOfFunds" || x.QuestionType == "Audio" || x.QuestionType == "Sign";
      //         });

      //         for (itm of ansarr) {
      //             var blob = new Array();
      //             if (itm.files.length > 0) {

      //                 for (files of itm.files) {
      //                     //blob = new Array();
      //                     blob.push(dataURLToBlob(files, itm.ContentType));
      //                 }
      //             }
      //             await db.TbAnswers.where("QuestionID").equals(itm.QuestionID).modify({ Blob: blob });
      //         }
      //     }
      //     catch (error) {
      //         syncDone();
      //         throw error;
      //     }
      //     syncDone();
      // },

      async SyncToServer() {
        console.log("Sync To Server called.");
        return new Promise((resolve, reject) => {
          db.User.where("IsLoggedIn")
            .equals(1)
            .toArray()
            .then((User) => {
              // Ensure `this` refers to the correct context
              this.submitgenz(User[0].UserId);
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },

      async GetClientJSONData(SyncQueuePKID) {
        var updateData = await db.ClientSyncQueue.where("SyncQueuePKID")
          .equals(SyncQueuePKID)
          .toArray();
        var JSonDataCollection = "";

        if (updateData != null && updateData.length > 0) {
          JSonDataCollection = await db.TbSurvey.where("ClientPKID")
            .equals(updateData[0].ClientPKID)
            .toArray();
        }

        return JSonDataCollection;
      },

      bytestosize(bytes) {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes == 0) return "0 Byte";
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
      },

      async FileCompress(e, width) {
        const fileName = e.name;
        const reader = new FileReader();
        reader.readAsDataURL(e);
        return new Promise(function (resolve, reject) {
          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
              const elem = document.createElement("canvas");
              const scaleFactor = width / img.width;
              elem.width = width;
              elem.height = img.height * scaleFactor;
              //To make white background ,by default it becomes black
              var ctx = elem.getContext("2d");
              ctx.fillStyle = "#FFF";
              ctx.fillRect(0, 0, elem.width, elem.height);
              // img.width and img.height will contain the original dimensions
              ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
              ctx.canvas.toBlob(
                (blob) => {
                  const file = new File([blob], fileName, {
                    type: "image/jpeg",
                    lastModified: Date.now(),
                  });
                  resolve(blob);
                },
                "image/jpeg",
                1
              );
            };
          };
        });
      },

      download(dataURL, filename) {
        if (
          navigator.userAgent.indexOf("Safari") > -1 &&
          navigator.userAgent.indexOf("Chrome") === -1
        ) {
          window.open(dataURL);
        } else {
          var blob = this.dataURLToBlob(dataURL);
          var url = window.URL.createObjectURL(blob);

          var a = document.createElement("a");
          a.style = "display: none";
          a.href = url;
          a.download = filename;

          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
        }
      },

      dataURLToBlob(dataURL) {
        if (dataURL.includes(";base64,")) {
          var parts = dataURL.split(";base64,");

          var contentType = parts[0].split(":")[1];
          var raw = window.atob(parts[1]);
        } else {
          var parts1 = dataURL;
          // contentType = _ContentType;
          raw = atob(parts1);
        }
        var rawLength = raw.length;
        var uInt8Array = new Uint8Array(rawLength);

        for (var i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
      },

      async generateCaptchaImg() {
        var self = this;

        var url = externalURL + "/generate_captcha/";

        try {
          await $.ajax({
            url: url,
            type: "POST",
            processData: false,
            contentType: false,

            success: async function (data) {
              if (data) {
                //    catchaData =data;
                console.log("captcha", data);
                // const userEncryptedText = await encryptValue(catchaData, 1234);
                this.catchaData = data.captcha_status;
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
          return this.catchaData;
        } catch (error) {
          console.log("error");
        }
      },

     async insertofflinedata(UserId) {
        // debugger
        // var data = await db.TbSurvey.where("ClientPKID").anyOf(1).toArray();
        var data = await db.TbSurvey.where("ClientPKID").anyOf(1).toArray();

        if (data == null || data.length == 0 || data == 1) {
          await this.getLookUpValues();
          await this.addTboptionValues();

          var vasurveyid = await db.TbSurvey.put({
            ClientPKID: 1,
            SurveyID: 1,
            SurveyName: "Full KYC account ",
            CreatedDate: new Date(),
            UserId: UserId,
            IsSubmitted: 0,
            IsSaved: 0,
          });

          var vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 1,
            Name: "Basic Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 1,
            ParentSectionId: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 1,
            QuestionName: "Account Type",
            QuestionText: "Account Type",
            QuestionType: "Dropdown",
            QuestionOrder: 1,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Account Type",
            IsMandatory: 1,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //         QuestionID: 2, QuestionName: "Account Class",QuestionText: "Account Class(test)", QuestionType: "Dropdown", QuestionOrder: 2, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the country", IsMandatory: 1, TotCount: 2
          //     });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 2,
            QuestionName: "Account Class",
            QuestionText: "Account Class(Current)",
            QuestionType: "Dropdown",
            QuestionOrder: 2,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 400,
            QuestionName: "Account Class",
            QuestionText: "Account Class(Savings)",
            QuestionType: "Dropdown",
            QuestionOrder: 2,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });
          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500,
            QuestionName: "Account Class",
            QuestionText: "Account Class(Call)",
            QuestionType: "Dropdown",
            QuestionOrder: 2,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          var vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 52,
            QuestionName: "Account Currency",
            QuestionText: "Account Currency",
            QuestionType: "Dropdown",
            QuestionOrder: 52,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            Disabled: false,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 3,
            QuestionName: "Customer Category",
            QuestionText: "Customer Category",
            QuestionType: "Text",
            QuestionOrder: 3,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 4,
            QuestionName: "Branch Name",
            QuestionText: "Branch Name",
            QuestionType: "Text",
            QuestionOrder: 4,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 5,
            QuestionName: "Branch Code",
            QuestionType: "Text",
            QuestionText: "Branch Code",
            QuestionOrder: 5,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 6,
            QuestionName: "Application Date",
            QuestionText: "Application Date",
            QuestionType: "Text",
            QuestionOrder: 6,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            TotCount: 2,
          });

          // ------SECTION 2-------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 2,
            Name: "Personal Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 2,
            ParentSectionId: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 7,
            QuestionName: "Are you a Resident/Non-Resident of Botswana",
            QuestionText: "Are you a Resident/Non-Resident of Botswana",
            QuestionType: "Radio",
            QuestionOrder: 7,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Resident Status",
            IsMandatory: 1,
            TotCount: 6,
          });
          var options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a Resident/Non-Resident of Botswana",
            OptionValue: "Resident",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 3,
              OptionValue: "Resident",
              OptionText: "Resident",
              SurveyID: vasurveyid,
              QuestionID: "Are you a Resident/Non-Resident of Botswana",
              QuestionType: "CheckBox",
            });
          }
          options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a Resident/Non-Resident of Botswana",
            OptionValue: "Non-Resident",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 4,
              OptionValue: "Non-Resident",
              OptionText: "Non-Resident",
              SurveyID: vasurveyid,
              QuestionID: "Are you a Resident/Non-Resident of Botswana",
              QuestionType: "CheckBox",
            });
          }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 8,
            QuestionName: "Title",
            QuestionText: "Title",
            QuestionType: "Dropdown",
            QuestionOrder: 8,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Title",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 9,
            QuestionName: "Gender",
            QuestionText: "Gender",
            QuestionType: "Dropdown",
            QuestionOrder: 9,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Gender",
            IsMandatory: 1,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 10, QuestionName: "First Name", QuestionType: "Text", QuestionOrder: 10, SurveyID: vasurveyid, SectionId: vasurveysectionid,validationType:"onlySpaceAlphabet", IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the First Name",TextLength:30, IsMandatory: 1, TotCount: 2
          // });

          await db.TbSurveyQuestions.put({
            QuestionID: 10,
            QuestionName: "First Name",
            QuestionText: "First Name",
            QuestionType: "Text",
            QuestionOrder: 10,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the First Name",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });
          await db.TbSurveyQuestions.put({
            QuestionID: 11,
            QuestionName: "Middle Name",
            QuestionText: "Middle Name",
            QuestionType: "Text",
            QuestionOrder: 11,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Middle Name",
            TextLength: 30,
            IsMandatory: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 12,
            QuestionName: "Surname",
            QuestionText: "Surname",
            QuestionType: "Text",
            QuestionOrder: 12,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Surname",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 13,
            QuestionName: "Date of Birth",
            QuestionText: "Date of Birth",
            QuestionType: "Date",
            QuestionOrder: 13,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 1,
            Disabled: false,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 14,
            QuestionName: "Place of Birth",
            QuestionText: "Place of Birth",
            QuestionType: "Text",
            QuestionOrder: 14,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Place of Birth",
            TextLength: 15,
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 15,
            QuestionName: "Country of Birth",
            QuestionText: "Country of Birth",
            QuestionType: "Dropdown",
            QuestionOrder: 15,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 16,
            QuestionName: "Nationality",
            QuestionText: "Nationality",
            QuestionType: "Dropdown",
            QuestionOrder: 16,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });
          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 1006,
            QuestionName: "National ID Issue Country",
            QuestionText: "National ID Issue Country",
            QuestionType: "Dropdown",
            QuestionOrder: 1006,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 17,
            QuestionName: "National ID Number",
            QuestionText: "National ID Number",
            QuestionType: "Text",
            QuestionOrder: 17,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "AlphaNumeric",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the National ID number",
            IsMandatory: 1,
            TextLength: 9,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 18,
            QuestionName: "National ID Expiry Date",
            QuestionText: "National ID Expiry Date",
            QuestionType: "ExpiryDate",
            QuestionOrder: 18,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 1,
            Disabled: false,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 23,
            QuestionName: "Marital Status",
            QuestionText: "Marital Status",
            QuestionType: "Dropdown",
            QuestionOrder: 23,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });
//  vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  8888,
//             QuestionName: "MIS Class",
//             QuestionText: "MIS Class",
//             QuestionType: "Dropdown",
//             QuestionOrder: 8888,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Class",
//             IsMandatory: 1,
//             TotCount: 2,
//           });
//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 8881,
//             QuestionName: "MIS Code",
//             QuestionText: "MIS Code",
//             QuestionType: "Text",
//             QuestionOrder: 8881,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Enter the MIS Code", //sales Origin
//             TextLength: 30,
//             IsMandatory: 1,
//             TotCount: 2,
//           });

// geetha code 
await db.TbSurveyQuestions.put({
            QuestionID: 11114,
            QuestionName: "MIS Details",
            QuestionText: "MIS Details",
            QuestionLabel: "MIS Details",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });
 vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500000,
            QuestionName: "PORTFOLIO",
            QuestionText: "PORTFOLIO",
            QuestionType: "CheckBox",
            QuestionOrder: 500000,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "PORTFOLIO",
            OptionValue: "PORTFOLIO",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500000,
              OptionValue: "PORTFOLIO",
              OptionText: "PORTFOLIO",
              SurveyID: vasurveyid,
              QuestionID: "PORTFOLIO",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  400001,
            QuestionName: "MIS_Code_PORTFOLIO",
            QuestionText: "MIS_Code_PORTFOLIO",
            QuestionType: "Dropdown",
            QuestionOrder: 400001,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });
            
         
          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500001,
            QuestionName: "CHANNELAQ",
            QuestionText: "CHANNELAQ",
            QuestionType: "CheckBox",
            QuestionOrder: 500001,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "CHANNELAQ",
            OptionValue: "CHANNELAQ",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500001,
              OptionValue: "CHANNELAQ",
              OptionText: "CHANNELAQ",
              SurveyID: vasurveyid,
              QuestionID: "CHANNELAQ",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500002,
            QuestionName: "MIS_Code_CHANNELAQ",
            QuestionText: "MIS_Code_CHANNELAQ",
            QuestionType: "Dropdown",
            QuestionOrder: 500002,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500003,
            QuestionName: "INDUSTRY",
            QuestionText: "INDUSTRY",
            QuestionType: "CheckBox",
            QuestionOrder: 500003,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "INDUSTRY",
            OptionValue: "INDUSTRY",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500003,
              OptionValue: "INDUSTRY",
              OptionText: "INDUSTRY",
              SurveyID: vasurveyid,
              QuestionID: "INDUSTRY",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500004,
            QuestionName: "MIS_Code_INDUSTRY",
            QuestionText: "MIS_Code_INDUSTRY",
            QuestionType: "Dropdown",
            QuestionOrder: 500004,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500005,
            QuestionName: "KYC",
            QuestionText: "KYC",
            QuestionType: "CheckBox",
            QuestionOrder: 500005,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "KYC",
            OptionValue: "KYC",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500005,
              OptionValue: "KYC",
              OptionText: "KYC",
              SurveyID: vasurveyid,
              QuestionID: "KYC",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500006,
            QuestionName: "MIS_Code_KYC",
            QuestionText: "MIS_Code_KYC",
            QuestionType: "Dropdown",
            QuestionOrder: 500006,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500007,
            QuestionName: "LEGSTAT",
            QuestionText: "LEGSTAT",
            QuestionType: "CheckBox",
            QuestionOrder: 500007,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "LEGSTAT",
            OptionValue: "LEGSTAT",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500007,
              OptionValue: "LEGSTAT",
              OptionText: "LEGSTAT",
              SurveyID: vasurveyid,
              QuestionID: "LEGSTAT",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500008,
            QuestionName: "MIS_Code_LEGSTAT",
            QuestionText: "MIS_Code_LEGSTAT",
            QuestionType: "Dropdown",
            QuestionOrder: 500008,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500009,
            QuestionName: "REFERRALS",
            QuestionText: "REFERRALS",
            QuestionType: "CheckBox",
            QuestionOrder: 500009,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "REFERRALS",
            OptionValue: "REFERRALS",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500009,
              OptionValue: "REFERRALS",
              OptionText: "REFERRALS",
              SurveyID: vasurveyid,
              QuestionID: "REFERRALS",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500010,
            QuestionName: "MIS_Code_REFERRALS",
            QuestionText: "MIS_Code_REFERRALS",
            QuestionType: "Dropdown",
            QuestionOrder: 500010,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500011,
            QuestionName: "RESSTATUS",
            QuestionText: "RESSTATUS",
            QuestionType: "CheckBox",
            QuestionOrder: 500011,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "RESSTATUS",
            OptionValue: "RESSTATUS",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500011,
              OptionValue: "RESSTATUS",
              OptionText: "RESSTATUS",
              SurveyID: vasurveyid,
              QuestionID: "RESSTATUS",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500012,
            QuestionName: "MIS_Code_RESSTATUS",
            QuestionText: "MIS_Code_RESSTATUS",
            QuestionType: "Dropdown",
            QuestionOrder: 500012,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500013,
            QuestionName: "SALES_ORI",
            QuestionText: "SALES_ORI",
            QuestionType: "CheckBox",
            QuestionOrder: 500013,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SALES_ORI",
            OptionValue: "SALES_ORI",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500013,
              OptionValue: "SALES_ORI",
              OptionText: "SALES_ORI",
              SurveyID: vasurveyid,
              QuestionID: "SALES_ORI",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500014,
            QuestionName: "MIS_Code_SALES_ORI",
            QuestionText: "MIS_Code_SALES_ORI",
            QuestionType: "Text",
            QuestionOrder: 500014,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TextLength: 30,
            TotCount: 2,
          });


           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500015,
            QuestionName: "SEGMENT",
            QuestionText: "SEGMENT",
            QuestionType: "CheckBox",
            QuestionOrder: 500015,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SEGMENT",
            OptionValue: "SEGMENT",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500015,
              OptionValue: "SEGMENT",
              OptionText: "SEGMENT",
              SurveyID: vasurveyid,
              QuestionID: "SEGMENT",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500016,
            QuestionName: "MIS_Code_SEGMENT",
            QuestionText: "MIS_Code_SEGMENT",
            QuestionType: "Dropdown",
            QuestionOrder: 500016,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 500017,
            QuestionName: "SEGMENT_C",
            QuestionText: "SEGMENT_C",
            QuestionType: "CheckBox",
            QuestionOrder: 500017,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SEGMENT_C",
            OptionValue: "SEGMENT_C",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 500017,
              OptionValue: "SEGMENT_C",
              OptionText: "SEGMENT_C",
              SurveyID: vasurveyid,
              QuestionID: "SEGMENT_C",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  500018,
            QuestionName: "MIS_Code_SEGMENT_C",
            QuestionText: "MIS_Code_SEGMENT_C",
            QuestionType: "Dropdown",
            QuestionOrder: 500018,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

         

          // vaquestionid = await db.TbSurveyQuestions.put({
          //   QuestionID: 8882,
          //   QuestionName: "Segment Name",
          //   QuestionText: "Segment Name",
          //   QuestionType: "Dropdown",
          //   QuestionOrder: 8882,
          //   SurveyID: vasurveyid,
          //   SectionId: vasurveysectionid,
          //   IsConditionQuestion: 0,
          //   ConditionValue1: null,
          //   IsRepeatSection: 0,
          //   IsFormulaQuestion: 0,
          //   IsSearchable: 1,
          //   ErrorText: "Select the Segment Name",
          //   IsMandatory: 1,
          //   TotCount: 2,
          // });

          await db.TbSurveyQuestions.put({
            QuestionID: 19,
            QuestionName: "Passport Number",
            QuestionText: "Passport Number",
            QuestionType: "Text",
            QuestionOrder: 19,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "AlphaNumeric",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Passport number",
            IsMandatory: 0,
            TextLength: 15,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 20,
            QuestionName: "Passport Issue Date",
            QuestionText: "Passport Issue Date",
            QuestionType: "IssuanceDate",
            QuestionOrder: 20,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 21,
            QuestionName: "Passport Expiry Date",
            QuestionText: "Passport Expiry Date",
            QuestionType: "ExpiryDate",
            QuestionOrder: 21,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 22,
            QuestionName: "Passport Issue Country",
            QuestionText: "Passport Issue Country",
            QuestionType: "Dropdown",
            QuestionOrder: 22,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 24, QuestionName: "Name of Spouse", QuestionText: "Name of Spouse",QuestionType: "Text", QuestionOrder: 24, SurveyID: vasurveyid, SectionId: vasurveysectionid,validationType:"onlySpaceAlphabet", IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the spouse name", IsMandatory: 0,TextLength:30, TotCount: 2
          // });

          // var vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 25, QuestionName: "Spouse Employment Status",QuestionText: "Spouse Employment Status", QuestionType: "Dropdown", QuestionOrder: 25, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the country", IsMandatory: 0, TotCount: 2
          // });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 26 , QuestionName: "Spouse Mobile Number[Country code]",QuestionLabel: "Spouse Mobile Number", QuestionText:"ISDCodes",QuestionType: "Dropdown", QuestionOrder: 26, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number", IsMandatory: 0, TotCount: 2
          // });

          //  await db.TbSurveyQuestions.put({
          //     QuestionID: 27, QuestionName: "Spouse Mobile Number",QuestionText: "ISDCode", QuestionType: "Number", QuestionOrder: 27, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number",TextLength:15, IsMandatory: 0, TotCount: 2
          // });

          // ------SECTION 3-------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 3,
            Name: "Contact Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 3,
            ParentSectionId: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 28,
            QuestionName: "Email ID",
            QuestionText: "Email ID",
            QuestionType: "Text",
            QuestionOrder: 28,
            validationType: "onlyEmailId",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 0,
            ErrorText: "Enter valid Email ID",
            TextLength: 50,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });
          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 29 , QuestionName: "Landline Number[Country code]",QuestionLabel: "Landline Number", QuestionText:"ISDCodes",QuestionType: "Dropdown", QuestionOrder: 29, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number", IsMandatory: 0, TotCount: 2
          // });
          // await db.TbSurveyQuestions.put({
          //     QuestionID: 30, QuestionName: "Landline Number", QuestionType: "Number", QuestionText:"ISDCode", QuestionOrder: 30, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number",TextLength:15, IsMandatory: 0, TotCount: 2
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 31,
            QuestionName: "Primary Mobile Number[Country code]",
            QuestionLabel: "Primary Mobile Number",
            QuestionText: "ISDCodes",
            QuestionType: "Dropdown",
            QuestionOrder: 31,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter Mobile number",
            IsMandatory: 1,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 32,
            QuestionName: "Primary Mobile Number",
            QuestionType: "Number",
            QuestionText: "ISDCode",
            QuestionOrder: 32,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter Mobile number",
            TextLength: 15,
            IsMandatory: 1,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 600,
            QuestionName: "Physical Address",
            QuestionLabel: "Physical Address",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 33,
            QuestionName: "Plot Number",
            QuestionType: "Number",
            QuestionText: "House Number and Street(Current)",
            QuestionOrder: 33,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the House Number",
            TextLength: 15,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 34,
            QuestionName: "Area Town",
            QuestionType: "Text",
            QuestionText: "Area Town(Current)",
            QuestionOrder: 34,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Street Name",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 35,
            QuestionName: "Nearest City",
            QuestionText: "Nearest City",
            QuestionType: "Dropdown",
            QuestionOrder: 35,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 36,
            QuestionName: "City",
            QuestionText: "City(Current)",
            QuestionType: "Text",
            validationType: "onlySpaceAlphabet",
            QuestionOrder: 36,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the city",
            TextLength: 20,
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 37,
            QuestionName: "District",
            QuestionText: "State(Current)",
            QuestionType: "Dropdown",
            QuestionOrder: 37,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 38,
            QuestionName: "Country",
            QuestionText: "Country(Current)",
            QuestionType: "Dropdown",
            QuestionOrder: 38,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 39,
            QuestionName: "Postal Address",
            QuestionLabel: "Postal Address",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 40, QuestionName: "Is Permanent Address same as Current Address?", QuestionText:"Is Permanent Address same as Current Address?",QuestionType: "CheckBox", QuestionOrder: 40, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, IsMandatory: 0, TotCount: 6
          //  });
          //  options = await db.TbQuestionOptions.where({QuestionID: "Is Permanent Address same as Current Address?", OptionValue: 'No'}).toArray();
          //  if (options == null || options.length == 0) {
          //  await db.TbQuestionOptions.put({ OptionID: 200, OptionValue: "No", OptionText: "", SurveyID: vasurveyid, QuestionID: "Is Permanent Address same as Current Address?", QuestionType: "CheckBox" });
          //  }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 40,
            QuestionName: "Is Physical Address same as Postal Address?",
            QuestionText: "Is Physical Address same as Postal Address?",
            QuestionType: "CheckBox",
            QuestionOrder: 40,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "Is Physical Address same as Postal Address?",
            OptionValue: "yes",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 200,
              OptionValue: "yes",
              OptionText: "",
              SurveyID: vasurveyid,
              QuestionID: "Is Physical Address same as Postal Address?",
              QuestionType: "CheckBox",
            });
          }

          await db.TbSurveyQuestions.put({
            QuestionID: 41,
            QuestionName: "Plot Number",
            QuestionType: "Number",
            QuestionText: "House Number and Street(Permanent)",
            QuestionOrder: 41,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the House Number",
            TextLength: 15,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 42,
            QuestionName: "Area Town",
            QuestionType: "Text",
            QuestionText: "Area Town(Permanent)",
            QuestionOrder: 42,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Street Name",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 43,
            QuestionName: "City",
            QuestionText: "City(Permanent)",
            QuestionType: "Text",
            validationType: "onlySpaceAlphabet",
            QuestionOrder: 43,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the city",
            IsMandatory: 1,
            TextLength: 20,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 44,
            QuestionName: "District",
            QuestionText: "State(Permanent)",
            QuestionType: "Dropdown",
            QuestionOrder: 44,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the Province/District",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 45,
            QuestionName: "Country",
            QuestionText: "Country(Permanent)",
            QuestionType: "Dropdown",
            QuestionOrder: 45,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          // ------SECTION 4-------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 4,
            Name: "Employment Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 4,
            ParentSectionId: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 46,
            QuestionName: "Employer's Name",
            QuestionText: "Employer's Name",
            QuestionType: "Text",
            QuestionOrder: 46,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Employers Name",
            IsMandatory: 1,
            TextLength: 30,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 47,
            QuestionName: "Occupation",
            QuestionText: "Occupation",
            QuestionType: "Dropdown",
            QuestionOrder: 47,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the city/town/village",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 48,
            QuestionName: "Nature of Employment",
            QuestionText: "Nature of Employment",
            QuestionType: "Dropdown",
            QuestionOrder: 48,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the city/town/village",
            IsMandatory: 1,
            TotCount: 2,
          });

          

          // ------SECTION 5-------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 5,
            Name: "FACTA",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 5,
            ParentSectionId: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 49,
            QuestionName: "Are you a US Citizen or US Resident?",
            QuestionText: "Are you a US Citizen or US Resident?",
            QuestionType: "Radio",
            QuestionOrder: 49,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Employer /Business type",
            IsMandatory: 0,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a US Citizen or US Resident?",
            OptionValue: "Yes",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 50,
              OptionValue: "Yes",
              OptionText: "Yes",
              SurveyID: vasurveyid,
              QuestionID: "Are you a US Citizen or US Resident?",
              QuestionType: "CheckBox",
            });
          }
          options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a US Citizen or US Resident?",
            OptionValue: "No",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 51,
              OptionValue: "No",
              OptionText: "No",
              SurveyID: vasurveyid,
              QuestionID: "Are you a US Citizen or US Resident?",
              QuestionType: "CheckBox",
            });
          }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 50,
            QuestionName:
              "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
            QuestionText:
              "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
            QuestionType: "Radio",
            QuestionOrder: 50,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Employer /Business type",
            IsMandatory: 0,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID:
              "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
            OptionValue: "Yes",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 52,
              OptionValue: "Yes",
              OptionText: "Yes",
              SurveyID: vasurveyid,
              QuestionID:
                "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
              QuestionType: "CheckBox",
            });
          }
          options = await db.TbQuestionOptions.where({
            QuestionID:
              "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
            OptionValue: "No",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 53,
              OptionValue: "No",
              OptionText: "No",
              SurveyID: vasurveyid,
              QuestionID:
                "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",
              QuestionType: "CheckBox",
            });
          }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 51,
            QuestionName: "Have you Visited U.S in the past 3 years?",
            QuestionText: "Have you Visited U.S in the past 3 years?",
            QuestionType: "Radio",
            QuestionOrder: 51,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Employer /Business type",
            IsMandatory: 0,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "Have you Visited U.S in the past 3 years?",
            OptionValue: "Yes",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 54,
              OptionValue: "Yes",
              OptionText: "Yes",
              SurveyID: vasurveyid,
              QuestionID: "Have you Visited U.S in the past 3 years?",
              QuestionType: "CheckBox",
            });
          }
          options = await db.TbQuestionOptions.where({
            QuestionID: "Have you Visited U.S in the past 3 years?",
            OptionValue: "No",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 55,
              OptionValue: "No",
              OptionText: "No",
              SurveyID: vasurveyid,
              QuestionID: "Have you Visited U.S in the past 3 years?",
              QuestionType: "CheckBox",
            });
          }

          // ------SECTION 6-------

          //  var vasurveysectionid = await db.TbSurveySection.put({ SectionId: 6, Name: "Account Details", CreatedDate: new Date(), UpdatedDate: new Date(), CreatedBy: UserId, UpdatedBy: UserId, IsActive: 1, SurveyId: vasurveyid, SectionOrder: 6, ParentSectionId: 0, TotCount: 2 });
          // geetha code 
//           vasurveysectionid = await db.TbSurveySection.put({
//             SectionId: 6,
//             Name: "MIS Details",
//             CreatedDate: new Date(),
//             UpdatedDate: new Date(),
//             CreatedBy: UserId,
//             UpdatedBy: UserId,
//             IsActive: 1,
//             SurveyId: vasurveyid,
//             SectionOrder: 6,
//             ParentSectionId: 0,
//             TotCount: 2,
//           });

//  vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 500000,
//             QuestionName: "PORTFOLIO",
//             QuestionText: "PORTFOLIO",
//             QuestionType: "CheckBox",
//             QuestionOrder: 500001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "PORTFOLIO",
//             OptionValue: "PORTFOLIO",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 500001,
//               OptionValue: "PORTFOLIO",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "PORTFOLIO",
//               QuestionType: "CheckBox",
//             });
//           }


//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_PORTFOLIO",
//             QuestionText: "MIS_Code_PORTFOLIO",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });
            
         
//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 500001,
//             QuestionName: "CHANNELAQ",
//             QuestionText: "CHANNELAQ",
//             QuestionType: "CheckBox",
//             QuestionOrder: 500001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "CHANNELAQ",
//             OptionValue: "CHANNELAQ",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 500001,
//               OptionValue: "CHANNELAQ",
//               OptionText: "CHANNELAQ",
//               SurveyID: vasurveyid,
//               QuestionID: "CHANNELAQ",
//               QuestionType: "CheckBox",
//             });
//           }

//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_CHANNELAQ",
//             QuestionText: "MIS_Code_CHANNELAQ",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50002,
//             QuestionName: "INDUSTRY",
//             QuestionText: "INDUSTRY",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50002,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "INDUSTRY",
//             OptionValue: "INDUSTRY",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20001,
//               OptionValue: "INDUSTRY",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "INDUSTRY",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50002,
//             QuestionName: "MIS_Code_INDUSTRY",
//             QuestionText: "MIS_Code_INDUSTRY",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50002,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50003,
//             QuestionName: "KYC",
//             QuestionText: "KYC",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50003,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "KYC",
//             OptionValue: "KYC",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20002,
//               OptionValue: "KYC",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "KYC",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_KYC",
//             QuestionText: "MIS_Code_KYC",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50004,
//             QuestionName: "LEGSTAT",
//             QuestionText: "LEGSTAT",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50004,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "LEGSTAT",
//             OptionValue: "LEGSTAT",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20003,
//               OptionValue: "LEGSTAT",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "LEGSTAT",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_LEGSTAT",
//             QuestionText: "MIS_Code_LEGSTAT",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50005,
//             QuestionName: "REFERRALS",
//             QuestionText: "REFERRALS",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50005,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "REFERRALS",
//             OptionValue: "REFERRALS",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20004,
//               OptionValue: "REFERRALS",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "REFERRALS",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_REFERRALS",
//             QuestionText: "MIS_Code_REFERRALS",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50006,
//             QuestionName: "RESSTATUS",
//             QuestionText: "RESSTATUS",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50006,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "RESSTATUS",
//             OptionValue: "RESSTATUS",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20000,
//               OptionValue: "RESSTATUS",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "RESSTATUS",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_RESSTATUS",
//             QuestionText: "MIS_Code_RESSTATUS",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

//            vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 50007,
//             QuestionName: "SALES_ORI",
//             QuestionText: "SALES_ORI",
//             QuestionType: "CheckBox",
//             QuestionOrder: 50007,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select Debit",
//             IsMandatory: 0,
//             TotCount: 6,
//           });
//           options = await db.TbQuestionOptions.where({
//             QuestionID: "SALES_ORI",
//             OptionValue: "SALES_ORI",
//           }).toArray();
//           if (options == null || options.length == 0) {
//             await db.TbQuestionOptions.put({
//               OptionID: 20000,
//               OptionValue: "SALES_ORI",
//               OptionText: "",
//               SurveyID: vasurveyid,
//               QuestionID: "SALES_ORI",
//               QuestionType: "CheckBox",
//             });
//           }


//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  50001,
//             QuestionName: "MIS_Code_SALES_ORI",
//             QuestionText: "MIS_Code_SALES_ORI",
//             QuestionType: "Dropdown",
//             QuestionOrder: 50001,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Code",
//             IsMandatory: 1,
//             TotCount: 2,
//           });

          //-------SECTION 7---------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 6,
            Name: "Signature",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 6,
            ParentSectionId: 0,
            TotCount: 6,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 54,
            QuestionName: "Signature",
            QuestionText: "Signature",
            QuestionType: "Sign",
            QuestionOrder: 54,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            DefaultValue: null,
            ConditionSectionId: 0,
            ConditionType: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: null,
            FieldVar: null,
            FormulaExpression: null,
            HierarchyQuestionOrder: null,
            IsMandatory: 1,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 55, QuestionName: "Proof of Identification",QuestionText: "Proof of Identification", QuestionType: "File", QuestionOrder: 55, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Image", IsMandatory: 1, TotCount: 2
          // });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 56, QuestionName: "Proof of Residence",QuestionText: "Proof of Residence", QuestionType: "ProofOfResidence", QuestionOrder: 56, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Image", IsMandatory: 1, TotCount: 2
          // });
          await db.TbSurveyQuestions.put({
            QuestionID: 56,
            QuestionName: "Proof of Residence",
            QuestionText: "Proof of Residence",
            QuestionType: "Image",
            QuestionOrder: 56,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Image",
            IsMandatory: 1,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 57, QuestionName: "Utility Bill",QuestionText: "Utility Bill", QuestionType: "Dropdown", QuestionOrder: 57, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Account Type", IsMandatory: 1, TotCount: 2
          // });

          // await db.TbQuestionOptions.put({
          //     OptionID: 300, OptionValue: "Letter from employer", OptionText: "Letter from employer", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 301, OptionValue: "Letter from school", OptionText: "Letter from school", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 302, OptionValue: "Lease Agreement", OptionText: "Lease Agreement", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 303, OptionValue: "Affidavit from the landlord", OptionText: "Affidavit from the landlord", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 304, OptionValue: "Local Council rates invoice", OptionText: "Local Council rates invoice", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 305, OptionValue: "Access Bank staff visit", OptionText: "Access Bank staff visit", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 306, OptionValue: "Access Bank confirmation", OptionText: "Access Bank confirmation", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 307, OptionValue: "Confirmation letter by Legal practitioner", OptionText: "Confirmation letter by Legal practitioner", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 308, OptionValue: "Confirmation letter by BICA Members", OptionText: "Confirmation letter by BICA Members", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 309, OptionValue: "Address verification by Access Bank Customer", OptionText: "Address verification by Access Bank Customer", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 310, OptionValue: "Customary Authority", OptionText: "Customary Authority", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 311, OptionValue: "For married couples", OptionText: "For married couples", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });

          //   await db.TbSurveyQuestions.put({
          //     QuestionID: 58, QuestionName: "Documents for Utility Bill",QuestionText: "Documents for Utility Bill", QuestionType: "Image", QuestionOrder: 58, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Image", IsMandatory: 1, TotCount: 2
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 312,
            QuestionName: "Customer Type",
            QuestionText: "Customer Type",
            QuestionType: "Dropdown",
            QuestionOrder: 59,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 59,
            QuestionName: "Source of Funds / Income Proof",
            QuestionText: "Source of Funds(Employed)",
            QuestionType: "Dropdown",
            QuestionOrder: 60,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select an option",
            IsMandatory: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 60,
            QuestionName: "Source of Funds / Income Proof",
            QuestionText: "Source of Funds(SelfEmployed)",
            QuestionType: "Dropdown",
            QuestionOrder: 60,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select an option",
            IsMandatory: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 61,
            QuestionName: "Source of Funds / Income Proof",
            QuestionText: "Source of Funds(Pensioner)",
            QuestionType: "Dropdown",
            QuestionOrder: 60,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select an option",
            IsMandatory: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 62,
            QuestionName: "Source of Funds / Income Proof",
            QuestionText: "Source of Funds(UnEmployed)",
            QuestionType: "Dropdown",
            QuestionOrder: 60,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select an option",
            IsMandatory: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 63,
            QuestionName: "Documents for Source of Funds / Income Proof",
            QuestionText: "Documents for Source of Funds / Income Proof",
            QuestionType: "Image",
            QuestionOrder: 61,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Image",
            IsMandatory: 0,
            TotCount: 2,
          });
        }
      },

      async insertLiteKycAcctdata(UserId) {
        // debugger
        var data = await db.TbSurvey.where("ClientPKID").anyOf(2).toArray();
        if (data == null || data.length == 0) {
          await this.getLookUpValues();
          await this.addTboptionValues();

          var vasurveyid = await db.TbSurvey.put({
            ClientPKID: 2,
            SurveyID: 2,
            SurveyName: "Lite KYC Account",
            CreatedDate: new Date(),
            UserId: UserId,
            IsSubmitted: 0,
            IsSaved: 0,
          });

          // var vasurveysectionid = await db.TbSurveySection.put({ SectionId: 8, Name: "Basic Details", CreatedDate: new Date(), UpdatedDate: new Date(), CreatedBy: UserId, UpdatedBy: UserId, IsActive: 1, SurveyId: vasurveyid, SectionOrder: 1, ParentSectionId: 0, TotCount: 2 });

          // ------SECTION 9-------

          var vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 7,
            Name: "Personal Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 1,
            ParentSectionId: 0,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 96,
            QuestionName: "Are you a Resident/Non-Resident of Botswana",
            QuestionText: "Are you a Resident/Non-Resident of Botswana",
            QuestionType: "Radio",
            QuestionOrder: 96,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Employer /Business type",
            IsMandatory: 1,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a Resident/Non-Resident of Botswana",
            OptionValue: "Resident",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 3,
              OptionValue: "Resident",
              OptionText: "Resident",
              SurveyID: vasurveyid,
              QuestionID: "Are you a Resident/Non-Resident of Botswana",
              QuestionType: "CheckBox",
            });
          }
          options = await db.TbQuestionOptions.where({
            QuestionID: "Are you a Resident/Non-Resident of Botswana",
            OptionValue: "Non-Resident",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 4,
              OptionValue: "Non-Resident",
              OptionText: "Non-Resident",
              SurveyID: vasurveyid,
              QuestionID: "Are you a Resident/Non-Resident of Botswana",
              QuestionType: "CheckBox",
            });
          }

          var vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 97,
            QuestionName: "Title",
            QuestionText: "Title",
            QuestionType: "Dropdown",
            QuestionOrder: 97,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Title",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 98,
            QuestionName: "Gender",
            QuestionText: "Gender",
            QuestionType: "Dropdown",
            QuestionOrder: 98,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Gender",
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 99,
            QuestionName: "First Name",
            QuestionText: "First Name",
            QuestionType: "Text",
            QuestionOrder: 99,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the First Name",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 100,
            QuestionName: "Middle Name",
            QuestionText: "Middle Name",
            QuestionType: "Text",
            QuestionOrder: 100,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Middle Name",
            TextLength: 30,
            IsMandatory: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 101,
            QuestionName: "Surname",
            QuestionText: "Surname",
            QuestionType: "Text",
            QuestionOrder: 101,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Surname",
            TextLength: 30,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 102,
            QuestionName: "Date of Birth",
            QuestionText: "Date of Birth",
            QuestionType: "Date",
            QuestionOrder: 102,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 1,
            Disabled: false,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 103,
            QuestionName: "Place of Birth",
            QuestionText: "Place of Birth",
            QuestionType: "Text",
            QuestionOrder: 103,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "onlySpaceAlphabet",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Place of Birth",
            IsMandatory: 1,
            TextLength: 15,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 104,
            QuestionName: "Country of Birth",
            QuestionText: "Country of Birth",
            QuestionType: "Dropdown",
            QuestionOrder: 104,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 105,
            QuestionName: "Nationality",
            QuestionText: "Nationality",
            QuestionType: "Dropdown",
            QuestionOrder: 105,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 1007,
            QuestionName: "National ID Issue Country",
            QuestionText: "National ID Issue Country",
            QuestionType: "Dropdown",
            QuestionOrder: 1007,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 106,
            QuestionName: "National ID Number",
            QuestionText: "National ID Number",
            QuestionType: "Text",
            QuestionOrder: 106,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "AlphaNumeric",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the National ID number",
            IsMandatory: 1,
            TextLength: 9,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 107,
            QuestionName: "National ID Expiry Date",
            QuestionText: "National ID Expiry Date",
            QuestionType: "Date",
            QuestionOrder: 107,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 1,
            Disabled: false,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 112,
            QuestionName: "Marital Status",
            QuestionText: "Marital Status",
            QuestionType: "Dropdown",
            QuestionOrder: 112,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 114,
            QuestionName: "Customer Type",
            QuestionText: "Customer Type",
            QuestionType: "Dropdown",
            QuestionOrder: 114,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //   QuestionID: 8883,
          //   QuestionName: "Account Officer Name",
          //   QuestionText: "Account Officer Name",
          //   QuestionType: "Dropdown",
          //   QuestionOrder: 8883,
          //   SurveyID: vasurveyid,
          //   SectionId: vasurveysectionid,
          //   IsConditionQuestion: 0,
          //   ConditionValue1: null,
          //   IsRepeatSection: 0,
          //   IsFormulaQuestion: 0,
          //   IsSearchable: 1,
          //   ErrorText: "Select the Account Officer Name",
          //   IsMandatory: 1,
          //   TotCount: 2,
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 113,
            QuestionName: "Account Currency",
            QuestionText: "Account Currency",
            QuestionType: "Text",
            QuestionOrder: 113,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 108,
            QuestionName: "Passport Number",
            QuestionText: "Passport Number",
            QuestionType: "Text",
            QuestionOrder: 108,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "AlphaNumeric",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the National ID number",
            IsMandatory: 0,
            TextLength: 15,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 109,
            QuestionName: "Passport Issue Date",
            QuestionText: "Passport Issue Date",
            QuestionType: "IssuanceDate",
            QuestionOrder: 109,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 110,
            QuestionName: "Passport Expiry Date",
            QuestionText: "Passport Expiry Date",
            QuestionType: "ExpiryDate",
            QuestionOrder: 110,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select date",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 111,
            QuestionName: "Passport Issue Country",
            QuestionText: "Passport Issue Country",
            QuestionType: "Dropdown",
            QuestionOrder: 111,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 0,
            Disabled: false,
            hide: true,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 90,
            QuestionName: "Account Type",
            QuestionText: "Account Type(LiteKYCAcct)",
            QuestionType: "Text",
            QuestionOrder: 90,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Account Type",
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 91,
            QuestionName: "Account Class",
            QuestionText: "Account Class(Transactional)",
            QuestionType: "Text",
            QuestionOrder: 91,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 92,
            QuestionName: "Customer Category",
            QuestionText: "Customer Category",
            QuestionType: "Text",
            QuestionOrder: 92,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 93,
            QuestionName: "Branch Name",
            QuestionText: "Branch Name",
            QuestionType: "Text",
            QuestionOrder: 93,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 94,
            QuestionName: "Branch Code",
            QuestionText: "Branch Code",
            QuestionType: "Text",
            QuestionOrder: 94,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 95,
            QuestionName: "Application Date",
            QuestionText: "Application Date",
            QuestionType: "Text",
            QuestionOrder: 95,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 113, QuestionName: "Name of Spouse",QuestionText: "Name of Spouse", QuestionType: "Text", QuestionOrder: 113, SurveyID: vasurveyid, SectionId: vasurveysectionid,validationType:"onlySpaceAlphabet", IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the spouse name", IsMandatory: 0,Disabled:true,TextLength:30, TotCount: 2
          // });

          // var vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 114, QuestionName: "Spouse Employment Status",QuestionText: "Spouse Employment Status", QuestionType: "Dropdown", QuestionOrder: 114, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the country",Disabled:true, IsMandatory: 0, TotCount: 2
          // });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 115 , QuestionName: "Spouse Mobile Number[Country code]", QuestionText: "Spouse Mobile Number[Country code]",QuestionLabel: "Spouse Mobile Number", QuestionText:"ISDCodes",QuestionType: "Dropdown", QuestionOrder: 115, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number",Disabled:true, IsMandatory: 0, TotCount: 2
          // });

          //  await db.TbSurveyQuestions.put({
          //     QuestionID: 116, QuestionName: "Spouse Mobile Number", QuestionType: "Number", QuestionText:"ISDCode", QuestionOrder: 116, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number",TextLength:11, IsMandatory: 0,Disabled:true, TotCount: 2
          // });


          

          // ------SECTION 10-------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 8,
            Name: "Contact Details",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 2,
            ParentSectionId: 0,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 117,
            QuestionName: "Email ID",
            QuestionText: "Email ID",
            QuestionType: "Text",
            QuestionOrder: 117,
            validationType: "onlyEmailId",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 0,
            ErrorText: "Enter valid Email ID",
            TextLength: 50,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 127 , QuestionName: "Landline Number[Country code]",QuestionLabel: "Landline Number", QuestionText:"ISDCodes",QuestionType: "Dropdown", QuestionOrder: 127, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number", IsMandatory: 0, TotCount: 2
          // });
          // await db.TbSurveyQuestions.put({
          //     QuestionID: 128, QuestionName: "Landline Number", QuestionType: "Number", QuestionText:"ISDCode", QuestionOrder: 128, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Enter Mobile number",TextLength:11, IsMandatory: 0, TotCount: 2
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 129,
            QuestionName: "Primary Mobile Number[Country code]",
            QuestionLabel: "Primary Mobile Number",
            QuestionText: "ISDCodes",
            QuestionType: "Dropdown",
            QuestionOrder: 129,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter Mobile number",
            Disabled: true,
            hide: true,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 130,
            QuestionName: "Primary Mobile Number",
            QuestionType: "Number",
            QuestionText: "ISDCode",
            QuestionOrder: 130,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter Mobile number",
            TextLength: 15,
            IsMandatory: 1,
            Disabled: true,
            hide: true,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 131,
            QuestionName: "Physical Address",
            QuestionText: "Physical Address",
            QuestionLabel: "Physical Address",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 132,
            QuestionName: "Plot Number",
            QuestionType: "Number",
            QuestionText: "House Number and Street(Current)",
            QuestionOrder: 132,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Plot Number",
            IsMandatory: 1,
            TextLength: 15,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 132, QuestionName: "Area Town", QuestionType: "Text",QuestionText: "Area Town(Current)", QuestionOrder: 132, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the Street Name", IsMandatory: 1,TextLength:30, TotCount: 2
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 133,
            QuestionName: "Nearest City",
            QuestionText: "Nearest City",
            QuestionType: "Dropdown",
            QuestionOrder: 133,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 134,
            QuestionName: "Village/Town/City",
            QuestionText: "Village/Town/City(Current)",
            validationType: "onlySpaceAlphabet",
            QuestionType: "Text",
            QuestionOrder: 134,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the city/town/village",
            IsMandatory: 1,
            TextLength: 20,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 135,
            QuestionName: "District",
            QuestionText: "District(Current)",
            QuestionType: "Dropdown",
            QuestionOrder: 135,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 136,
            QuestionName: "Country",
            QuestionText: "Country(Current)",
            QuestionType: "Dropdown",
            QuestionOrder: 136,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select country of Birth",
            IsMandatory: 1,
            TotCount: 2,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 137,
            QuestionName: "Postal Address",
            QuestionText: "Postal Address",
            QuestionLabel: "Postal Address",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 138,
            QuestionName: "Is Physical Address same as Postal Address?",
            QuestionText: "Is Physical Address same as Postal Address?",
            QuestionType: "CheckBox",
            QuestionOrder: 138,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "Is Physical Address same as Postal Address?",
            OptionValue: "yes",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 300,
              OptionValue: "yes",
              OptionText: "",
              SurveyID: vasurveyid,
              QuestionID: "Is Physical Address same as Postal Address?",
              QuestionType: "CheckBox",
            });
          }

          await db.TbSurveyQuestions.put({
            QuestionID: 139,
            QuestionName: "Plot Number",
            QuestionType: "Number",
            QuestionText: "House Number and Street(Permanent)",
            QuestionOrder: 139,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Plot Number",
            TextLength: 15,
            IsMandatory: 1,
            TotCount: 2,
          });

          // await db.TbSurveyQuestions.put({
          //     QuestionID: 139, QuestionName: "Postal Address", QuestionType: "Text",QuestionText: "Postal Address(Permanent)", QuestionOrder: 140, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the Street Name", IsMandatory: 1,TextLength:30, TotCount: 2
          // });
          await db.TbSurveyQuestions.put({
            QuestionID: 140,
            QuestionName: "Village/Town/City",
            QuestionType: "Text",
            QuestionText: "Village/Town/City(Permanent)",
            QuestionOrder: 140,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Enter the Street Name",
            IsMandatory: 1,
            TextLength: 30,
            TotCount: 2,
          });

          // var vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 141, QuestionName: "City",QuestionText: "City(Permanent)", QuestionType: "Text",validationType:"onlySpaceAlphabet", QuestionOrder: 141, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the city/town/village", IsMandatory: 1,TextLength:20, TotCount: 2
          // });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 142,
            QuestionName: "District",
            QuestionText: "State(Permanent)",
            QuestionType: "Dropdown",
            QuestionOrder: 142,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the Province/District",
            IsMandatory: 1,
            TotCount: 2,
          });

          // var OptionIDNo = 20500;
          // for(var i=0 ; i<State.length ;i++){
          //    var options = State[i].LookUpValue;
          //      var optText = State[i].LookUpValue;

          // await db.TbQuestionOptions.put({
          //     OptionID: OptionIDNo++, OptionValue: options, OptionText: optText, SurveyID: vasurveyid, QuestionID: 142, QuestionType: "Dropdown"
          //     });
          // }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 143,
            QuestionName: "Country",
            QuestionText: "Country(Permanent)",
            QuestionType: "Dropdown",
            QuestionOrder: 143,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the country",
            IsMandatory: 1,
            TotCount: 2,
          });

          var OptionIDNo = 30500;
          for (var i = 0; i < this.CountryCode.length; i++) {
            var options = this.CountryCode[i].LookUpValue;
            var optText = this.CountryCode[i].LookUpValue;

            await db.TbQuestionOptions.put({
              OptionID: OptionIDNo++,
              OptionValue: options,
              OptionText: optText,
              SurveyID: vasurveyid,
              QuestionID: 143,
              QuestionType: "Dropdown",
            });
          }

          await db.TbSurveyQuestions.put({
            QuestionID: 11113,
            QuestionName: "MIS Details",
            QuestionText: "MIS Details",
            QuestionLabel: "MIS Details",
            QuestionType: "Label",
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            IsMandatory: 1,
            TotCount: 2,
          });

          // geetha code 
 vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 6000000,
            QuestionName: "PORTFOLIO",
            QuestionText: "PORTFOLIO",
            QuestionType: "CheckBox",
            QuestionOrder: 6000000,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "PORTFOLIO",
            OptionValue: "PORTFOLIO",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 6000000,
              OptionValue: "PORTFOLIO",
              OptionText: "PORTFOLIO",
              SurveyID: vasurveyid,
              QuestionID: "PORTFOLIO",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600000,
            QuestionName: "MIS_Code_PORTFOLIO",
            QuestionText: "MIS_Code_PORTFOLIO",
            QuestionType: "Dropdown",
            QuestionOrder: 600000,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });
            
         
          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600001,
            QuestionName: "CHANNELAQ",
            QuestionText: "CHANNELAQ",
            QuestionType: "CheckBox",
            QuestionOrder: 600001,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "CHANNELAQ",
            OptionValue: "CHANNELAQ",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600001,
              OptionValue: "CHANNELAQ",
              OptionText: "CHANNELAQ",
              SurveyID: vasurveyid,
              QuestionID: "CHANNELAQ",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600002,
            QuestionName: "MIS_Code_CHANNELAQ",
            QuestionText: "MIS_Code_CHANNELAQ",
            QuestionType: "Dropdown",
            QuestionOrder: 600002,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600003,
            QuestionName: "INDUSTRY",
            QuestionText: "INDUSTRY",
            QuestionType: "CheckBox",
            QuestionOrder: 600003,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "INDUSTRY",
            OptionValue: "INDUSTRY",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600003,
              OptionValue: "INDUSTRY",
              OptionText: "INDUSTRY",
              SurveyID: vasurveyid,
              QuestionID: "INDUSTRY",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600004,
            QuestionName: "MIS_Code_INDUSTRY",
            QuestionText: "MIS_Code_INDUSTRY",
            QuestionType: "Dropdown",
            QuestionOrder: 600004,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600005,
            QuestionName: "KYC",
            QuestionText: "KYC",
            QuestionType: "CheckBox",
            QuestionOrder: 600005,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "KYC",
            OptionValue: "KYC",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600005,
              OptionValue: "KYC",
              OptionText: "KYC",
              SurveyID: vasurveyid,
              QuestionID: "KYC",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600006,
            QuestionName: "MIS_Code_KYC",
            QuestionText: "MIS_Code_KYC",
            QuestionType: "Dropdown",
            QuestionOrder: 600006,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600007,
            QuestionName: "LEGSTAT",
            QuestionText: "LEGSTAT",
            QuestionType: "CheckBox",
            QuestionOrder: 600007,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "LEGSTAT",
            OptionValue: "LEGSTAT",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600007,
              OptionValue: "LEGSTAT",
              OptionText: "LEGSTAT",
              SurveyID: vasurveyid,
              QuestionID: "LEGSTAT",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600008,
            QuestionName: "MIS_Code_LEGSTAT",
            QuestionText: "MIS_Code_LEGSTAT",
            QuestionType: "Dropdown",
            QuestionOrder: 600008,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600009,
            QuestionName: "REFERRALS",
            QuestionText: "REFERRALS",
            QuestionType: "CheckBox",
            QuestionOrder: 600009,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "REFERRALS",
            OptionValue: "REFERRALS",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600009,
              OptionValue: "REFERRALS",
              OptionText: "REFERRALS",
              SurveyID: vasurveyid,
              QuestionID: "REFERRALS",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600010,
            QuestionName: "MIS_Code_REFERRALS",
            QuestionText: "MIS_Code_REFERRALS",
            QuestionType: "Dropdown",
            QuestionOrder: 600010,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600011,
            QuestionName: "RESSTATUS",
            QuestionText: "RESSTATUS",
            QuestionType: "CheckBox",
            QuestionOrder: 600011,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "RESSTATUS",
            OptionValue: "RESSTATUS",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600011,
              OptionValue: "RESSTATUS",
              OptionText: "RESSTATUS",
              SurveyID: vasurveyid,
              QuestionID: "RESSTATUS",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600012,
            QuestionName: "MIS_Code_RESSTATUS",
            QuestionText: "MIS_Code_RESSTATUS",
            QuestionType: "Dropdown",
            QuestionOrder: 600012,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600013,
            QuestionName: "SALES_ORI",
            QuestionText: "SALES_ORI",
            QuestionType: "CheckBox",
            QuestionOrder: 600013,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 1,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SALES_ORI",
            OptionValue: "SALES_ORI",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600013,
              OptionValue: "SALES_ORI",
              OptionText: "SALES_ORI",
              SurveyID: vasurveyid,
              QuestionID: "SALES_ORI",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600014,
            QuestionName: "MIS_Code_SALES_ORI",
            QuestionText: "MIS_Code_SALES_ORI",
            QuestionType: "Text",
            QuestionOrder: 500014,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            validationType: "",
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TextLength: 30,
            TotCount: 2,
          });


           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600015,
            QuestionName: "SEGMENT",
            QuestionText: "SEGMENT",
            QuestionType: "CheckBox",
            QuestionOrder: 500015,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SEGMENT",
            OptionValue: "SEGMENT",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600015,
              OptionValue: "SEGMENT",
              OptionText: "SEGMENT",
              SurveyID: vasurveyid,
              QuestionID: "SEGMENT",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600016,
            QuestionName: "MIS_Code_SEGMENT",
            QuestionText: "MIS_Code_SEGMENT",
            QuestionType: "Dropdown",
            QuestionOrder: 600016,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });

           vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID: 600017,
            QuestionName: "SEGMENT_C",
            QuestionText: "SEGMENT_C",
            QuestionType: "CheckBox",
            QuestionOrder: 500017,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select Debit",
            IsMandatory: 0,
            TotCount: 6,
            Disabled: true
          });
          options = await db.TbQuestionOptions.where({
            QuestionID: "SEGMENT_C",
            OptionValue: "SEGMENT_C",
          }).toArray();
          if (options == null || options.length == 0) {
            await db.TbQuestionOptions.put({
              OptionID: 600017,
              OptionValue: "SEGMENT_C",
              OptionText: "SEGMENT_C",
              SurveyID: vasurveyid,
              QuestionID: "SEGMENT_C",
              QuestionType: "CheckBox",
              Disabled: true
            });
          }


          vaquestionid = await db.TbSurveyQuestions.put({
            QuestionID:  600018,
            QuestionName: "MIS_Code_SEGMENT_C",
            QuestionText: "MIS_Code_SEGMENT_C",
            QuestionType: "Dropdown",
            QuestionOrder: 600018,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: "Select the MIS Code",
            IsMandatory: 1,
            TotCount: 2,
          });
// vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID: 8888,
//             QuestionName: "MIS Class", //portfoilo type
//             QuestionText: "MIS Class",
//             QuestionType: "Dropdown",
//             QuestionOrder: 8888,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Select the MIS Class",
//             IsMandatory: 1,
//             TotCount: 2,
//           });
//           vaquestionid = await db.TbSurveyQuestions.put({
//             QuestionID:  8881,
//             QuestionName: "MIS Code",
//             QuestionText: "MIS Code", //sales origin
//             QuestionType: "Text",
//             QuestionOrder: 8881,
//             SurveyID: vasurveyid,
//             SectionId: vasurveysectionid,
//             IsConditionQuestion: 0,
//             ConditionValue1: null,
//             IsRepeatSection: 0,
//             IsFormulaQuestion: 0,
//             IsSearchable: 1,
//             ErrorText: "Enter the MIS Code",
//             TextLength: 30,
//             IsMandatory: 1,
//             TotCount: 2,
//           });

          

          // vaquestionid = await db.TbSurveyQuestions.put({
          //   QuestionID: 8882,
          //   QuestionName: "Segment Name",
          //   QuestionText: "Segment Name",
          //   QuestionType: "Dropdown",
          //   QuestionOrder: 8882,
          //   SurveyID: vasurveyid,
          //   SectionId: vasurveysectionid,
          //   IsConditionQuestion: 0,
          //   ConditionValue1: null,
          //   IsRepeatSection: 0,
          //   IsFormulaQuestion: 0,
          //   IsSearchable: 1,
          //   ErrorText: "Select the Segment Name",
          //   IsMandatory: 1,
          //   TotCount: 2,
          // });

          // ------SECTION 11-------

          //  var vasurveysectionid = await db.TbSurveySection.put({ SectionId: 11, Name: "Employment Details", CreatedDate: new Date(), UpdatedDate: new Date(), CreatedBy: UserId, UpdatedBy: UserId, IsActive: 1, SurveyId: vasurveyid, SectionOrder: 4, ParentSectionId: 0, TotCount: 2 });

          //  await db.TbSurveyQuestions.put({
          //     QuestionID: 144, QuestionName: "Employer's Name",QuestionText: "Employer's Name", QuestionType: "Text", QuestionOrder: 144, SurveyID: vasurveyid, SectionId: vasurveysectionid,validationType:"onlySpaceAlphabet", IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1,ErrorText: "Enter the Employers Name", IsMandatory: 1,TextLength:30, TotCount: 2
          // });

          // var vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 145, QuestionName: "Occupation",QuestionText: "Occupation", QuestionType: "Dropdown", QuestionOrder: 145, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the city/town/village", IsMandatory: 1, TotCount: 2
          // });

          // var vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 146, QuestionName: "Nature of Employment",QuestionText: "Nature of Employment", QuestionType: "Dropdown", QuestionOrder: 146, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select the city/town/village", IsMandatory: 1, TotCount: 2
          // });

          // ------SECTION 12-------

          // var vasurveysectionid = await db.TbSurveySection.put({ SectionId: 12, Name: "FACTA", CreatedDate: new Date(), UpdatedDate: new Date(), CreatedBy: UserId, UpdatedBy: UserId, IsActive: 1, SurveyId: vasurveyid, SectionOrder: 5, ParentSectionId: 0, TotCount: 2 });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 147, QuestionName: "Are you a US Citizen or US Resident?",QuestionText:"Are you a US Citizen or US Resident?", QuestionType: "Radio", QuestionOrder: 147, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Employer /Business type", IsMandatory: 0, TotCount: 6
          //   });
          //   options = await db.TbQuestionOptions.where({QuestionID: "Are you a US Citizen or US Resident?", OptionValue: 'Yes'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 50, OptionValue: "Yes", OptionText: "Yes", SurveyID: vasurveyid, QuestionID: "Are you a US Citizen or US Resident?", QuestionType: "CheckBox" });
          //   }
          //   options = await db.TbQuestionOptions.where({QuestionID: "Are you a US Citizen or US Resident?", OptionValue: 'No'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 51, OptionValue: "No", OptionText: "No", SurveyID: vasurveyid, QuestionID: "Are you a US Citizen or US Resident?", QuestionType: "CheckBox" });
          //   }

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 148, QuestionName: "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?",QuestionText:"Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?", QuestionType: "Radio", QuestionOrder: 148, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Employer /Business type", IsMandatory: 0, TotCount: 6
          //   });
          //   options = await db.TbQuestionOptions.where({QuestionID: "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?", OptionValue: 'Yes'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 52, OptionValue: "Yes", OptionText: "Yes", SurveyID: vasurveyid, QuestionID: "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?", QuestionType: "CheckBox" });
          //   }
          //   options = await db.TbQuestionOptions.where({QuestionID: "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?", OptionValue: 'No'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 53, OptionValue: "No", OptionText: "No", SurveyID: vasurveyid, QuestionID: "Have you Signed a Power of Attorny(PoA) or granted signatory authority to a person holding a U.S address?", QuestionType: "CheckBox" });
          //   }

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 149, QuestionName: "Have you Visited U.S in the past 3 years?",QuestionText:"Have you Visited U.S in the past 3 years?", QuestionType: "Radio", QuestionOrder: 149, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Employer /Business type", IsMandatory: 0, TotCount: 6
          //   });
          //   options = await db.TbQuestionOptions.where({QuestionID: "Have you Visited U.S in the past 3 years?", OptionValue: 'Yes'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 54, OptionValue: "Yes", OptionText: "Yes", SurveyID: vasurveyid, QuestionID: "Have you Visited U.S in the past 3 years?", QuestionType: "CheckBox" });
          //   }
          //   options = await db.TbQuestionOptions.where({QuestionID: "Have you Visited U.S in the past 3 years?", OptionValue: 'No'}).toArray();
          //   if (options == null || options.length == 0) {
          //   await db.TbQuestionOptions.put({ OptionID: 55, OptionValue: "No", OptionText: "No", SurveyID: vasurveyid, QuestionID: "Have you Visited U.S in the past 3 years?", QuestionType: "CheckBox" });
          //   }

          // ------SECTION 13-------

          //  var vasurveysectionid = await db.TbSurveySection.put({ SectionId: 13, Name: "Account Details", CreatedDate: new Date(), UpdatedDate: new Date(), CreatedBy: UserId, UpdatedBy: UserId, IsActive: 1, SurveyId: vasurveyid, SectionOrder: 6, ParentSectionId: 0, TotCount: 2 });

          //-------SECTION 14---------

          vasurveysectionid = await db.TbSurveySection.put({
            SectionId: 9,
            Name: "Signature",
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: UserId,
            UpdatedBy: UserId,
            IsActive: 1,
            SurveyId: vasurveyid,
            SectionOrder: 3,
            ParentSectionId: 0,
            TotCount: 6,
          });

          await db.TbSurveyQuestions.put({
            QuestionID: 152,
            QuestionName: "Signature",
            QuestionText: "Signature",
            QuestionType: "Sign",
            QuestionOrder: 152,
            SurveyID: vasurveyid,
            SectionId: vasurveysectionid,
            IsConditionQuestion: 0,
            ConditionValue1: null,
            DefaultValue: null,
            ConditionSectionId: 0,
            ConditionType: null,
            IsRepeatSection: 0,
            IsFormulaQuestion: 0,
            IsSearchable: 1,
            ErrorText: null,
            FieldVar: null,
            FormulaExpression: null,
            HierarchyQuestionOrder: null,
            IsMandatory: 1,
            TotCount: 2,
          });

          // vaquestionid = await db.TbSurveyQuestions.put({
          //     QuestionID: 153, QuestionName: "Utility Bill",QuestionText: "Utility Bill", QuestionType: "Dropdown", QuestionOrder: 1, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Account Type", IsMandatory: 1, TotCount: 2
          // });

          // await db.TbQuestionOptions.put({
          //     OptionID: 300, OptionValue: "Letter from employer", OptionText: "Letter from employer", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 301, OptionValue: "Letter from school", OptionText: "Letter from school", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 302, OptionValue: "Lease Agreement", OptionText: "Lease Agreement", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 303, OptionValue: "Affidavit from the landlord", OptionText: "Affidavit from the landlord", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 304, OptionValue: "Local Council rates invoice", OptionText: "Local Council rates invoice", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 305, OptionValue: "Access Bank staff visit", OptionText: "Access Bank staff visit", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 306, OptionValue: "Access Bank confirmation", OptionText: "Access Bank confirmation", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 307, OptionValue: "Confirmation letter by Legal practitioner", OptionText: "Confirmation letter by Legal practitioner", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 308, OptionValue: "Confirmation letter by BICA Members", OptionText: "Confirmation letter by BICA Members", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 309, OptionValue: "Address verification by Access Bank Customer", OptionText: "Address verification by Access Bank Customer", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 310, OptionValue: "Customary Authority", OptionText: "Customary Authority", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });
          // await db.TbQuestionOptions.put({
          //     OptionID: 311, OptionValue: "For married couples", OptionText: "For married couples", SurveyID: vasurveyid, QuestionID: "Utility Bill", QuestionType: "Dropdown"
          // });

          //   await db.TbSurveyQuestions.put({
          //     QuestionID: 156, QuestionName: "Upload [Income proof]",QuestionText: "Upload [Income proof]", QuestionType: "Image", QuestionOrder: 154, SurveyID: vasurveyid, SectionId: vasurveysectionid, IsConditionQuestion: 0, ConditionValue1: null, IsRepeatSection: 0, IsFormulaQuestion: 0, IsSearchable: 1, ErrorText: "Select Image", IsMandatory: 1, TotCount: 2
          // });
        }
      },

       async getLookUpValues() {
        //tamilscode
        if (this.portfolioOptions.length == 0) {
          this.getPortfolioOptions();
        }

        if (this.channelAqOptions.length == 0) {
          this.getchannelAqOptions();
        }
        if (this.industryOptions.length == 0) {
          this.getindustryOptions();
        }
        if (this.kycOptions.length == 0) {
          this.getkycOptions();
        }
        if (this.referralsOptions.length == 0) {
          this.getreferralsOptions();
        }
        if (this.legstatOptions.length == 0) {
          this.getlegstatOptions();
        }
        if (this.resstatusOptions.length == 0) {
          this.getresstatusOptions();
        }
        if (this.salesOriOptions.length == 0) {
          this.getsalesOriOptions();
        }
        if (this.segmentOptions.length == 0) {
          this.getsegmentOptions();
        }
        if (this.segmentCOptions.length == 0) {
          this.getsegmentCOptions();
        }
       

        if (this.segmentNameOptions.length == 0) {
          this.getSegmentNameOptions();
        }
        if (this.accountOfficerNameOptions.length == 0) {
          this.getAccountOfficerNameOptions();
        }

        if (this.Occupation.length == 0) {
          await this.getOccupation();
        }

        if (this.EmploymentStatus.length == 0) {
          await this.getEmploymentStatus();
        }

        if (this.Branch.length == 0) {
          await this.getBranch();
        }

        if (this.City.length == 0) {
          await this.getCity();
        }

        if (this.ISDcode.length == 0) {
          await this.getISDcode();
        }

        if (this.ResidentStatus.length == 0) {
          await this.getResidentStatus();
        }
        if (this.CurrenciesAllowed.length == 0) {
          await this.getCurrenciesAllowed();
        }
        if (this.CountryCode.length == 0) {
          await this.getCountryCode();
        }
        if (this.CustomerType.length == 0) {
          await this.getCustomerType();
        }

        if (this.title.length == 0) {
          await this.getTitle();
        }

        if (this.Gender.length == 0) {
          await this.getGender();
        }

        if (this.maritalStatus.length == 0) {
          await this.getMaritalStatus();
        }

        if (this.CurrentAccountClass.length == 0) {
          await this.getCurrentAccountClass();
        }
        if (this.SavingsAccountClass.length == 0) {
          await this.getSavingsAccountClass();
        }
        if (this.CallAccountClass.length == 0) {
          await this.getCallAccountClass();
        }
        if (this.TransactionalAccountClass.length == 0) {
          await this.getTransactionalAccountClass();
        }
        if (this.FullKYCAccountType.length == 0) {
          await this.getFullKYCAccountType();
        }
        if (this.LiteKYCAccountType.length == 0) {
          await this.getLiteKYCAccountType();
        }

        if (this.FullKYCAccoutClass.length == 0) {
          await this.getTestAccountClass();
        }

        if (this.District.length == 0) {
          await this.getDistrict();
        }

        // if(AccountType.length == 0){
        //     await getAccountType();
        // }

        if (this.State.length == 0) {
          await this.getState();
        }

        if (this.NearestCity.length == 0) {
          await this.getNearestCity();
        }

        if (this.EmployedProofDocument.length == 0) {
          await this.getEmployedType();
        }
        if (this.SelfEmployedProofDocument.length == 0) {
          await this.getSelfEmployedType();
        }
        if (this.PensionerProofDocument.length == 0) {
          await this.getPensionerEmployedType();
        }
        if (this.UnEmployedProofDocument.length == 0) {
          await this.getUnEmployedType();
        }
      },

      async getTestAccountClass() {
        const url = `${externalURL}get_lookup_value/?lookupType=AccountClass&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: function (data) {
              if (data && data.length > 0) {
                const ids = data.map((o) => o.LookUpValue);
                self.FullKYCAccoutClass = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
              self.PreLoader = false;
            },
            error: function (ex) {
              self.PreLoader = false;
            },
          });
        } catch (error) {
          this.PreLoader = false;
        }
      },

      async getState() {
        const url = `${externalURL}get_lookup_value/?lookupType=State&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.State = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },
      //tamilscode
      async getPortfolioOptionsbackup() {
        this.portfolioOptions = [
          {
            LookUpValue: "CHANNELAQ",
            LookUpCode: "CHANNELAQ",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "INDUSTRY",
            LookUpCode: "INDUSTRY",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "KYC",
            LookUpCode: "KYC",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "LEGSTAT",
            LookUpCode: "LEGSTAT",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "PORTFOLIO",
            LookUpCode: "PORTFOLIO",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
            {
            LookUpValue: "REFERRALS",
            LookUpCode: "REFERRALS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
            {
            LookUpValue: "RESSTATUS",
            LookUpCode: "RESSTATUS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
            {
            LookUpValue: "SALES_ORI",
            LookUpCode: "SALES_ORI",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
              {
            LookUpValue: "SEGMENT",
            LookUpCode: "SEGMENT",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
            {
            LookUpValue: "SEGMENT_C",
            LookUpCode: "SEGMENT_C",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
        ];
      },
      async getPortfolioOptions() {
        this.portfolioOptions = [
          {
            LookUpValue: "RET_Y",
            LookUpCode: "RET_Y",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_F",
            LookUpCode: "RET_F",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_G",
            LookUpCode: "RET_G",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_P",
            LookUpCode: "RET_P",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_D",
            LookUpCode: "RET_D",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
         
        ];
      },

      async getchannelAqOptions() {
        this.channelAqOptions = [
          {
            LookUpValue: "WALK_IN",
            LookUpCode: "WALK_IN",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "REFERAL",
            LookUpCode: "REFERAL",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "DIRECT",
            LookUpCode: "DIRECT",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RB",
            LookUpCode: "RB",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          
        ];
      },

      async getindustryOptions() {
        this.industryOptions = [
          {
            LookUpValue: "1",
            LookUpCode: "1",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
         
          
        ];
      },

      async getkycOptions() {
        this.kycOptions = [
          {
            LookUpValue: "COMPLIANT",
            LookUpCode: "COMPLIANT",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "NONCOMPLT",
            LookUpCode: "NONCOMPLT",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
         
          
        ];
      },
      async getlegstatOptions() {
        this.legstatOptions = [
          {
            LookUpValue: "PVT_INDIV",
            LookUpCode: "PVT_INDIV",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "IND",
            LookUpCode: "IND",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
         
          
        ];
      },
      async getreferralsOptions() {
        this.referralsOptions = [
          {
            LookUpValue: "BD01",
            LookUpCode: "BD01",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
        ];
      },
      async getresstatusOptions() {
        this.resstatusOptions = [
          {
            LookUpValue: "NONREIND",
            LookUpCode: "NONREIND",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RESINDV",
            LookUpCode: "RESINDV",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
         
          
        ];
      },
      async getsalesOriOptions() {
        this.salesOriOptions = [
          {
            LookUpValue: "DSA239",
            LookUpCode: "DSA239",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          
        ];
      },
      async getsegmentOptions() {
        this.segmentOptions = [
          {
            LookUpValue: "IND",
            LookUpCode: "IND",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          
        ];
      },
      async getsegmentCOptions() {
        this.segmentCOptions = [
          {
            LookUpValue: "RET_YC",
            LookUpCode: "RET_YC",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_YS",
            LookUpCode: "RET_YS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_FSE",
            LookUpCode: "RET_FSE",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_FBW",
            LookUpCode: "RET_FBW",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_GG",
            LookUpCode: "RET_GG",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_GS",
            LookUpCode: "RET_GS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_GX",
            LookUpCode: "RET_GX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_PP",
            LookUpCode: "RET_PP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_PX",
            LookUpCode: "RET_PX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          {
            LookUpValue: "RET_DP",
            LookUpCode: "RET_DP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
          },
          
        ];
      },

      async getSegmentNameOptions() {
        this.segmentNameOptions = [
          {
            LookUpValue: "Children",
            LookUpCode: "RET_YC",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Youth",
          },
          {
            LookUpValue: "Students",
            LookUpCode: "RET_YS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Youth",
          },
          {
            LookUpValue: "Self Employed",
            LookUpCode: "RET_FSE",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Fresh",
          },
          {
            LookUpValue: "Blue collar workers",
            LookUpCode: "RET_FBW",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Fresh",
          },
          {
            LookUpValue: "Graduate",
            LookUpCode: "RET_GG",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Stable Gold",
            LookUpCode: "RET_GS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Gold Other",
            LookUpCode: "RET_GX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Professional Platinum",
            LookUpCode: "RET_PP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Platinum",
          },
          {
            LookUpValue: "Platinum Other",
            LookUpCode: "RET_PX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Platinum",
          },
          {
            LookUpValue: "Private Client",
            LookUpCode: "RET_DP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Diamond",
          },
        ];
      },
      async getAccountOfficerNameOptions() {
        this.accountOfficerNameOptions = [
          {
            LookUpValue: "Children",
            LookUpCode: "RET_YC",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Youth",
          },
          {
            LookUpValue: "Students",
            LookUpCode: "RET_YS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Youth",
          },
          {
            LookUpValue: "Self Employed",
            LookUpCode: "RET_FSE",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Fresh",
          },
          {
            LookUpValue: "Blue collar workers",
            LookUpCode: "RET_FBW",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Fresh",
          },
          {
            LookUpValue: "Graduate",
            LookUpCode: "RET_GG",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Stable Gold",
            LookUpCode: "RET_GS",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Gold Other",
            LookUpCode: "RET_GX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Gold",
          },
          {
            LookUpValue: "Professional Platinum",
            LookUpCode: "RET_PP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Platinum",
          },
          {
            LookUpValue: "Platinum Other",
            LookUpCode: "RET_PX",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Platinum",
          },
          {
            LookUpValue: "Private Client",
            LookUpCode: "RET_DP",
            MapField1: "",
            MapField2: "",
            MapField3: "",
            Type: "Diamond",
          },
        ];
      },

      async getOccupation() {
        const url = `${externalURL}get_lookup_value/?lookupType=Occupation&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.Occupation = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getEmploymentStatus() {
        const url = `${externalURL}get_lookup_value/?lookupType=EmploymentStatus&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.EmploymentStatus = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getBranch() {
        const url = `${externalURL}get_lookup_value/?lookupType=Branch&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.Branch = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCity() {
        const url = `${externalURL}get_lookup_value/?lookupType=City&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.City = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      // async getISDcode(){

      //     var url = externalURL+"get_lookup_value/?lookupType=ISDCode&lookupString=";

      //     try {
      //         await $.ajax({
      //             url: url,
      //             type: 'POST',
      //             success: async function (data) {

      //             if(data  && data.length > 0){
      //                 var ids = data.map(o => o.LookUpCode)
      //                 this.ISDcode = data.filter(({LookUpCode}, index) => !ids.includes(LookUpCode, index + 1));
      //             }
      //             },
      //             error: function (ex) {
      //                 console.log(ex);
      //             }
      //             });
      //         } catch (error) {
      //             console.log(error);
      //         }
      // },

      async getResidentStatus() {
        const url = `${externalURL}get_lookup_value/?lookupType=ResidentStatus&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.ResidentStatus = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCurrenciesAllowed() {
        const url = `${externalURL}get_lookup_value/?lookupType=CurrenciesAllowed&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.CurrenciesAllowed = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCountryCode() {
        const url = `${externalURL}get_lookup_value/?lookupType=CountryCode&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.CountryCode = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCustomerType() {
        const url = `${externalURL}get_lookup_value/?lookupType=CustomerType&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.CustomerType = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getTitle() {
        const url = `${externalURL}get_lookup_value/?lookupType=Title&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: function (data) {
              if (data && data.length > 0) {
                const ids = data.map((o) => o.LookUpValue);
                self.title = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
              self.PreLoader = false;
            },
            error: function (ex) {
              self.PreLoader = false;
            },
          });
        } catch (error) {
          this.PreLoader = false;
        }
      },

      async getGender() {
        const url = `${externalURL}get_lookup_value/?lookupType=Gender&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.Gender = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getMaritalStatus() {
        const url = `${externalURL}get_lookup_value/?lookupType=MaritalStatus&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.maritalStatus = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCurrentAccountClass() {
        const url = `${externalURL}get_lookup_value/?lookupType=CurrentAccount&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.CurrentAccountClass = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getSavingsAccountClass() {
        const url = `${externalURL}get_lookup_value/?lookupType=SavingsAccount&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.SavingsAccountClass = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );

                // if(SavingsAccountClass.length>0){
                //     var optionId = 30000
                //     var tboptions = await db.TbQuestionOptions.where("QuestionID").equals("Account Class(Current)").toArray();

                //     if(tboptions.length != SavingsAccountClass.length || tboptions == null || tboptions.length == 0) {
                //         await db.TbQuestionOptions.where({QuestionID: "Account Class(Current)"}).delete();
                //         for(var i=0; i<SavingsAccountClass.length; i++){
                //             var options = SavingsAccountClass[i].LookUpValue;
                //             await db.TbQuestionOptions.put({
                //             OptionID: optionId++, OptionValue: options, OptionText: options, SurveyID: vasurveyid, QuestionID: "Account Class(Current)", QuestionType: null
                //             });
                //         }
                //     }
                // }
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getCallAccountClass() {
        const url = `${externalURL}get_lookup_value/?lookupType=CallAccount&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.CallAccountClass = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );

                // if(CallAccountClass.length>0){
                //     var optionId = 10500
                //     var tboptions = await db.TbQuestionOptions.where("QuestionID").equals("Account Class(FullKYCAcct)").toArray();

                //     if(tboptions.length != CallAccountClass.length || tboptions == null || tboptions.length == 0) {
                //         await db.TbQuestionOptions.where({QuestionID: "Account Class(FullKYCAcct)"}).delete();
                //         for(var i=0; i<CallAccountClass.length; i++){
                //             var options = CallAccountClass[i].LookUpValue;
                //             await db.TbQuestionOptions.put({
                //             OptionID: optionId++, OptionValue: options, OptionText: options, SurveyID: vasurveyid, QuestionID: "Account Class(FullKYCAcct)", QuestionType: null
                //             });
                //         }
                //     }
                // }
                return this.CallAccountClass;
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getTransactionalAccountClass() {
        const url = `${externalURL}get_lookup_value/?lookupType=TransactionalAccount&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.TransactionalAccountClass = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getFullKYCAccountType() {
        const url = `${externalURL}get_lookup_value/?lookupType=FullKYCAccountType&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);

                self.FullKYCAccountType = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getLiteKYCAccountType() {
        const url = `${externalURL}get_lookup_value/?lookupType=LiteKYCAccountType&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);

                self.LiteKYCAccountType = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      // async getSelectiveAccountClass() {
      //     var url = externalURL + "get_lookup_value/?lookupType=AccountType&lookupString=";

      //     try {
      //         const data = await $.ajax({
      //             url: url,
      //             type: 'POST'
      //         });

      //         if (data && data.length > 0) {
      //             var currentAcctType = [];

      //             // Define the callback function outside the AJAX success function
      //             function isCurrent(acctType) {
      //                 if (acctType.LookUpValue === 'Current') {
      //                     currentAcctType.push(acctType.LookUpCode);
      //                     return true; // Return true to keep this item in the filtered array
      //                 }
      //                 return false; // Return false to exclude this item from the filtered array
      //             }

      //             // Use the filter() method with the callback function to create a new array
      //             var evenNumbers = data.filter(isCurrent);

      //             return currentAcctType; // Return the filtered array or whatever result is needed
      //         }
      //     } catch (error) {
      //         console.error(error);
      //         throw error; // Re-throw the error to propagate it further if needed
      //     }
      // },

      async getDistrict() {
        const url = `${externalURL}get_lookup_value/?lookupType=District&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.District = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getNearestCity() {
        const url = `${externalURL}get_lookup_value/?lookupType=NearestCity&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.NearestCity = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async getEmployedType() {
        const url = `${externalURL}get_lookup_value/?lookupType=Employed&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.EmployedProofDocument = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },
      async getSelfEmployedType() {
        const url = `${externalURL}get_lookup_value/?lookupType=Self Employed&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.SelfEmployedProofDocument = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },
      async getPensionerEmployedType() {
        const url = `${externalURL}get_lookup_value/?lookupType=Pensioner&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.PensionerProofDocument = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },
      async getUnEmployedType() {
        const url = `${externalURL}get_lookup_value/?lookupType=UnEmployed&lookupString=`;

        try {
          const self = this;
          await $.ajax({
            url: url,
            type: "POST",
            success: async function (data) {
              if (data && data.length > 0) {
                var ids = data.map((o) => o.LookUpValue);
                self.UnEmployedProofDocument = data.filter(
                  ({ LookUpValue }, index) =>
                    !ids.includes(LookUpValue, index + 1)
                );
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      async addTboptionValues() {
        var vasurveyid = 1;
        if (this.title.length > 0) {
          var optionId = 1000;
          var tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Title")
            .toArray();

          if (
            tboptions.length != this.title.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({ QuestionID: "Title" }).delete();
            for (var i = 0; i < this.title.length; i++) {
              var options = this.title[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Title",
                QuestionType: "Dropdown",
              });
            }
          }
        }
        if (this.Gender.length > 0) {
          optionId = 1500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Gender")
            .toArray();

          if (
            tboptions.length != this.Gender.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({ QuestionID: "Gender" }).delete();
            for (i = 0; i < this.Gender.length; i++) {
              options = this.Gender[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Gender",
                QuestionType: null,
              });
            }
          }
        }

        // if(CountryCode.length>0){
        // 	var optionId = 2000
        // 	var tboptions = await db.TbQuestionOptions.where("QuestionID").equals("Country of Birth").toArray();

        // 	if(tboptions.length != CountryCode.length || tboptions == null || tboptions.length == 0) {
        // 		await db.TbQuestionOptions.where({QuestionID: "Country of Birth"}).delete();
        // 		for(var i=0; i<CountryCode.length; i++){
        // 			var options = CountryCode[i].LookUpValue;
        // 			await db.TbQuestionOptions.put({
        // 			OptionID: optionId++, OptionValue: options, OptionText: options, SurveyID: vasurveyid, QuestionID: "Country of Birth", QuestionType: null
        // 			});
        // 		}
        // 	}
        // }
        if (this.CountryCode.length > 0) {
          optionId = 2000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Country of Birth")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Country of Birth",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Country of Birth",
                QuestionType: null,
              });
            }
          }

          optionId = 2500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Nationality")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Nationality",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Nationality",
                QuestionType: null,
              });
            }
          }
          optionId = 50500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("National ID Issue Country")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "National ID Issue Country",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "National ID Issue Country",
                QuestionType: null,
              });
            }
          }

          optionId = 3000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Passport Issue Country")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Passport Issue Country",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Passport Issue Country",
                QuestionType: null,
              });
            }
          }

          optionId = 7000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Country(Current)")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Country(Current)",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Country(Current)",
                QuestionType: null,
              });
            }
          }
          optionId = 10000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Country(Permanent)")
            .toArray();

          if (
            tboptions.length != this.CountryCode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Country(Permanent)",
            }).delete();
            for (i = 0; i < this.CountryCode.length; i++) {
              options = this.CountryCode[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Country(Permanent)",
                QuestionType: null,
              });
            }
          }
        }
        // if(CountryCode.length>0){
        // 	var optionId = 3000
        // 	var tboptions = await db.TbQuestionOptions.where("QuestionID").equals("Passport Issue Country").toArray();

        // 	if(tboptions.length != CountryCode.length || tboptions == null || tboptions.length == 0) {
        // 		await db.TbQuestionOptions.where({QuestionID: "Passport Issue Country"}).delete();
        // 		for(var i=0; i<CountryCode.length; i++){
        // 			var options = CountryCode[i].LookUpValue;
        // 			await db.TbQuestionOptions.put({
        // 			OptionID: optionId++, OptionValue: options, OptionText: options, SurveyID: vasurveyid, QuestionID: "Passport Issue Country", QuestionType: null
        // 			});
        // 		}
        // 	}
        // }
        if (this.maritalStatus.length > 0) {
          optionId = 3500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Marital Status")
            .toArray();

          if (
            tboptions.length != this.maritalStatus.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Marital Status",
            }).delete();
            for (i = 0; i < this.maritalStatus.length; i++) {
              options = this.maritalStatus[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Marital Status",
                QuestionType: null,
              });
            }
          }
        }
        if (this.EmploymentStatus.length > 0) {
          optionId = 4000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Spouse Employment Status")
            .toArray();

          if (
            tboptions.length != this.EmploymentStatus.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Spouse Employment Status",
            }).delete();
            for (i = 0; i < this.EmploymentStatus.length; i++) {
              options = this.EmploymentStatus[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Spouse Employment Status",
                QuestionType: null,
              });
            }
          }
        }
        if (this.NearestCity.length > 0) {
          optionId = 4500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Nearest City")
            .toArray();

          if (
            tboptions.length != this.NearestCity.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Nearest City",
            }).delete();
            for (i = 0; i < this.NearestCity.length; i++) {
              options = this.NearestCity[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Nearest City",
                QuestionType: null,
              });
            }
          }
        }
        if (this.Occupation.length > 0) {
          optionId = 5000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Occupation")
            .toArray();

          if (
            tboptions.length != this.Occupation.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Occupation",
            }).delete();
            for (i = 0; i < this.Occupation.length; i++) {
              options = this.Occupation[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Occupation",
                QuestionType: null,
              });
            }
          }
        }

        if (this.FullKYCAccountType.length > 0) {
          optionId = 8500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Type")
            .toArray();

          if (
            tboptions.length != this.FullKYCAccountType.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Type",
            }).delete();
            for (i = 0; i < this.FullKYCAccountType.length; i++) {
              options = this.FullKYCAccountType[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Type",
                QuestionType: null,
              });
            }
          }
        }
        if (this.CurrentAccountClass.length > 0) {
          optionId = 30000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Class(Current)")
            .toArray();

          if (
            tboptions.length != this.CurrentAccountClass.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Class(Current)",
            }).delete();
            for (i = 0; i < this.CurrentAccountClass.length; i++) {
              options = this.CurrentAccountClass[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Class(Current)",
                QuestionType: null,
              });
            }
          }
        }

        if (this.SavingsAccountClass.length > 0) {
          optionId = 30500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Class(Savings)")
            .toArray();

          if (
            tboptions.length != this.SavingsAccountClass.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Class(Savings)",
            }).delete();
            for (i = 0; i < this.SavingsAccountClass.length; i++) {
              options = this.SavingsAccountClass[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Class(Savings)",
                QuestionType: null,
              });
            }
          }
        }

        if (this.CallAccountClass.length > 0) {
          optionId = 40000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Class(Call)")
            .toArray();
          if (
            tboptions.length != this.CallAccountClass.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Class(Call)",
            }).delete();
            for (i = 0; i < this.CallAccountClass.length; i++) {
              options = this.CallAccountClass[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Class(Call)",
                QuestionType: null,
              });
            }
          }
        }

        if (this.TransactionalAccountClass.length > 0) {
          optionId = 20000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Class(Transactional)")
            .toArray();

          if (
            tboptions.length != this.TransactionalAccountClass.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Class(Transactional)",
            }).delete();
            for (i = 0; i < this.TransactionalAccountClass.length; i++) {
              options = this.TransactionalAccountClass[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Class(Transactional)",
                QuestionType: null,
              });
            }
          }
        }

        if (this.CustomerType.length > 0) {
          optionId = 5500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Customer Type")
            .toArray();

          if (
            tboptions.length != this.CustomerType.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Customer Type",
            }).delete();
            for (i = 0; i < this.CustomerType.length; i++) {
              options = this.CustomerType[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Customer Type",
                QuestionType: null,
              });
            }
          }
        }
        //tamilcode
        if (this.portfolioOptions.length > 0) {
          optionId = 70000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_PORTFOLIO")
            .toArray();

          if (
            tboptions.length != this.portfolioOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_PORTFOLIO",
            }).delete();
            for (i = 0; i < this.portfolioOptions.length; i++) {
              options = this.portfolioOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_PORTFOLIO",
                QuestionType: null,
              });
            }
          }
        }

        if (this.channelAqOptions.length > 0) {
          optionId = 70001
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_CHANNELAQ")
            .toArray();

          if (
            tboptions.length != this.channelAqOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_CHANNELAQ",
            }).delete();
            for (i = 0; i < this.channelAqOptions.length; i++) {
              options = this.channelAqOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_CHANNELAQ",
                QuestionType: null,
              });
            }
          }
        }
        if (this.referralsOptions.length > 0) {
          optionId = 70002
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_REFERRALS")
            .toArray();

          if (
            tboptions.length != this.referralsOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_REFERRALS",
            }).delete();
            for (i = 0; i < this.referralsOptions.length; i++) {
              options = this.referralsOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_REFERRALS",
                QuestionType: null,
              });
            }
          }
        }
        if (this.industryOptions.length > 0) {
          optionId = 70003
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_INDUSTRY")
            .toArray();

          if (
            tboptions.length != this.industryOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_INDUSTRY",
            }).delete();
            for (i = 0; i < this.industryOptions.length; i++) {
              options = this.industryOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_INDUSTRY",
                QuestionType: null,
              });
            }
          }
        }
        if (this.kycOptions.length > 0) {
          optionId = 70004
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_KYC")
            .toArray();

          if (
            tboptions.length != this.kycOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_KYC",
            }).delete();
            for (i = 0; i < this.kycOptions.length; i++) {
              options = this.kycOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_KYC",
                QuestionType: null,
              });
            }
          }
        }
        if (this.legstatOptions.length > 0) {
          optionId = 70005
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_LEGSTAT")
            .toArray();

          if (
            tboptions.length != this.legstatOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_LEGSTAT",
            }).delete();
            for (i = 0; i < this.legstatOptions.length; i++) {
              options = this.legstatOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_LEGSTAT",
                QuestionType: null,
              });
            }
          }
        }

        if (this.resstatusOptions.length > 0) {
          optionId = 70006
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_RESSTATUS")
            .toArray();

          if (
            tboptions.length != this.resstatusOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_RESSTATUS",
            }).delete();
            for (i = 0; i < this.resstatusOptions.length; i++) {
              options = this.resstatusOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_RESSTATUS",
                QuestionType: null,
              });
            }
          }
        }

        if (this.salesOriOptions.length > 0) {
          optionId = 70007
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_SALES_ORI")
            .toArray();

          if (
            tboptions.length != this.salesOriOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_SALES_ORI",
            }).delete();
            for (i = 0; i < this.salesOriOptions.length; i++) {
              options = this.salesOriOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_SALES_ORI",
                QuestionType: null,
              });
            }
          }
        }
        if (this.segmentOptions.length > 0) {
          optionId = 70008
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_SEGMENT")
            .toArray();

          if (
            tboptions.length != this.segmentOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_SEGMENT",
            }).delete();
            for (i = 0; i < this.segmentOptions.length; i++) {
              options = this.segmentOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_SEGMENT",
                QuestionType: null,
              });
            }
          }
        }
        if (this.segmentCOptions.length > 0) {
          optionId = 70009
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("MIS_Code_SEGMENT_C")
            .toArray();

          if (
            tboptions.length != this.segmentCOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "MIS_Code_SEGMENT_C",
            }).delete();
            for (i = 0; i < this.segmentCOptions.length; i++) {
              options = this.segmentCOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "MIS_Code_SEGMENT_C",
                QuestionType: null,
              });
            }
          }
        }
        // if (this.segmentNameOptions.length > 0) {
        //   optionId = 8882;
        //   tboptions = await db.TbQuestionOptions.where("QuestionID")
        //     .equals("Segment Name")
        //     .toArray();

        //   if (
        //     tboptions.length != this.segmentNameOptions.length ||
        //     tboptions == null ||
        //     tboptions.length == 0
        //   ) {
        //     await db.TbQuestionOptions.where({
        //       QuestionID: "Segment Name",
        //     }).delete();
        //     for (i = 0; i < this.segmentNameOptions.length; i++) {
        //       options = this.segmentNameOptions[i].LookUpValue;
        //       await db.TbQuestionOptions.put({
        //         OptionID: optionId++,
        //         OptionValue: options,
        //         OptionText: options,
        //         SurveyID: vasurveyid,
        //         QuestionID: "Segment Name",
        //         QuestionType: null,
        //       });
        //     }
        //   }
        // }

        if (this.accountOfficerNameOptions.length > 0) {
          optionId = 8883;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Officer Name")
            .toArray();

          if (
            tboptions.length != this.accountOfficerNameOptions.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Officer Name",
            }).delete();
            for (i = 0; i < this.accountOfficerNameOptions.length; i++) {
              options = this.accountOfficerNameOptions[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Officer Name",
                QuestionType: null,
              });
            }
          }
        }

        if (this.ISDcode.length > 0) {
          optionId = 8882;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("ISDCodes")
            .toArray();

          if (
            tboptions.length != this.ISDcode.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "ISDCodes",
            }).delete();
            for (i = 0; i < this.ISDcode.length; i++) {
              options = this.ISDcode[i].LookUpCode;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "ISDCodes",
                QuestionType: null,
              });
            }
          }
        }
        if (this.District.length > 0) {
          optionId = 6500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Province/District")
            .toArray();

          if (
            tboptions.length != this.District.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Province/District",
            }).delete();
            for (i = 0; i < this.District.length; i++) {
              options = this.District[i].LookUpCode;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Province/District",
                QuestionType: null,
              });
            }
          }
        }

        // if(CountryCode.length>0){
        // 	var optionId = 7000
        // 	var tboptions = await db.TbQuestionOptions.where("QuestionID").equals("Country").toArray();

        // 	if(tboptions.length != CountryCode.length || tboptions == null || tboptions.length == 0) {
        // 		await db.TbQuestionOptions.where({QuestionID: "Country"}).delete();
        // 		for(var i=0; i<CountryCode.length; i++){
        // 			var options = CountryCode[i].LookUpValue;
        // 			await db.TbQuestionOptions.put({
        // 			OptionID: optionId++, OptionValue: options, OptionText: options, SurveyID: vasurveyid, QuestionID: "Country", QuestionType: null
        // 			});
        // 		}
        // 	}
        // }
        if (this.EmploymentStatus.length > 0) {
          optionId = 7500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Nature of Employment")
            .toArray();

          if (
            tboptions.length != this.EmploymentStatus.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Nature of Employment",
            }).delete();
            for (i = 0; i < this.EmploymentStatus.length; i++) {
              options = this.EmploymentStatus[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Nature of Employment",
                QuestionType: null,
              });
            }
          }
        }
        if (this.CurrenciesAllowed.length > 0) {
          optionId = 8000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Currency")
            .toArray();

          if (
            tboptions.length != this.CurrenciesAllowed.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Currency",
            }).delete();
            for (i = 0; i < this.CurrenciesAllowed.length; i++) {
              options = this.CurrenciesAllowed[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Currency",
                QuestionType: null,
              });
            }
          }
        }

        if (this.LiteKYCAccountType.length > 0) {
          optionId = 20500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Type(LiteKYCAcct)")
            .toArray();

          if (
            tboptions.length != this.LiteKYCAccountType.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Type(LiteKYCAcct)",
            }).delete();
            for (i = 0; i < this.LiteKYCAccountType.length; i++) {
              options = this.LiteKYCAccountType[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Type(LiteKYCAcct)",
                QuestionType: null,
              });
            }
          }
        }

        if (this.State.length > 0) {
          optionId = 9000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("District(Current)")
            .toArray();

          if (
            tboptions.length != this.State.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "District(Current)",
            }).delete();
            for (i = 0; i < this.State.length; i++) {
              options = this.State[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "District(Current)",
                QuestionType: null,
              });
            }
          }

          optionId = 9500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("State(Current)")
            .toArray();

          if (
            tboptions.length != this.State.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "State(Current)",
            }).delete();
            for (i = 0; i < this.State.length; i++) {
              options = this.State[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "State(Current)",
                QuestionType: null,
              });
            }
          }

          optionId = 50500;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("State(Permanent)")
            .toArray();

          if (
            tboptions.length != this.State.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "State(Permanent)",
            }).delete();
            for (i = 0; i < this.State.length; i++) {
              options = this.State[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "State(Permanent)",
                QuestionType: null,
              });
            }
          }

          optionId = 50000;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Source of Funds(Employed)")
            .toArray();

          if (
            tboptions.length != this.EmployedProofDocument.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Source of Funds(Employed)",
            }).delete();
            for (i = 0; i < this.EmployedProofDocument.length; i++) {
              options = this.EmployedProofDocument[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Source of Funds(Employed)",
                QuestionType: null,
              });
            }
          }

          optionId = 50100;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Source of Funds(SelfEmployed)")
            .toArray();

          if (
            tboptions.length != this.SelfEmployedProofDocument.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Source of Funds(SelfEmployed)",
            }).delete();
            for (i = 0; i < this.SelfEmployedProofDocument.length; i++) {
              options = this.SelfEmployedProofDocument[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Source of Funds(SelfEmployed)",
                QuestionType: null,
              });
            }
          }

          optionId = 50200;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Source of Funds(Pensioner)")
            .toArray();

          if (
            tboptions.length != this.PensionerProofDocument.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Source of Funds(Pensioner)",
            }).delete();
            for (i = 0; i < this.PensionerProofDocument.length; i++) {
              options = this.PensionerProofDocument[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Source of Funds(Pensioner)",
                QuestionType: null,
              });
            }
          }

          optionId = 50300;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Source of Funds(UnEmployed)")
            .toArray();

          if (
            tboptions.length != this.UnEmployedProofDocument.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Source of Funds(UnEmployed)",
            }).delete();
            for (i = 0; i < this.UnEmployedProofDocument.length; i++) {
              options = this.UnEmployedProofDocument[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Source of Funds(UnEmployed)",
                QuestionType: null,
              });
            }
          }

          optionId = 50400;
          tboptions = await db.TbQuestionOptions.where("QuestionID")
            .equals("Account Class(test)")
            .toArray();

          if (
            tboptions.length != this.FullKYCAccoutClass.length ||
            tboptions == null ||
            tboptions.length == 0
          ) {
            await db.TbQuestionOptions.where({
              QuestionID: "Account Class(test)",
            }).delete();
            for (i = 0; i < this.FullKYCAccoutClass.length; i++) {
              options = this.FullKYCAccoutClass[i].LookUpValue;
              await db.TbQuestionOptions.put({
                OptionID: optionId++,
                OptionValue: options,
                OptionText: options,
                SurveyID: vasurveyid,
                QuestionID: "Account Class(test)",
                QuestionType: null,
              });
            }
          }
        }
      },

      async SavingsAcctClass() {
        var vasurveyid = 1;
        var optionId = 50500;
        var SavingsList = [];
        var tboptions = await db.TbQuestionOptions.where("QuestionID")
          .equals("Account Class(test)")
          .toArray();
        if (this.FullKYCAccoutClass.length == 0) {
          this.getLookUpValues();
        }
        this.FullKYCAccoutClass = this.FullKYCAccoutClass.filter(
          (word) => word.LookUpValue
        );
        for (var k = 0; k < this.FullKYCAccoutClass.length; k++) {
          if (this.FullKYCAccoutClass[k].LookUpValue.includes("Savings")) {
            SavingsList.push(this.FullKYCAccoutClass[k].LookUpValue);
          }
        }
        // if(tboptions.length != SavingsList.length || tboptions == null || tboptions.length == 0) {
        await db.TbQuestionOptions.where({
          QuestionID: "Account Class(test)",
        }).delete();
        for (var i = 0; i < SavingsList.length; i++) {
          var options = SavingsList[i];
          await db.TbQuestionOptions.put({
            OptionID: optionId++,
            OptionValue: options,
            OptionText: options,
            SurveyID: vasurveyid,
            QuestionID: "Account Class(test)",
            QuestionType: null,
          });
        }
        await db.TbQuestionOptions.where({
          QuestionID: "Account Class(test)",
        }).update();
        var tboptions1 = await db.TbQuestionOptions.where("QuestionID")
          .equals("Account Class(test)")
          .toArray();
        // }
      },

      async submitgenz(userid, formid) {
        var ClientSyncData = await db.ClientSyncQueue.where("FormID")
          .equals(formid)
          .toArray();
        var surveyName = "";
        var arrImage = new Array();
        var FormID = 0;
        var SurveyId = 0;
        if (
          ClientSyncData != null &&
          ClientSyncData.length > 0 &&
          ClientSyncData[0].TagName != "User"
        ) {
          ClientSyncData = ClientSyncData.filter((x) => x.TagName != "User");

          for (var k = 0; k < ClientSyncData.length; k++) {
            FormID = ClientSyncData[k].FormID;
            SurveyId = ClientSyncData[k].SurveyID;
            var TbSurvey = await db.TbSurvey.where("SurveyID")
              .equals(SurveyId)
              .toArray();
            surveyName =
              TbSurvey != null && TbSurvey.length > 0
                ? TbSurvey[0].SurveyName
                : "";

            var ans3 = await db.TbSurveySection.where({
              SurveyId: SurveyId,
            }).toArray();
            var ans =
              ans3 != null
                ? ans3.sort(function (a, b) {
                    return a.SectionOrder - b.SectionOrder;
                  })
                : ans3;

            var conditionSectionIds = await db.TbSurveyQuestions.where({
              SurveyID: SurveyId,
            }).toArray();
            conditionSectionIds = conditionSectionIds.filter(
              (x) => x.IsConditionQuestion == true
            );

            for (var cntid = 0; cntid < conditionSectionIds.length; cntid++) {
              ans = ans.filter(
                (x) =>
                  x.SectionId != conditionSectionIds[cntid].ConditionSectionId
              );
            }
            var arr = new Array();

            for (var i = 0; i < ans.length; i++) {
              var SurveyQuestion1 = await db.TbSurveyQuestions.where({
                SectionId: ans[i].SectionId,
              }).toArray();
              SurveyQuestion1 = SurveyQuestion1.filter(
                (x) => x.QuestionType != "Notes"
              );
              var SurveyQuestion =
                SurveyQuestion1 != null
                  ? SurveyQuestion1.sort(function (a, b) {
                      return a.QuestionOrder - b.QuestionOrder;
                    })
                  : SurveyQuestion1;

              for (var j = 0; j < SurveyQuestion.length; j++) {
                if (
                  SurveyQuestion[j].QuestionText == "ISDCode" ||
                  SurveyQuestion[j].QuestionText == "ISDCodes"
                ) {
                  SurveyQuestion[j].QuestionText =
                    SurveyQuestion[j].QuestionName;
                }
                var object = new Object();

                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = SurveyQuestion[j].SectionId;
                object.QuestionID = SurveyQuestion[j].QuestionID;
                object.Question = SurveyQuestion[j].QuestionText;
                object.QuestionType = SurveyQuestion[j].QuestionType;

                var RepeatQuestionCount = await db.TbSurveyQuestions.where({
                  RepeatSectionId: ans[i].SectionId,
                }).count();

                var Answers = await this.GetSectionAnswerAutoPdf(
                  object.QuestionID,
                  FormID,
                  object.QuestionType
                );

                if (
                  Answers != null &&
                  Answers.length > 0 &&
                  RepeatQuestionCount == 0
                ) {
                  object.Answer = Answers[0].Answer;

                  if (
                    SurveyQuestion[j].QuestionType == "Image" ||
                    SurveyQuestion[j].QuestionType == "Sign"
                  ) {
                    object.Answer = "";

                    if (Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                      for (var m = 0; m < Answers[0].Blob.length; m++) {
                        var objectImage = new Object();

                        switch (object.QuestionID) {
                          case 26:
                            objectImage.Name = "PhotoofCustomer";
                            break;
                          case 54:
                            objectImage.Name = "FullKYCSignature";
                            break;
                          // case 56:
                          //     objectImage.Name = "UploadDeclaration";
                          //     break;
                          // case 58:
                          //     objectImage.Name = "UploadDeclaration";
                          //     break;
                          case 152:
                            objectImage.Name = "LiteKYCSignature";
                            break;
                          case 154:
                            objectImage.Name = "CaptureImage"; // type is FILE
                            break;
                          case 56:
                            objectImage.Name = "ProofOfResidence";
                            break;
                          case 58:
                            objectImage.Name = "ProofOfUtilityBill";
                            break;
                          case 63:
                            objectImage.Name = "ProofForSourceOfFunds";
                            break;
                        }
                        objectImage.Image = Answers[0].Blob[m];
                        arrImage.push(objectImage);
                        // formImage.push(objectImage)
                        // this.formJsonValue = { ...objectImage}
                      }
                    }
                  }

                  if (
                    SurveyQuestion[j].QuestionType == "CaptureImage" ||
                    SurveyQuestion[j].QuestionType == "ProofOfResidence" ||
                    SurveyQuestion[j].QuestionType == "ProofOfUtilityBill" ||
                    SurveyQuestion[j].QuestionType == "ProofForSourceOfFunds"
                  ) {
                    object.Answer = "";

                    if (Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                      // for (var m = 0; m < Answers[0].Blob.length; m++) {
                      var objectImage1 = new Object();

                      switch (object.QuestionID) {
                        // case 55:
                        //         objectImage.Name = "CaptureImage"; // type is FILE
                        //         break;
                        case 154:
                          objectImage1.Name = "CaptureImage"; // type is FILE
                          break;
                        case 56:
                          objectImage1.Name = "ProofOfResidence";
                          break;
                        case 58:
                          objectImage1.Name = "ProofOfUtilityBill";
                          break;
                        case 63:
                          objectImage1.Name = "ProofForSourceOfFunds";
                          break;
                      }
                      objectImage1.Image = Answers[0].Blob[0];
                      arrImage.push(objectImage1);
                      // formImage.push(objectImage1)
                      // }
                    }
                  }
                }

                if (
                  object.Answer != null &&
                  object.Answer != "" &&
                  object.Answer != undefined &&
                  object.Answer != "[]"
                ) {
                  if (object.QuestionType == "Yes/No") {
                    object.Answer = parseInt(object.Answer);

                    if (SurveyQuestion[j].IsConditionQuestion) {
                      var curntanswer =
                        parseInt(object.Answer) == 1 ? "Yes" : "No";

                      if (curntanswer == SurveyQuestion[j].ConditionValue1) {
                        var SurveyQuestion2 = await db.TbSurveyQuestions.where({
                          SectionId: SurveyQuestion[j].ConditionSectionId,
                        }).toArray();
                        for (var kk = 0; kk < SurveyQuestion2.length; kk++) {
                          SurveyQuestion.splice(
                            j + (kk + 1),
                            0,
                            SurveyQuestion2[kk]
                          );
                        }
                      }
                    }

                    switch (object.Answer) {
                      case 1:
                        object.Answer = "Yes";
                        break;
                      case 2:
                        object.Answer = "No";
                        break;
                    }
                  } else if (
                    object.QuestionType == "Dropdown" ||
                    object.QuestionType == "masterdb"
                  ) {
                    switch (object.Question) {
                      case "Branch State":
                        var ansbr = object.Answer;
                        object.Answer = ansbr.substring(ansbr.indexOf("-") + 1);
                        break;
                      case "Branch":
                        // object.Answer = (object.Answer != null ? object.Answer.split('-')[1].trim() : "");
                        var ansbr1 = object.Answer;
                        object.Answer = ansbr1.substring(
                          ansbr1.indexOf("-") + 1
                        );
                        break;
                      case "Religion":
                        var ansbr2 = object.Answer;
                        object.Answer = ansbr2.substring(
                          ansbr2.indexOf("-") + 1
                        );
                        break;
                      case "Category":
                        var ansbr3 = object.Answer;
                        object.Answer = ansbr3.substring(
                          ansbr3.indexOf("-") + 1
                        );
                        break;
                      case "Annual Income":
                        var ansbr4 = object.Answer;
                        object.Answer = ansbr4.substring(
                          ansbr4.indexOf("-") + 1
                        );
                        break;
                      case "Education":
                        //var splt = object.Answer.split('-');
                        //if (splt != null && splt.length > 0 && splt[0] == "01") {
                        //    object.Answer = object.Answer.split('-')[1].trim() + "-" + object.Answer.split('-')[2].trim();
                        //} else {
                        //    object.Answer = (object.Answer != null ? object.Answer.split('-')[1].trim() : "");
                        //}
                        var ansbr5 = object.Answer;
                        object.Answer = ansbr5.substring(
                          ansbr5.indexOf("-") + 1
                        );
                        break;
                      case "Occupation":
                        var ansbr6 = object.Answer;
                        object.Answer = ansbr6.substring(
                          ansbr6.indexOf("-") + 1
                        );
                        break;
                      case "Product type":
                        var ansbr7 = object.Answer;
                        object.Answer = ansbr7.substring(
                          ansbr7.indexOf("-") + 1
                        );
                      // swap value  → code for server
                      case "Portfolio Type": {
                        const selected = this.portfolioOptions.find(
                          (opt) => opt.LookUpValue === object.Answer
                        );
                        object.Answer =
                          selected && selected.LookUpCode
                            ? selected.LookUpCode
                            : "";
                        break;
                      }
                      case "Segment Name": {
                        //  ← NEW
                        const sel = this.segmentNameOptions.find(
                          (o) => o.LookUpValue === object.Answer
                        );
                        object.Answer = sel ? sel.LookUpCode : "";
                        break;
                      }
                    }
                  }
                }
                // if(object.Answer){
                // arr.push(object);
                // }
                if (object.Answer != undefined) {
                  if (object.Answer != "") {
                    arr.push(object);
                    formJsonValue.push(object);
                    console.log("formJsonValue ::::", this.formJsonValue);
                  }
                } else if (object.Answer == undefined) {
                  // to not send empty data to backend
                }
              }
              console.log("all object", object);
            }

            var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
            var userToken = "";
            if (genzdata != null && genzdata.length != 0) {
              userToken = genzdata[0].token;

              if (typeof genzdata[0].consentForm != "undefined") {
                object = new Object();
                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = 10002;
                object.QuestionID = 1000000;
                object.Question = "Consent for account opening";
                object.QuestionType = "CheckBox";
                object.Answer = "I AGREE";
                arr.push(object);
              }

              if (typeof genzdata[0].termsandCondition != "undefined") {
                object = new Object();
                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = 10003;
                object.QuestionID = 1000001;
                object.Question = "Terms and Condition";
                object.QuestionType = "CheckBox";
                object.Answer = "I AGREE";
                arr.push(object);
              }
            }

            /* image upload Section  Starts*/
            objectImage = new Object();
            if (arrImage != null && arrImage.length > 0) {
              for (var imgcount = 0; imgcount < arrImage.length; imgcount++) {
                var base64data = await this.blobToBase64(
                  arrImage[imgcount].Image
                );

                switch (arrImage[imgcount].Name) {
                  case "PhotoofCustomer":
                    objectImage.PhotoofCustomer = base64data.split(",")[1];
                    break;
                  case "Signature":
                    objectImage.Signature = base64data.split(",")[1];
                    break;
                  case "FullKYCSignature":
                    objectImage.FullKYCSignature = base64data.split(",")[1];
                    break;
                  case "LiteKYCSignature":
                    objectImage.LiteKYCSignature = base64data.split(",")[1];
                    break;
                  case "UploadDeclaration":
                    objectImage.UploadDeclaration = base64data.split(",")[1];
                    break;
                  case "CaptureImage":
                    objectImage.CaptureImage = base64data.split(",")[1];
                    break;
                  case "ProofOfResidence":
                    objectImage.ProofOfResidence = base64data.split(",")[1];
                    break;
                  case "ProofOfUtilityBill":
                    objectImage.ProofOfUtilityBill = base64data.split(",")[1];
                    break;
                  case "ProofForSourceOfFunds":
                    objectImage.ProofForSourceOfFunds =
                      base64data.split(",")[1];
                    break;
                }
              }
            }

            // objectImage.FormPdf = await AutoGeneratePDF(SurveyId, FormID, userToken);
            // console.log(objectImage.FormPdf);

            var isIos = "False";
            var deviceAgent = navigator.userAgent.toLowerCase();
            var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
            if (agentID) {
              isIos = "True";
            }

            try {
              //console.log(JSON.stringify(arr));
              //var formDataImage = new FormData();
              //formDataImage.append('clientUserId', userToken);
              //formDataImage.append('isios', isIos);
              //var stringifyjson = JSON.stringify(objectImage);
              //formDataImage.append('data', stringifyjson);
              //formDataImage.append('userid', userToken);

              //$.ajax({
              //    url: 'https://vcip.gieom.com/uploadmultiple/',
              //    type: 'POST',
              //    data: formDataImage,
              //    processData: false,
              //    contentType: false,
              //    success: function (dataupload) {
              //        //console.log(dataupload)
              //    },
              //    error: function (ex) {
              //        console.log(ex);
              //        // alert("Network error: Something is wrong with your internet connection. Please try again after restoring the connection.");
              //    }
              //});

              /* image upload Section Ends */
              console.log("arr one", arr);

              // let firstNameObj = arr.find((q) => q.Question === "First Name");
              // let middleNameObj = arr.find((q) => q.Question === "Middle Name");
              // let surnameObj = arr.find((q) => q.Question === "Surname");

              // let firstName = firstNameObj ? firstNameObj.Answer : "";
              // let middleName = middleNameObj ? middleNameObj.Answer : "";
              // let surname = surnameObj ? surnameObj.Answer : "";

              // let arrNew = arr.map((item) => {
              //   if (item.Question.startsWith("Account Class")) {
              //     let fullName = [surname, firstName, middleName]
              //       .filter((name) => name.trim())
              //       .join(" ");
              //     return { ...item, Answer: fullName };
              //   }
              //   return item;
              // });

              // console.log("New arrNew one", arrNew);

              var jsondata = JSON.stringify(arr);
              console.log("New customer data", arr);
              jsondata = '{"customerdetails":' + jsondata + "}";
              console.log("Customer details", jsondata);

              const url =
                "http://dctestapi.gieom.com/Users/CreateTaskForApplication";

              var data = new FormData();
              genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

              var stringifyjson = JSON.stringify(objectImage);
              // Parse the JSON string to a JavaScript object
              let parsedObject = JSON.parse(stringifyjson);

              // Extract the keys
              let keys = Object.keys(parsedObject);
              let imageString = keys.join(",");
              // Print the keys
              console.log(keys);
              //jsondata = JSON.parse(jsondata);
              data.append("formjson", jsondata);
              data.append("UserId", userToken);
              data.append("PWADSAUserId", genzdata[0].DSAUserId);
              data.append("PWAUserType", this.PwaUserType);
              data.append("interimSave", "0");
              // data.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
              data.append("PWAUserSessionId", getSessionId());
              data.append("PWAUserBranchCode", genzdata[0].PWAUserBranchCode);

              let response = await fetch(
                externalURL + "CreateRefIdForApplication/",
                {
                  //mode: "no-cors",
                  method: "POST",
                  //body: 'formjson=' + jsondata,
                  body: data,
                  headers: { 'DSAUserId': genzdata[0].DSAUserId }
                }
              );

              let result = await response.json();
              if (response.statusText == "OK") {
                if (result.Message == "Success") {
                  await db.ClientSyncQueue.where("SyncQueuePKID")
                    .equals(ClientSyncData[k].SyncQueuePKID)
                    .delete();
                }
              }
              if(result.DSAAuthenticationStatus == '81'){
               if (sunidhi.handleAuthFailure(result, self)) {
                       return
                    }
                  }
              return result;
            } catch (err) {
              console.log("CreateRefIdForApplication", err);
              alert(
                "Service Unavailable due to network issue. Please try again later.2"
              );
            }
          }
        }
      },

      async Createreference(referenceid, userid) {
        var url = baseUrl + "createreference/";

        var fvformData = new FormData();
        fvformData.append("userid", userid);
        fvformData.append("referenceid", referenceid);

        let response = await fetch(url, {
          method: "POST",
          body: fvformData,
          //headers: { 'Content-type': 'application/json' }
          headers: { 'DSAUserId': genzdata[0].DSAUserId }
        });

        let result = await response.json();
        if (result != null && result != undefined) {
          if (result.message == "Success") {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },

      async SubmitCustomerCreation(object, userId) {
        // debugger;
        // console.log(JSON.stringify(object));
        var UCICNo = "";
        // var customerdate = new Date();

        try {
          $.ajax({
            url:
              "http://localhost:84/api/customercreation?api_key=kyqak5muymxcrjhc5q57vz9v&userid=" +
              userId,
            type: "POST",
            async: false,
            data: object,
            dataType: "json",
            contentType: "application/x-www-form-urlencoded",
            success: async function (data) {
              //var res = Math.abs(customerdate - new Date()) / 1000;
              //var seconds = (res / 60).toFixed(2);
              //FinalTimestamp.push("CustomerCreation-" + seconds);

              if (data.Status == "success") {
                if (data.Data != null && data.Data != undefined) {
                  if (data.Data.Errors != null && data.Data.Errors.length > 0) {
                    //alert("Customer creation Failed : " + data.Data.Errors[0].Code + ' -' + data.Data.Errors[0].Description);
                  } else {
                    // alert("Customer created Successfully :- UCIC -" + data.Data.UCIC);

                    UCICNo = data.Data.UCIC;
                  }
                } else {
                  // alert("Customer creation Failed :-" + data.Message);
                }
              } else {
                // alert("Customer creation Failed :-" + data.Message);
              }
            },
            error: function (ex) {
              // alert("Customer creation Failed");
            },
          });
        } catch (error) {
          UCICNo = "";
        }
        return UCICNo;
      },

      async SubmitCustomerAML(objectDate, UCIC, userid) {
        var objectone = new Object();

        objectone.EntityType = "";
        objectone.CreationDateTime = this.formatDate();
        objectone.RequestorName = "Suryoday";

        var objectPostalAddress = new Object();
        objectPostalAddress.Type = "";
        objectPostalAddress.StreetName = "";
        objectPostalAddress.BuildingNumber = "";
        objectPostalAddress.Department = "";
        objectPostalAddress.SubDepartment = "";
        objectPostalAddress.TownName = "";
        objectPostalAddress.City =
          objectDate.ContactDetails.ContactDetails[0].PostalAddress.City;

        objectPostalAddress.Landmark = "";
        objectPostalAddress.CountrySubDivision = "";
        objectPostalAddress.Country = "india";
        objectPostalAddress.PostCode = "";
        objectPostalAddress.AddressLine = "";

        var objectCustomer = new Object();
        objectCustomer.DateOfBirth = objectDate.DateAndPlaceOfBirth.BirthDt;
        objectCustomer.PostalAddress = [];
        objectCustomer.PostalAddress.push(objectPostalAddress);
        objectCustomer.FirstName = objectDate.FirstName;
        objectCustomer.LastName = objectDate.LastName;
        objectCustomer.MiddleName = "";
        objectCustomer.Identification_Type = [];
        objectCustomer.UCIC = UCIC;

        var objectIdentificationtype = new Object();
        objectIdentificationtype.IdentityNumber =
          objectDate.IdentificationType[0].IdentityNumber;
        objectIdentificationtype.IdentityType =
          objectDate.IdentificationType[0].IdentityType;
        objectCustomer.Identification_Type.push(objectIdentificationtype);

        objectIdentificationtype.IdentityNumber =
          objectDate.IdentificationType[1].IdentityNumber;
        objectIdentificationtype.IdentityType =
          objectDate.IdentificationType[1].IdentityType;
        objectCustomer.Identification_Type.push(objectIdentificationtype);

        objectone.Customer = objectCustomer;
        objectone.BranchId = objectDate.BranchId;
        objectone.RequestType = "";

        var object = new Object();
        object.Data = objectone;

        var correlationId = "";

        //var dd = JSON.stringify(object);
        //debugger;
        // var amlquery = new Date();
        var URL =
          "http://localhost:84/api/customer/aml/query?api_key=kyqak5muymxcrjhc5q57vz9v&userid=" +
          userid;
        try {
          await $.ajax({
            url: URL,
            type: "POST",
            async: false,
            data: object,
            dataType: "json",
            contentType: "application/x-www-form-urlencoded",
            success: async function (data) {
              //var res = Math.abs(amlquery - new Date()) / 1000;
              //var seconds = (res / 60).toFixed(2);
              //FinalTimestamp.push("amlquery-" + seconds);

              if (data.Status == "success") {
                // setTimeout(async function () {

                if (data.Data != null && data.Data != undefined) {
                  if (data.Data.Errors != null && data.Data.Errors.length > 0) {
                    // alert("AML Query Failed : " + data.Data.Errors[0].Code + ' -' + data.Data.Errors[0].Description);
                  } else if (data.Data.Status == "SUCCESS") {
                    //  alert("AML Query executed Successfully :- CorrelationId -" + data.Data.CorrelationId);
                    correlationId = data.Data.CorrelationId;
                  }
                } else {
                  //alert("AML Query Failed :-" + data.Message);
                }
                // }, 50000);
              } else {
                //alert("AML Query Failed :-" + data.Message);
              }
            },
            error: function (ex) {
              //  alert("AML Query Failed :-" + "Error While Fetching data");
            },
          });
        } catch (error) {
          correlationId = "";
        }

        return correlationId;
      },

      async QueryResponseAML(corelationid, userId) {
        var apistatus = true;

        try {
          await $.ajax({
            url:
              "http://localhost:84/api/customer/aml/query/response?api_key=kyqak5muymxcrjhc5q57vz9v&correlationId=" +
              corelationid +
              "&userid=" +
              userId,
            type: "GET",
            success: async function (fetchdata) {
              if (fetchdata.Status == "Success") {
                // eslint-disable-next-line no-undef
                if (data.Data != null && data.Data != undefined) {
                  // eslint-disable-next-line no-undef
                  if (data.Data.Errors != null && data.Data.Errors.length > 0) {
                    //alert("AML Query Response Failed : " + data.Data.Errors[0].Code + ' -' + data.Data.Errors[0].Description);
                    //return false;
                  } else {
                    //  await QueryResponseAML(data.Data.CorrelationId, objectData, UCIC);
                    //return new Promise(await CASAAccountCreation(objectData, UCIC));
                    //var calStatus = ;
                    //return calStatus;
                    apistatus = true;
                  }
                } else {
                  //alert("AML Query Response Failed : " + fetchdata.Message);
                  //return false;
                }
              } else {
                //alert("AML Query Response Failed : " + fetchdata.Message);
                //return false;
              }
            },
            error: function (ex) {
              //alert("AML Query Response Failed : " + "Error While Fetching data");
              //return false;
            },
          });
        } catch (error) {
          //error
        }
        return apistatus;
      },

      formatDate() {
        var d = new Date(),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
      },

      async CASAAccountCreation(objectDate, UCIC, userId) {
        var object = new Object();

        var casaaccountid = "";

        if (
          objectDate.NameoftheNominee != undefined &&
          objectDate.NameoftheNominee != null &&
          objectDate.NameoftheNominee.length > 0
        ) {
          object = {
            Data: {
              Product: {
                Group: "SAV",
                Type: objectDate.ProductType,
              },
              UCIC: UCIC,
              BranchId: objectDate.BranchId,
              Customer: {
                OrganizationName: "",
                AdultDependents: "",
                Category: "",
                TDSDetails: {
                  FormSubmitted: "",
                },
                TurnOver: "",
                Gender: objectDate.Gender,
                EmailNotification: "",
                EmailStatementFlag: "",
                Name: "",
                MaidenFirstName: "",
                Education: "",
                EmployeeSector: "",
                MotherName: "",
                NoOfDependents: "",
                FATCAFlag: "",
                SMSNotification: "",
                CountryOfRegistration: "",
                NamePrefix: "",
                CountryOfResidence: "",
                Designation: "",
                OfficePhoneNumber: "",
                FirstName: "",
                CustomerCode: "",
                DateAndPlaceOfBirth: {
                  BirthDt: objectDate.BirthDt,
                  CityOfBirth: "",
                  CountryOfBirth: "",
                },
                NatureOfBusiness: "",
                EmployeeNumber: "",
                MinorDependents: "",
                MiddleName: "",
                EmailAddress: "",
                IncomeCategory: "",
                IdentificationType: [
                  {
                    IdentityNumber: "",
                    IdentityType: "",
                    Category: "",
                    SubCategory: "",
                    EmbossedName: "",
                    IssuedBy: "",
                    PlaceOfIssue: "",
                    Country: "",
                    //"IssueDate": "",
                    //"ExpiryDate": ""
                  },
                ],
                CustomerEmployeeNumber: "",
                Occupation: "",
                MaritalStatus: "",
                ResidentialType: "",
                MobileNumber: "",
                Type: "",
                PhoneNumber: "",
                LastName: "",
                AddressType: "P",
                Community: "",
                FatherName: objectDate.FatherName,
                CustomerOrganisationName: "",
              },
              ChequeBookRequired: objectDate.Chequebook.toString(),
              DebitCardRequired: objectDate.Debitcard.toString(),
              Account: {
                NomineeAge:
                  objectDate.NomineeAge == undefined
                    ? ""
                    : objectDate.NomineeAge.toString(),
                EmbossedName:
                  objectDate.NameonDebitcard == undefined
                    ? ""
                    : objectDate.NameonDebitcard,
                SweepFacility: "0",
                Address: "",
                AccountRelationship: "A",
                Reference: [
                  {
                    PostalAddress: "",
                    Name: "",
                  },
                  {
                    PostalAddress: "",
                    Name: "",
                  },
                ],
                Amount: "0",
                NickName: objectDate.FirstName + " " + objectDate.LastName,
                Nominee: {
                  PostalAddress: {
                    Type: "ADDR",
                    StreetName:
                      objectDate.AddressofNominee1 == undefined
                        ? ""
                        : objectDate.AddressofNominee1,
                    BuildingNumber:
                      objectDate.AddressofNominee2 == undefined
                        ? ""
                        : objectDate.AddressofNominee2,
                    Department:
                      objectDate.AddressofNominee3 == undefined
                        ? ""
                        : objectDate.AddressofNominee3,
                    SubDepartment: "",
                    TownName: "",
                    City:
                      objectDate.NomineeCity == undefined
                        ? ""
                        : objectDate.NomineeCity,
                    Landmark: "",
                    CountrySubDivision: "IN",
                    Country: "IN",
                    PostCode:
                      objectDate.NomineePostCode == undefined
                        ? ""
                        : objectDate.NomineePostCode.toString(),
                    AddressLine: "",
                    GeoLocation: {
                      Latitude: "",
                      Longitude: "",
                    },
                  },
                  Relationship:
                    objectDate.RelationwithCustomer == undefined
                      ? ""
                      : objectDate.RelationwithCustomer,
                  GuardianName:
                    objectDate.GuardianName == undefined
                      ? ""
                      : objectDate.GuardianName,
                  Name:
                    objectDate.NameoftheNominee == undefined
                      ? ""
                      : objectDate.NameoftheNominee,
                },
                LeadNo: "",
                MobileBankingStatus: objectDate.MobileBankingFlag.toString(),
                InternetBankingStatus: objectDate.internetbanking.toString(),
                GuardianAge:
                  objectDate.GuardianAge == undefined
                    ? ""
                    : objectDate.GuardianAge.toString(),
                Relationship:
                  objectDate.RelationwithNominee == undefined
                    ? ""
                    : objectDate.RelationwithNominee,
                AccountOpeningFormNumber: this.IDGenerator(),
                DateofBirth:
                  objectDate.NomineeDateofBirth == undefined
                    ? ""
                    : objectDate.NomineeDateofBirth,
                ModeOfOperation: "1",
              },
              PostalAddress: [],
              AccountId: "",
            },
          };
        } else {
          object = {
            Data: {
              Product: {
                Group: "SAV",
                Type: objectDate.ProductType,
              },
              UCIC: UCIC,
              BranchId: objectDate.BranchId,
              Customer: {
                OrganizationName: "",
                AdultDependents: "",
                Category: "",
                TDSDetails: {
                  FormSubmitted: "",
                },
                TurnOver: "",
                Gender: objectDate.Gender,
                EmailNotification: "",
                EmailStatementFlag: "",
                Name: "",
                MaidenFirstName: "",
                Education: "",
                EmployeeSector: "",
                MotherName: "",
                NoOfDependents: "",
                FATCAFlag: "",
                SMSNotification: "",
                CountryOfRegistration: "",
                NamePrefix: "",
                CountryOfResidence: "",
                Designation: "",
                OfficePhoneNumber: "",
                FirstName: "",
                CustomerCode: "",
                DateAndPlaceOfBirth: {
                  BirthDt: objectDate.BirthDt,
                  CityOfBirth: "",
                  CountryOfBirth: "",
                },
                NatureOfBusiness: "",
                EmployeeNumber: "",
                MinorDependents: "",
                MiddleName: "",
                EmailAddress: "",
                IncomeCategory: "",
                IdentificationType: [
                  {
                    IdentityNumber: "",
                    IdentityType: "",
                    Category: "",
                    SubCategory: "",
                    EmbossedName: "",
                    IssuedBy: "",
                    PlaceOfIssue: "",
                    Country: "",
                    //"IssueDate": "",
                    //"ExpiryDate": ""
                  },
                ],
                CustomerEmployeeNumber: "",
                Occupation: "",
                MaritalStatus: "",
                ResidentialType: "",
                MobileNumber: "",
                Type: "",
                PhoneNumber: "",
                LastName: "",
                AddressType: "P",
                Community: "",
                FatherName: objectDate.FatherName,
                CustomerOrganisationName: "",
              },
              ChequeBookRequired: objectDate.Chequebook.toString(),
              DebitCardRequired: objectDate.Debitcard.toString(),
              Account: {
                NomineeAge:
                  objectDate.NomineeAge == undefined
                    ? ""
                    : objectDate.NomineeAge.toString(),
                EmbossedName:
                  objectDate.NameonDebitcard == undefined
                    ? ""
                    : objectDate.NameonDebitcard,
                SweepFacility: "0",
                Address: "",
                AccountRelationship: "A",
                Reference: [
                  {
                    PostalAddress: "",
                    Name: "",
                  },
                  {
                    PostalAddress: "",
                    Name: "",
                  },
                ],
                Amount: "0",
                NickName: objectDate.FirstName + " " + objectDate.LastName,
                Nominee: {
                  PostalAddress: {
                    Type: "ADDR",
                    StreetName:
                      objectDate.AddressofNominee1 == undefined
                        ? ""
                        : objectDate.AddressofNominee1,
                    BuildingNumber:
                      objectDate.AddressofNominee2 == undefined
                        ? ""
                        : objectDate.AddressofNominee2,
                    Department:
                      objectDate.AddressofNominee3 == undefined
                        ? ""
                        : objectDate.AddressofNominee3,
                    SubDepartment: "",
                    TownName: "",
                    City:
                      objectDate.NomineeCity == undefined
                        ? ""
                        : objectDate.NomineeCity,
                    Landmark: "",
                    CountrySubDivision: "IN",
                    Country: "IN",
                    PostCode:
                      objectDate.NomineePostCode == undefined
                        ? ""
                        : objectDate.NomineePostCode.toString(),
                    AddressLine: "",
                    GeoLocation: {
                      Latitude: "",
                      Longitude: "",
                    },
                  },
                  Relationship:
                    objectDate.RelationwithCustomer == undefined
                      ? ""
                      : objectDate.RelationwithCustomer,
                  GuardianName:
                    objectDate.GuardianName == undefined
                      ? ""
                      : objectDate.GuardianName,
                  Name:
                    objectDate.NameoftheNominee == undefined
                      ? ""
                      : objectDate.NameoftheNominee,
                },
                LeadNo: "",
                MobileBankingStatus: objectDate.MobileBankingFlag.toString(),
                InternetBankingStatus: objectDate.internetbanking.toString(),
                GuardianAge:
                  objectDate.GuardianAge == undefined
                    ? ""
                    : objectDate.GuardianAge.toString(),
                Relationship:
                  objectDate.RelationwithNominee == undefined
                    ? ""
                    : objectDate.RelationwithNominee,
                AccountOpeningFormNumber: this.IDGenerator(),
                //"DateofBirth": (objectDate.NomineeDateofBirth == undefined ? "" : objectDate.NomineeDateofBirth),
                ModeOfOperation: "1",
              },
              PostalAddress: [],
              AccountId: "",
            },
          };
        }

        //console.log(JSON.stringify(object));
        //alert(JSON.stringify(object));
        //var casa = new Date();

        try {
          await $.ajax({
            url:
              "http://localhost:84/api/banking/account/casa/?api_key=kyqak5muymxcrjhc5q57vz9v&userid=" +
              userId,
            type: "POST",
            async: false,
            data: object,
            dataType: "json",
            contentType: "application/x-www-form-urlencoded",
            success: async function (data) {
              //alert(JSON.stringify(data));

              //var res = Math.abs(casa - new Date()) / 1000;
              //var seconds = (res / 60).toFixed(2);
              //FinalTimestamp.push("casa-" + seconds);

              if (data.Status == "success") {
                if (data.Data != null && data.Data != undefined) {
                  if (data.Data.Errors != null && data.Data.Errors.length > 0) {
                    // alert("CASA Account creation Failed : " + data.Data.Errors[0].Code + ' -' + data.Data.Errors[0].Description);
                  } else {
                    //   alert("CASA Account Created Successfully. AccountID ID is :-" + data.Data.AccountID);

                    casaaccountid = data.Data.AccountID;
                  }
                } else {
                  // alert("CASA Account creation Failed:-" + data.Message);
                }
              } else {
                // alert("CASA Account creation Failed :-" + data.Message);
              }
            },
            error: function (ex) {
              // alert("CASA Account creation Failed");
            },
          });
        } catch (error) {
          casaaccountid = "";
        }

        return casaaccountid;
      },

      // async AutoGeneratePDF(SurveyID, FormId, UserToken) {
      //     var referenceNumber = "";
      //     var splitRegex = /\r\n|\r|\n/g;
      //     jsPDF.API.myText = function (txt, options, x, y) {
      //         options = options || {};
      //         /* Use the options align property to specify desired text alignment
      //          * Param x will be ignored if desired text alignment is 'center'.
      //          * Usage of options can easily extend the function to apply different text
      //          * styles and sizes
      //         */
      //         if (options.align == "center") {
      //             // Get current font size
      //             var fontSize = this.internal.getFontSize();

      //             // Get page width
      //             var pageWidth = this.internal.pageSize.width;

      //             // Get the actual text's width
      //             /* You multiply the unit width of your string by your font size and divide
      //              * by the internal scale factor. The division is necessary
      //              * for the case where you use units other than 'pt' in the constructor
      //              * of jsPDF.
      //             */
      //             txtWidth = this.getStringUnitWidth(txt) * fontSize / this.internal.scaleFactor;

      //             // Calculate text's x coordinate
      //             x = (pageWidth - txtWidth) / 2;
      //         }

      //         // Draw text at x,y
      //         this.text(txt, x, y);
      //     };

      //     var doc = new jsPDF({ compress: true });

      //     var surevy = await db.TbSurvey.where({ SurveyID: SurveyID }).toArray();
      //     var SurveyName = (surevy != null && surevy.length > 0) ? surevy[0].SurveyName : "";

      //     var surevyForm = await db.TbSurveyForm.where({ FormID: FormId }).toArray();
      //     if (surevyForm != null && surevyForm.length > 0) {
      //         referenceNumber = surevyForm[0].ReferenceNumber;
      //     }

      //     var vacharheight = 15;
      //     var base64 = await this.ConverttoBase64URLAuto('\/Group49.png');

      //     doc.addImage(base64, 'PNG', 70, vacharheight, 70, 20);
      //     vacharheight = vacharheight + 28;

      //     doc.setFontSize(14);
      //     doc.setFontStyle('bold');
      //     doc.myText(SurveyName, { align: "center" }, 0, vacharheight);

      //     vacharheight = vacharheight + 13;

      //     doc.setFontSize(10);
      //     doc.setFontStyle('normal');
      //     doc.text("User ID :- " + UserToken, 10, vacharheight);
      //     //vacharheight = vacharheight + 7;

      //     vacharheight = vacharheight + 8;
      //     doc.setFontSize(10);
      //     doc.setFontStyle('normal');

      //     var ans3 = await db.TbSurveySection.where({ SurveyId: SurveyID }).toArray();
      //     var ans = (ans3 != null ? ans3.sort(function (a, b) { return a.SectionOrder - b.SectionOrder }) : ans3);

      //     var conditionSectionIds = await db.TbSurveyQuestions.where({ SurveyID: SurveyID }).toArray();
      //     conditionSectionIds = conditionSectionIds.filter(x => x.IsConditionQuestion == true);

      //     for (var cntid = 0; cntid < conditionSectionIds.length; cntid++) {
      //         ans = ans.filter(x => x.SectionId != conditionSectionIds[cntid].ConditionSectionId);
      //     }

      //     for (var i = 0; i < ans.length; i++) {

      //         var SurveyQuestion1 = await db.TbSurveyQuestions.where({ SectionId: ans[i].SectionId }).toArray();
      //         SurveyQuestion1 = SurveyQuestion1.filter(x => x.QuestionType != "Notes");
      //         var SurveyQuestion = (SurveyQuestion1 != null ? SurveyQuestion1.sort(function (a, b) { return a.QuestionOrder - b.QuestionOrder }) : SurveyQuestion1);

      //         for (var j = 0; j < SurveyQuestion.length; j++) {

      //             var object = new Object();
      //             object.QuestionID = SurveyQuestion[j].QuestionID;
      //             object.QuestionName = SurveyQuestion[j].QuestionName;
      //             doc.setFontSize(10);
      //             doc.setFontStyle('normal');
      //             if (vacharheight >= doc.internal.pageSize.height - 20) {
      //                 doc.addPage();
      //                 vacharheight = 25;
      //             }

      //             object.QuestionType = SurveyQuestion[j].QuestionType;

      //             var RepeatQuestionCount = await db.TbSurveyQuestions.where({ RepeatSectionId: ans[i].SectionId }).count();

      //             var Answers = await GetSectionAnswerAutoPdf(object.QuestionID, FormId, object.QuestionType);

      //             if (Answers != null && Answers.length > 0 && RepeatQuestionCount == 0) {
      // debugger
      //                 switch (object.QuestionType) {
      //                     case "Text":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                             object.Answers = Answers[0].Answer;

      //                             doc.text(object.QuestionName + " :- " + object.Answers, 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "MultiLineText":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                             object.Answers = Answers[0].Answer;

      //                             if (object.Answers != null
      //                                 && object.Answers != undefined
      //                                 && object.Answers.length > 0 && object.Answers[0] != undefined) {

      //                                 var totchlen = object.Answers.length / 100;
      //                                 totchlen = Math.ceil(totchlen);

      //                                 for (var chlen = 0; chlen < totchlen; chlen++) {
      //                                     if (chlen == 0) {
      //                                         doc.text(object.QuestionName + " :- " + object.Answers.substring(chlen * 100, (chlen + 1) * 100), 10, vacharheight);
      //                                     } else {
      //                                         doc.text(object.Answers.substring(chlen * 100, (chlen + 1) * 100), 10, vacharheight);
      //                                     }
      //                                     vacharheight = vacharheight + 8;
      //                                 }
      //                             }
      //                         }
      //                         break;
      //                     case "Number":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
      //                             object.Answers = parseInt(Answers[0].Answer);

      //                             doc.text(object.QuestionName + " :- " + object.Answers.toString(), 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "Date":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                             object.Answers = Answers[0].Answer;
      //                             var d = new Date(object.Answers);
      //                             doc.text(object.QuestionName + " :- " + ("0" + (d.getDate())).slice(-2) + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear(), 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "IssuanceDate":
      //                             if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                                 object.Answers = Answers[0].Answer;
      //                                 var d = new Date(object.Answers);
      //                                 doc.text(object.QuestionName + " :- " + ("0" + (d.getDate())).slice(-2) + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear(), 10, vacharheight);
      //                                 vacharheight = vacharheight + 8;
      //                             }
      //                             break;
      //                         case "ExpiryDate":
      //                             if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                                 object.Answers = Answers[0].Answer;
      //                                 var d = new Date(object.Answers);
      //                                 doc.text(object.QuestionName + " :- " + ("0" + (d.getDate())).slice(-2) + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear(), 10, vacharheight);
      //                                 vacharheight = vacharheight + 8;
      //                             }
      //                             break;
      //                     case "CheckBox":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer.length > 0) {
      //                             object.Answers = Answers[0].Answer;
      //                             object.OptionID = parseInt(Answers[0].OptionID);

      //                             doc.text(object.QuestionName + " :- " + object.Answers, 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "Dropdown":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
      //                             object.Answers = ({ "OptionValue": parseInt(Answers[0].OptionID), "OptionText": Answers[0].Answer })
      // debugger
      //                             if (object.QuestionID == 41 || object.QuestionID == 5 || object.QuestionID == 7 || object.QuestionID == 17 ||
      //                                 object.QuestionID == 18 || object.QuestionID == 21 || object.QuestionID == 22 || object.QuestionID == 52 ||
      //                                 object.QuestionID == 58) {
      //                                 var drpn = Answers[0].Answer;
      //                                 drpn = drpn.substring(drpn.indexOf("-") + 1);
      //                                 doc.text(object.QuestionName + " :- " + drpn, 10, vacharheight);
      //                             } else {
      //                                 doc.text(object.QuestionName + " :- " + Answers[0].Answer, 10, vacharheight);
      //                             }

      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "Radio":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "") {
      //                             object.Answers = parseInt(Answers[0].Answer);
      //                         }
      //                         break;
      //                     case "Yes/No":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer > 0) {
      //                             object.Answers = parseInt(Answers[0].Answer);

      //                             if (object.Answers == 1) {
      //                                 doc.text(object.QuestionName + " :- " + 'Yes', 10, vacharheight);
      //                             }
      //                             else {
      //                                 doc.text(object.QuestionName + " :- " + 'No', 10, vacharheight);
      //                             }
      //                             vacharheight = vacharheight + 8;

      //                             if (SurveyQuestion[j].IsConditionQuestion) {
      //                                 var curntanswer = (parseInt(Answers[0].Answer) == 1 ? "Yes" : "No");

      //                                 if (curntanswer == SurveyQuestion[j].ConditionValue1) {
      //                                     var SurveyQuestion2 = await db.TbSurveyQuestions.where({ SectionId: SurveyQuestion[j].ConditionSectionId }).toArray();
      //                                     for (var kk = 0; kk < SurveyQuestion2.length; kk++) {
      //                                         SurveyQuestion.splice(j + (kk + 1), 0, SurveyQuestion2[kk]);
      //                                     }
      //                                 }
      //                             }
      //                         }
      //                         break;
      //                     case "Image":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {

      //                             doc.text(object.QuestionName + ":-", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                             object.Answers = Answers[0].Answers
      //                             object.OrginalFileName = Answers[0].OrginalFileName;
      //                             object.Blob = Answers[0].Blob;
      //                             var base64 = await ConverttoBase64Auto(object.Blob[0]);

      //                             doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
      //                             vacharheight = vacharheight + 40;
      //                         }
      //                         break;
      //                     case "CaptureImage":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             doc.text(object.QuestionName + " :- " + "Yes", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         } else {
      //                             doc.text(object.QuestionName + " :- " + "No", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "ProofOfUtilityBill":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             doc.text(object.QuestionName + " :- " + "Yes", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         } else {
      //                             doc.text(object.QuestionName + " :- " + "No", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "ProofOfResidence":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             doc.text(object.QuestionName + " :- " + "Yes", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         } else {
      //                             doc.text(object.QuestionName + " :- " + "No", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "ProofForSourceOfFunds":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             doc.text(object.QuestionName + " :- " + "Yes", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         } else {
      //                             doc.text(object.QuestionName + " :- " + "No", 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "Audio":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             object.Answers = Answers[0].Answers;
      //                             object.OrginalFileName = Answers[0].OrginalFileName;
      //                             object.Blob = Answers[0].Blob;
      //                             doc.text(object.OrginalFileName, 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                     case "Sign":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Blob != null && Answers[0].Blob.length > 0) {
      //                             object.Answers = Answers[0].Answers
      //                             object.OrginalFileName = Answers[0].OrginalFileName;
      //                             object.Blob = Answers[0].Blob;

      //                             var base64 = await this.ConverttoBase64Auto(object.Blob[0]);

      //                             doc.addImage('data:image/jpeg;base64,' + base64, 'JPEG', 10, vacharheight, 40, 30);
      //                             vacharheight = vacharheight + 40;
      //                         }
      //                         break;
      //                     case "GPS":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer.length > 0) {
      //                             object.Answers = Answers[0].Answer;
      //                             var arr = Answers[0].Answer.split(",");
      //                             object.latitude = arr[0];
      //                             object.longitude = arr[1];
      //                         }
      //                         break;
      //                     case "masterdb":
      //                         if (Answers != null && Answers.length > 0 && Answers[0].Answer != null && Answers[0].Answer != "" && Answers[0].Answer.length > 0) {
      //                             var mstdb = Answers[0].Answer;
      //                             mstdb = mstdb.substring(mstdb.indexOf("-") + 1);
      //                             doc.text(object.QuestionName + " :- " + mstdb, 10, vacharheight);
      //                             vacharheight = vacharheight + 8;
      //                         }
      //                         break;
      //                 }
      //             }
      //             else {
      //                 if (object.QuestionID == 677 || object.QuestionID == 741) {
      //                     doc.text(object.QuestionName + " :- " + 'No', 10, vacharheight);
      //                     vacharheight = vacharheight + 8;
      //                 } else {
      //                     doc.text(object.QuestionName + " :- " + 'None', 10, vacharheight);
      //                     vacharheight = vacharheight + 8;
      //                 }
      //             }
      //         }
      //     }
      //     var base64tetx = doc.output('datauristring');
      //     return base64tetx.split(',')[1];
      // },

      async GetSectionAnswerAutoPdf(QuestionId, FormId, QuestionType) {
        var Answers = await db.TbAnswers.where("QuestionID")
          .equals(QuestionId)
          .toArray();
        Answers = Answers.filter(
          (x) =>
            x.FormID == FormId &&
            (x.EntryId == undefined || x.EntryId == 0 || x.EntryId == null)
        );

        return Answers;
      },

      async ConverttoBase64URLAuto(URL) {
        return fetch(URL)
          .then((response) => response.blob())
          .then(
            (blob) =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );
      },

      async ConverttoBase64Auto(file) {
        return new Promise((resolve, reject) => {
          let fr = new FileReader();
          fr.onload = () => resolve(fr.result.split(",")[1]);
          fr.onerror = () => reject(new Error("Failed to read file"));
          fr.readAsDataURL(file); // or readAsText(file) to get raw content
        });
      },

      async blobToBase64(blob) {
        // const reader = new FileReader();
        // reader.readAsDataURL(blob);
        // return new Promise((resolve, reject) => {
        //     reader.onloadend = () => {
        //         resolve(reader.result);
        //     };
        //     reader.onerror = () => {
        //         reject(new Error('Failed to convert blob to base64'));
        //     };
        // });

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(blob);
        });
      },
      async SendSMS(objDynamicParam, userid) {
        var object = new Object();
        object.DynamicParam = [];

        var otp = false;

        if (objDynamicParam != null && objDynamicParam.length > 0) {
          for (var i = 0; i < objDynamicParam.length; i++) {
            switch (objDynamicParam[i].Name) {
              case "mobilenumber":
                object.PhoneNumber = objDynamicParam[i].Value;
                break;
              case "producttype":
                var objDynamicParam1 = new Object();
                objDynamicParam1.Value = objDynamicParam[i].Value;
                objDynamicParam1.Name = objDynamicParam[i].Name;
                object.DynamicParam.push(objDynamicParam1);
                break;
              case "userid":
                var objDynamicParam2 = new Object();
                objDynamicParam2.Value = objDynamicParam[i].Value;
                objDynamicParam2.Name = objDynamicParam[i].Name;
                object.DynamicParam.push(objDynamicParam2);
                break;
              case "templateid":
                object.TemplateId = objDynamicParam[i].Value;
                break;
              case "accountid":
                var objDynamicParam3 = new Object();
                objDynamicParam3.Value = objDynamicParam[i].Value;
                objDynamicParam3.Name = objDynamicParam[i].Name;
                object.DynamicParam.push(objDynamicParam3);
                break;
              case "OTP":
                var objDynamicParam4 = new Object();
                objDynamicParam4.Value = objDynamicParam[i].Value;
                objDynamicParam4.Name = objDynamicParam[i].Name;
                object.DynamicParam.push(objDynamicParam4);
                otp = true;
                break;
            }
          }

          if (otp) {
            object.OTP = "true";
          } else {
            object.OTP = "false";
          }

          object.IntFlag = "1";
        }

        var objectData = new Object();
        objectData.Data = object;
        //console.log(JSON.stringify(objectData));

        try {
          $.ajax({
            url:
              "http://localhost:84/api/SendSMS?api_key=kyqak5muymxcrjhc5q57vz9v&userid=" +
              userid,
            type: "POST",
            async: false,
            data: objectData,
            dataType: "json",
            contentType: "application/x-www-form-urlencoded",
            success: async function (data) {
              if (data.Data != null) {
                return true;
              } else {
                console.log(data);
              }
            },
            error: function (ex) {
              console.log(ex);
            },
          });
        } catch (error) {
          console.log(error);
        }
      },

      // async SendOTP(mob, email, userid) {

      //     var firstObject = new Object();
      //     firstObject.MobileNumber = mob;
      //     firstObject.EmailID = email;
      //     firstObject.TransactionType = "string";

      //     var otpNumber = "";

      //     try {
      //         await $.ajax({
      //             url: 'http://localhost:84/api/GenerateOTP?userid=' + userid,
      //             type: 'POST',
      //             async: false,
      //             data: firstObject,
      //             dataType: "json",
      //             contentType: "application/x-www-form-urlencoded",
      //             success: async function (data) {

      //                 if (data != null && data != undefined &&
      //                     data.Data != undefined && data.Data != null) {

      //                     if (data.Data.Status = "OTP generated successfully") {
      //                         otpNumber = data.Data.OTP + "," + data.Data["X-Correlation-ID"];
      //                 }
      //                 }
      //             },
      //             error: async function (ex) {

      //             }
      //         });
      //     }
      //     catch (error) {
      //         otpNumber = "";
      //     }

      //     return otpNumber;
      // },

      sleep(milliseconds) {
        const date = Date.now();
        let currentDate = null;
        do {
          currentDate = Date.now();
        } while (currentDate - date < milliseconds);
      },

      async constKey() {
        // debugger
        $.ajax({
          url: "./pwa/scripts/const_key.json",
          dataType: "json",
          // responseType: "application/text",
          success: function (data) {
            if (data != null && data != undefined) {
              this.keyValue = data.cryptoKey[0].key;
              // console.log(keyValue);
              return this.keyValue;
            }
          },
          error: async function (ex) {
            console.log("Error");
          },
        });
      },

      async SubmitToBankApisNew(
        SectionList,
        SurveySectionList,
        usid,
        userId,
        hdngpslocation
      ) {
        var FinalTimestamp = [];
        var apiStatus = false;

        var objectData = new Object();
        objectData.UserToken = userId;

        if (SectionList != null && SectionList.length > 0) {
          for (var i = 0; i < SectionList.length; i++) {
            var Section = SurveySectionList.filter(
              (x) => x.SectionId == SectionList[i]
            );

            if (
              Section != null &&
              Section.length > 0 &&
              Section[0].Questions != null &&
              Section[0].Questions.length > 0
            ) {
              for (var j = 0; j < Section[0].Questions.length; j++) {
                var item = Section[0].Questions[j];
                var Answer = [];

                if (
                  item.Answers != null &&
                  item.Answers != "" &&
                  item.Answers != undefined
                ) {
                  if (
                    item.QuestionType == "Dropdown" ||
                    item.QuestionType == "masterdb"
                  ) {
                    if (Object.keys(item.Answers).length > 0) {
                      Answer = item.Answers.OptionValue;
                    }
                  } else if (item.QuestionType == "Radio") {
                    if (item.Answers > 0) {
                      var rdoItem = item.Options.filter(
                        (x) => x.OptionValue == parseInt(item.Answers)
                      );
                      if (rdoItem != null && rdoItem.length > 0) {
                        Answer = rdoItem[0].OptionValue;
                      }
                    }
                  } else if (
                    item.QuestionType == "Image" ||
                    item.QuestionType == "Audio" ||
                    item.QuestionType == "Sign"
                  ) {
                    if (item.Blob.length > 0 && item.OrginalFileName != "") {
                      Answer = "";
                    }
                  } else if (
                    item.QuestionType == "CaptureImage" ||
                    item.QuestionType == "ProofOfResidence" ||
                    item.QuestionType == "ProofOfUtilityBill" ||
                    item.QuestionType == "ProofForSourceOfFunds"
                  ) {
                    if (item.Blob.length > 0) {
                      Answer = "";
                    }
                  } else if (item.Answers > 0 || item.Answers.length > 0) {
                    if (item.Answers instanceof Array) {
                      if (
                        typeof item.Answers[item.Answers.length - 1] != "string"
                      ) {
                        Answer = item.Answers;
                      } else {
                        Answer = item.Answers[item.Answers.length - 1];
                      }
                    } else {
                      Answer = item.Answers;
                    }
                  }
                }

                if (
                  Answer != null &&
                  Answer != "" &&
                  Answer != undefined &&
                  Answer != "[]"
                ) {
                  switch (item.QuestionName.trim()) {
                    case "First Name":
                      objectData.FirstName = Answer;
                      break;
                    case "Last Name":
                      objectData.LastName = Answer;
                      break;
                    case "Mob.No.":
                      objectData.MobileNumber = Answer;
                      break;
                    case "Date of Birth":
                      objectData.BirthDt = Answer;
                      break;
                    case "Branch":
                      objectData.BranchId =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Mobile Banking":
                      objectData.MobileBankingFlag = Answer == 2 ? "0" : Answer;
                      break;
                    case "Internet Banking":
                      objectData.internetbanking = Answer == 2 ? "0" : Answer;
                      break;
                    case "SMS Alerts":
                      objectData.SMSCustomer = Answer == 2 ? "0" : Answer;
                      break;
                    case "Email Alerts":
                      objectData.EmailStatement = Answer == 2 ? "0" : Answer;
                      break;
                    case "Address Line 1":
                      objectData.Address1 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Address Line 2":
                      objectData.Address2 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Address Line 3":
                      objectData.Address3 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Address Line 4":
                      objectData.Address4 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "City":
                      objectData.city = Answer;
                      break;
                    case "State":
                      objectData.State =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Post Code":
                      objectData.PostCode = Answer;
                      break;
                    case "Email ID":
                      objectData.EmailAddress = Answer;
                      break;
                    case "Religion":
                      objectData.Religion =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Category":
                      objectData.MinorityCode =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Mother's Name":
                      objectData.MotherMaidenName = Answer;
                      objectData.MotherNamePrefix = "Mrs.";
                      break;
                    case "Father's Name":
                      objectData.FatherName = Answer;
                      objectData.FatherNamePrefix = "Mr.";
                      break;
                    case "Are you Married ?":
                      objectData.MaritalStatus = Answer == 1 ? "M" : "S";
                      break;
                    case "Spouse Name":
                      if (objectData.MaritalStatus == "M") {
                        objectData.SpouseName = Answer;
                      }
                      break;
                    case "Education":
                      objectData.EducationQualification =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Occupation":
                      objectData.Occupation =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Annual Income":
                      objectData.AnnualNetIncome =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Tax resident of any country other than India":
                      objectData.FATCACompliance = Answer == 2 ? "N" : "Y";
                      break;
                    case "PAN":
                      objectData.IdentityNumber = Answer;
                      break;
                    case "Aadhar":
                      objectData.IdentityNumber = Answer;
                      break;
                    case "Name Prefix":
                      objectData.NamePrefix = Answer;
                      break;
                    case "Product type":
                      objectData.ProductType =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Would you like Cheque book":
                      objectData.Chequebook = Answer == 1 ? "1" : "0";
                      break;
                    case "Would you like Debit card":
                      objectData.Debitcard = Answer == 1 ? "1" : "0";
                      break;
                    case "Name on Debit card":
                      if (objectData.Debitcard == "1") {
                        objectData.NameonDebitcard =
                          Answer != null && Answer != undefined
                            ? Answer.toUpperCase()
                            : "";
                      }
                      break;
                    case "Nominee Required":
                      objectData.NomineeRequired = Answer == 1 ? "1" : "0";
                      break;
                    case "Name of the Nominee":
                      objectData.NameoftheNominee = Answer;
                      break;
                    case "Relation with Customer":
                      objectData.RelationwithCustomer = Answer;
                      break;
                    case "Nominee - Address Line 1":
                      objectData.AddressofNominee1 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Nominee - Address Line 2":
                      objectData.AddressofNominee2 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Nominee - Address Line 3":
                      objectData.AddressofNominee3 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Nominee - Address Line 4":
                      objectData.AddressofNominee4 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Nominee - City":
                      objectData.NomineeCity = Answer;
                      break;
                    case "Nominee - State":
                      objectData.NomineeState = Answer;
                      break;
                    case "Nominee - Post Code":
                      objectData.NomineePostCode = Answer;
                      break;
                    case "Nominee Date of Birth":
                      objectData.NomineeDateofBirth = Answer;
                      // objectData.NomineeAge = CurrentAge(Answer);
                      break;
                    case "Guardian (In case of minor)":
                      objectData.GuardianName = Answer;
                      break;
                    case "Age of Guardian":
                      objectData.GuardianAge = Answer;
                      break;
                    case "Relation with Nominee":
                      objectData.RelationwithNominee = Answer;
                      break;
                    case "Do you want to activate DND feature on your account?":
                      objectData.DND = Answer == 1 ? "1" : "0";
                      break;
                    case "Gender":
                      objectData.Gender =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    case "Communication - Address Line 1":
                      objectData.ComAddressLine1 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - Address Line 2":
                      objectData.ComAddressLine2 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - Address Line 3":
                      objectData.ComAddressLine3 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - Address Line 4":
                      objectData.ComAddressLine4 =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - Post Code":
                      objectData.ComPostCode =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - City":
                      objectData.ComCity =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - District":
                      objectData.ComDistrict =
                        Answer == undefined || Answer == null ? "" : Answer;
                      break;
                    case "Communication - State":
                      objectData.ComState =
                        Answer != null ? Answer.split("-")[0].trim() : "";
                      break;
                    default:
                    // code block
                  }
                }
              }
            }
          }
        }

        var objectDate = new Object();
        objectDate.Type = "Retail Business";
        objectDate.MotherMaidenName = objectData.MotherMaidenName;
        objectDate.HouseRentedSince = "";
        objectDate.MaidenMiddleName = "";
        objectDate.Gender = objectData.Gender;
        objectDate.Verifier = {
          OrganizationName: "",
          Designation: "",
          VerificationDate: "",
          CKYCApplicationType: "",
          OrganizationCode: "",
          CKYCAccountType: "",
          Id: "",
          VerificationDoctype: "",
          Name: "",
        };

        var PAN = "";
        var AADHAR = "";
        var AADHARREF = "";

        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

        if (genzdata != null && genzdata.length > 0) {
          if (
            genzdata[0].pannoinkyc != null &&
            genzdata[0].pannoinkyc != undefined
          ) {
            PAN = genzdata[0].pannoinkyc;
          }

          if (
            genzdata[0].aadharreference != null &&
            genzdata[0].aadharreference != undefined
          ) {
            AADHARREF = genzdata[0].aadharreference;
          }
          if (
            genzdata[0].aadharnoinkyc != null &&
            genzdata[0].aadharnoinkyc != undefined
          ) {
            AADHAR = genzdata[0].aadharnoinkyc.toString();
            AADHAR = AADHAR.split(" ").join("");
            AADHARREF = AADHAR;
          }
        }

        objectDate.Document = [
          {
            Name: "",
            Type: "PAN",
            IdentityNumber: PAN,
            Category: "",
            SubCategory: "",
            IssuedBy: "",
            PlaceOfIssue: "",
            Content: "",
          },
          {
            Name: "",
            Type: "AADHAR",
            IdentityNumber: AADHARREF,
            Category: "",
            SubCategory: "",
            IssuedBy: "",
            PlaceOfIssue: "",
            Content: "",
          },
        ];
        objectDate.FATCACompliance = objectData.FATCACompliance;
        objectDate.UCIC = "";
        objectDate.LoanApplied = {
          EMI: "",
          Type: "",
        };
        objectDate.MailingAddressType = "P";

        var objPostalAddressp = new Object();
        objPostalAddressp.Type = "P";
        objPostalAddressp.Address1 =
          objectData.Address1 == undefined || objectData.Address1 == null
            ? ""
            : objectData.Address1;
        objPostalAddressp.Address2 =
          objectData.Address2 == undefined || objectData.Address2 == null
            ? ""
            : objectData.Address2;
        objPostalAddressp.Address3 =
          objectData.Address3 == undefined || objectData.Address3 == null
            ? ""
            : objectData.Address3;
        objPostalAddressp.Address4 =
          objectData.Address4 == undefined || objectData.Address4 == null
            ? ""
            : objectData.Address4;
        objPostalAddressp.Taluka = "";
        objPostalAddressp.District = "";
        objPostalAddressp.City = objectData.city;
        objPostalAddressp.Landmark = "";
        objPostalAddressp.State = objectData.State;
        objPostalAddressp.Country = "IN";
        objPostalAddressp.PostCode = objectData.PostCode;
        objPostalAddressp.AddressLine = "";

        var objPostalAddresso = new Object();
        objPostalAddresso.Type = "R";
        objPostalAddresso.Address1 =
          objectData.ComAddressLine1 == undefined ||
          objectData.ComAddressLine1 == null
            ? ""
            : objectData.ComAddressLine1;
        objPostalAddresso.Address2 =
          objectData.ComAddressLine2 == undefined ||
          objectData.ComAddressLine2 == null
            ? ""
            : objectData.ComAddressLine2;
        objPostalAddresso.Address3 =
          objectData.ComAddressLine3 == undefined ||
          objectData.ComAddressLine3 == null
            ? ""
            : objectData.ComAddressLine3;
        objPostalAddresso.Address4 =
          objectData.ComAddressLine4 == undefined ||
          objectData.ComAddressLine4 == null
            ? ""
            : objectData.ComAddressLine4;
        objPostalAddresso.Taluka = "";
        objPostalAddresso.District = objectData.ComDistrict;
        objPostalAddresso.City = objectData.ComCity;
        objPostalAddresso.Landmark = "";
        objPostalAddresso.State = objectData.ComState;
        objPostalAddresso.Country = "IN";
        objPostalAddresso.PostCode = objectData.ComPostCode;
        objPostalAddresso.AddressLine = "";

        var objectGeo = new Object();
        if (hdngpslocation != null && hdngpslocation.length > 0) {
          objectGeo.Latitude = hdngpslocation.split(",")[0];
          objectGeo.Longitude = hdngpslocation.split(",")[1];
        }

        objPostalAddressp.GeoLocation = objectGeo;
        objPostalAddresso.GeoLocation = objectGeo;

        var objectContact1 = new Object();
        var objPostalAddress1 = new Object();
        objPostalAddress1.EmailAddress = "";
        objPostalAddress1.MobileNumber = "";
        objPostalAddress1.ResidencePhoneNumber = "";
        objPostalAddress1.OfficePhoneNumber = "";
        objectContact1.ContactDetails = [];

        objPostalAddress1.PostalAddress = objPostalAddressp;
        objectContact1.ContactDetails.push(objPostalAddress1);

        var objPostalAddress2 = new Object();
        objPostalAddress2.EmailAddress = "";
        objPostalAddress2.MobileNumber = "";
        objPostalAddress2.ResidencePhoneNumber = "";
        objPostalAddress2.OfficePhoneNumber = "";
        objPostalAddress2.PostalAddress = objPostalAddresso;
        objectContact1.ContactDetails.push(objPostalAddress2);

        objectDate.ContactDetails = [];
        objectDate.ContactDetails = objectContact1;
        objectDate.FaxNumber = "";
        objectDate.RiskRating = "";
        objectDate.FatherLastName = "";
        objectDate.MoneyRiskCode = "";
        objectDate.CKYCDateOfDeclaration = "";
        objectDate.PANValidationDate = "";
        objectDate.YearsOfSelfEmployment = "";
        objectDate.EKYCDate = "";
        objectDate.BranchId = objectData.BranchId;
        objectDate.SMSRegistration = "";
        objectDate.FatherNamePrefix = objectData.FatherNamePrefix;
        objectDate.Caste = "";
        objectDate.OwnershipStatus = "";
        objectDate.SpouseMiddleName = "";
        objectDate.KYCType = "36";
        objectDate.PPI = "";
        objectDate.YearsAtCurrentAddress = "";
        objectDate.Party = {
          ChildDependent: "",
          OrganizationName: "",
          Status: "",
          Designation: "",
          AdultDependent: "",
          EmailAddress: objectData.EmailAddress,
          Name: "",
          UCIC: "",
          Role: "",
          Occupation: objectData.Occupation,
          Type: "",
          AnnualNetIncome: objectData.AnnualNetIncome,
          MobileNumber: objectData.MobileNumber,
          DateOfJoining: "",
          CommunicationAddressType: "P",
          Relationship: "",
          AlternateMobileNumber: "",
          EmployeeId: "",
          MonthlyIncome: "",
        };

        objectDate.MaidenNamePrefix = "";
        objectDate.Form60 = "";
        objectDate.Form61 = "";
        objectDate.SMSCustomer = objectData.SMSCustomer.toString();
        objectDate.EducationQualification = objectData.EducationQualification;
        objectDate.WorkingFamilyMembers = "";
        objectDate.FirstName = objectData.FirstName;
        objectDate.Introducer = {
          PostalAddress: [
            {
              Type: "",
              Address1: "",
              Address2: "",
              Address3: "",
              Address4: "",
              Taluka: "",
              District: "",
              City: "",
              Landmark: "",
              State: "",
              Country: "",
              PostCode: "",
              AddressLine: "",
              GeoLocation: {
                Latitude: "",
                Longitude: "",
              },
            },
          ],
          CountryOfResidence: "IN",
          EmbossedName: "",
          IdentificaitonType: "",
          CustomerKnownSince: "",
          SmartService: "",
          Relationship: "",
          AdditionalRiskCode: "",
          OtherRelation: "",
          Name: "",
          UCIC: "",
        };

        objectDate.CustomerCode = "1";
        objectDate.InternetBanking = objectData.internetbanking.toString();
        objectDate.AddressProof = AADHARREF;
        objectDate.Religion = objectData.Religion;
        objectDate.EKYCFlag = "";
        objectDate.Hobbies = "";
        objectDate.RelationshipStatus = "";
        objectDate.SpouseName = objectData.SpouseName;
        objectDate.BSR4Level = [""];
        objectDate.MailingAddressProofType = "";
        objectDate.NetWorth = "";
        objectDate.Insurance = {
          OrganizationName: "",
          Type: "",
          IdentityNumber: "",
        };

        objectDate.MobileBankingFlag = objectData.MobileBankingFlag.toString();
        objectDate.MotherLastName = "";
        objectDate.FatherName = objectData.FatherName;
        objectDate.EmailStatement = objectData.EmailStatement.toString();
        objectDate.KYCLastModifiedDate = "";
        objectDate.SpouseLastName = "";
        objectDate.PermanentAddressProofNumber = "";
        objectDate.MonthsOfSelfEmployment = "";
        objectDate.KYC = {
          Declaration: "",
        };
        objectDate.Remarks = {
          HouseHold: "",
        };

        objectDate.Form15H = "";
        objectDate.PermanentAddressType = "";
        objectDate.FATCAAddressType = "";

        var objectdob = new Object();
        objectdob.BirthDt = objectData.BirthDt;
        objectdob.CityOfBirth = "";
        objectdob.CountryOfBirth = "";
        objectDate.DateAndPlaceOfBirth = objectdob;

        objectDate.AMLScreening = "";
        objectDate.PhysicalStatus = "";
        objectDate.MaritalStatus = objectData.MaritalStatus;
        objectDate.Area = "";
        objectDate.CKYCId = "";
        objectDate.MotherMiddleName = "";
        objectDate.LastName = objectData.LastName;
        objectDate.EmployeeName = "";
        objectDate.MaidenName = "";
        objectDate.CreateDateTime = "";
        objectDate.SpouseNamePrefix = "";
        objectDate.MailingAddressProofNumber = "";
        objectDate.Source = "IEXCEED";
        objectDate.MaidenLastName = "";
        objectDate.PoliticallyExposedPerson = "";
        objectDate.OfficeAddressType = "";
        objectDate.NamePrefix = "1";
        objectDate.CountryOfResidence = "IN";
        objectDate.SBUCode = "03";
        objectDate.TDS = "";
        objectDate.FatherMiddleName = "";
        objectDate.Notification = "";
        objectDate.MobileNumberOwner = "1";
        objectDate.EmailStatementFrequency = "";
        objectDate.MotherNamePrefix = "Mrs.";
        objectDate.Form15G = "";
        objectDate.PermanentAddressProofType = "";
        objectDate.MiddleName = "";

        objectDate.CCM = {
          MinorityCode: objectData.MinorityCode,
          IdentificaitonType: "",
          FamilyMembersCount: "",
          TotalExperience: "",
          Reference: {
            Date: "",
            AccountNumber: "",
          },
          EmployeeNumber: "",
          DNDEmailAddress: "",
          Name: "",
          DistanceFromBranch: "",
          PostalAddress: [
            {
              Type: "",
              Address1: "",
              Address2: "",
              Address3: "",
              Address4: "",
              Taluka: "",
              District: "",
              City: "",
              Landmark: "",
              State: "",
              Country: "",
              PostCode: "",
              AddressLine: "",
              GeoLocation: {
                Latitude: "",
                Longitude: "",
              },
            },
          ],
          FinancialAsset: {
            NetWorthAsset: "",
            FinancialAsset: [""],
          },
          AuthorizerName: "",
          PeriodOfStay: "",
          ReasonForLocation: "",
          CustomerFeedback: "",
          WeakerSectorCode: "",
          CKYCModifiedDate: "",
        };

        objectDate.IdentificationType = [];

        if (PAN != null && PAN.length > 0) {
          var objIdentificationType = new Object();
          objIdentificationType.IdentityNumber = PAN;
          objIdentificationType.IdentityType = "PAN";
          objIdentificationType.Category = "";
          objIdentificationType.SubCategory = "";
          objIdentificationType.EmbossedName = "";
          objIdentificationType.IssuedBy = "";
          objIdentificationType.PlaceOfIssue = "";
          objIdentificationType.Country = "";
          objectDate.IdentificationType.push(objIdentificationType);
        }

        if (AADHAR != null && AADHAR.length > 0) {
          objIdentificationType = new Object();
          objIdentificationType.IdentityNumber = AADHAR;
          objIdentificationType.IdentityType = "AADHAR";
          objIdentificationType.Category = "";
          objIdentificationType.SubCategory = "";
          objIdentificationType.EmbossedName = "";
          objIdentificationType.IssuedBy = "";
          objIdentificationType.PlaceOfIssue = "";
          objIdentificationType.Country = "";
          objectDate.IdentificationType.push(objIdentificationType);
        }

        objIdentificationType = new Object();
        objIdentificationType.IdentityNumber = "";
        objIdentificationType.IdentityType = "AADRCD";
        objIdentificationType.Category = "ADDRESSPROOF";
        objIdentificationType.SubCategory = "";
        objIdentificationType.EmbossedName = "";
        objIdentificationType.IssuedBy = "";
        objIdentificationType.PlaceOfIssue = "";
        objIdentificationType.Country = "";
        objectDate.IdentificationType.push(objIdentificationType);

        objIdentificationType = new Object();
        objIdentificationType.IdentityNumber = "";
        objIdentificationType.IdentityType = "";
        objIdentificationType.Category = "OTHER";
        objIdentificationType.SubCategory = "";
        objIdentificationType.EmbossedName = "";
        objIdentificationType.IssuedBy = "";
        objIdentificationType.PlaceOfIssue = "";
        objIdentificationType.Country = "";
        objectDate.IdentificationType.push(objIdentificationType);

        objectDate.DOBRelation = "";
        objectDate.ResidentialStatus = "1";
        objectDate.OtherBankAccount = "";
        objectDate.UserId = "IEXCEED";
        objectDate.MailingPermanentAddressFlag = "Y";
        objectDate.ElectronicBillPayment = "";
        objectDate.DND = objectData.DND;

        var object1 = new Object();
        object1.Individual = objectDate;

        var object = new Object();
        object.Data = object1;
        var stat = false;
        //console.log(JSON.stringify(object));
        var customercreationId = "";
        var correlationId = "";
        var CasaAccountId = "";

        var objectarr = new Object();
        objectarr.object = [];
        objectarr.objectData = [];

        objectarr.object.push(object);
        objectarr.objectData.push(objectData);

        return objectarr;
      },

      async DataProcess(userid, syncId) {
        var ClientSyncData = await db.ClientSyncQueue.where("SyncQueuePKID")
          .equals(syncId)
          .toArray();
        var surveyName = "";
        var arrImage = new Array();
        var FormID = 0;
        var SurveyId = 0;
        if (
          ClientSyncData != null &&
          ClientSyncData.length > 0 &&
          ClientSyncData[0].TagName != "User"
        ) {
          ClientSyncData = ClientSyncData.filter((x) => x.TagName != "User");

          for (var k = 0; k < ClientSyncData.length; k++) {
            FormID = ClientSyncData[k].FormID;
            SurveyId = ClientSyncData[k].SurveyID;
            var TbSurvey = await db.TbSurvey.where("SurveyID")
              .equals(SurveyId)
              .toArray();
            surveyName =
              TbSurvey != null && TbSurvey.length > 0
                ? TbSurvey[0].SurveyName
                : "";

            var ans3 = await db.TbSurveySection.where({
              SurveyId: SurveyId,
            }).toArray();
            var ans =
              ans3 != null
                ? ans3.sort(function (a, b) {
                    return a.SectionOrder - b.SectionOrder;
                  })
                : ans3;

            var conditionSectionIds = await db.TbSurveyQuestions.where({
              SurveyID: SurveyId,
            }).toArray();
            conditionSectionIds = conditionSectionIds.filter(
              (x) => x.IsConditionQuestion == true
            );

            for (var cntid = 0; cntid < conditionSectionIds.length; cntid++) {
              ans = ans.filter(
                (x) =>
                  x.SectionId != conditionSectionIds[cntid].ConditionSectionId
              );
            }
            var arr = new Array();

            for (var i = 0; i < ans.length; i++) {
              var SurveyQuestion1 = await db.TbSurveyQuestions.where({
                SectionId: ans[i].SectionId,
              }).toArray();
              SurveyQuestion1 = SurveyQuestion1.filter(
                (x) => x.QuestionType != "Notes"
              );
              var SurveyQuestion =
                SurveyQuestion1 != null
                  ? SurveyQuestion1.sort(function (a, b) {
                      return a.QuestionOrder - b.QuestionOrder;
                    })
                  : SurveyQuestion1;

              for (var j = 0; j < SurveyQuestion.length; j++) {
                if (
                  SurveyQuestion[j].QuestionText == "ISDCode" ||
                  SurveyQuestion[j].QuestionText == "ISDCodes"
                ) {
                  SurveyQuestion[j].QuestionText =
                    SurveyQuestion[j].QuestionName;
                }
                var object = new Object();

                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = SurveyQuestion[j].SectionId;
                object.QuestionID = SurveyQuestion[j].QuestionID;
                object.Question = SurveyQuestion[j].QuestionText;
                object.QuestionType = SurveyQuestion[j].QuestionType;

                var RepeatQuestionCount = await db.TbSurveyQuestions.where({
                  RepeatSectionId: ans[i].SectionId,
                }).count();

                var Answers = await this.GetSectionAnswerAutoPdf(
                  object.QuestionID,
                  FormID,
                  object.QuestionType
                );

                if (
                  Answers != null &&
                  Answers.length > 0 &&
                  RepeatQuestionCount == 0
                ) {
                  object.Answer = Answers[0].Answer;

                  if (
                    SurveyQuestion[j].QuestionType == "Image" ||
                    SurveyQuestion[j].QuestionType == "Sign"
                  ) {
                    object.Answer = "";

                    if (Answers[0].Blob != null && Answers[0].Blob.length > 0) {
                      for (var m = 0; m < Answers[0].Blob.length; m++) {
                        var objectImage = new Object();

                        switch (object.QuestionID) {
                          // case 56:
                          // objectImage.Name = "File";
                          // break;
                          case 54:
                            objectImage.Name = "FullKYCSignature";
                            break;
                          // case 56:
                          //     objectImage.Name = "ProofOfResidence";
                          //     break;
                          // case 58:
                          //     objectImage.Name = "ProofOfUtilityBill";
                          //     break;
                          // case 63:
                          //     objectImage.Name = "ProofForSourceOfFunds";
                          //     break;
                          case 152:
                            objectImage.Name = "LiteKYCSignature";
                            break;
                          case 154:
                            objectImage.Name = "CaptureImage";
                            break;
                          case 56:
                            objectImage.Name = "ProofOfResidence";
                            break;
                          case 58:
                            objectImage.Name = "ProofOfUtilityBill";
                            break;
                          // case 154:
                          //         objectImage.Name = "ProofOfUtilityBill";
                          //         break;
                          case 63:
                            objectImage.Name = "ProofForSourceOfFunds";
                            break;
                        }
                        objectImage.Image = Answers[0].Blob[m];
                        arrImage.push(objectImage);
                      }
                    }
                  } else if (
                    SurveyQuestion[j].QuestionType == "CaptureImage" ||
                    SurveyQuestion[j].QuestionType == "ProofOfResidence" ||
                    SurveyQuestion[j].QuestionType == "ProofOfUtilityBill" ||
                    SurveyQuestion[j].QuestionType == "ProofForSourceOfFunds"
                  ) {
                    object.Answer = "";

                    if (Answers[0].Blob != null) {
                      // for (var m = 0; m < Answers[0].Blob.length; m++) {
                      objectImage = new Object();

                      switch (object.QuestionID) {
                        // case 55:
                        //         objectImage.Name = "CaptureImage";
                        //         break;
                        case 154:
                          objectImage.Name = "CaptureImage";
                          break;
                        case 56:
                          objectImage.Name = "ProofOfResidence";
                          break;
                        case 58:
                          objectImage.Name = "ProofOfUtilityBill";
                          break;
                        // case 154:
                        //         objectImage.Name = "ProofOfUtilityBill";
                        //         break;
                        case 63:
                          objectImage.Name = "ProofForSourceOfFunds";
                          break;
                      }
                      objectImage.Image = Answers[0].Blob[0];
                      arrImage.push(objectImage);
                      // }
                    }
                  }
                }

                if (
                  object.Answer != null &&
                  object.Answer != "" &&
                  object.Answer != undefined &&
                  object.Answer != "[]"
                ) {
                  if (object.QuestionType == "Yes/No") {
                    object.Answer = parseInt(object.Answer);

                    if (SurveyQuestion[j].IsConditionQuestion) {
                      var curntanswer =
                        parseInt(object.Answer) == 1 ? "Yes" : "No";

                      if (curntanswer == SurveyQuestion[j].ConditionValue1) {
                        var SurveyQuestion2 = await db.TbSurveyQuestions.where({
                          SectionId: SurveyQuestion[j].ConditionSectionId,
                        }).toArray();
                        for (var kk = 0; kk < SurveyQuestion2.length; kk++) {
                          SurveyQuestion.splice(
                            j + (kk + 1),
                            0,
                            SurveyQuestion2[kk]
                          );
                        }
                      }
                    }

                    switch (object.Answer) {
                      case 1:
                        object.Answer = "Yes";
                        break;
                      case 2:
                        object.Answer = "No";
                        break;
                    }
                  } else if (
                    object.QuestionType == "Dropdown" ||
                    object.QuestionType == "masterdb"
                  ) {
                    switch (object.Question) {
                      case "Branch State":
                        var ansbr = object.Answer;
                        object.Answer = ansbr.substring(ansbr.indexOf("-") + 1);
                        break;
                      case "Branch":
                        // object.Answer = (object.Answer != null ? object.Answer.split('-')[1].trim() : "");
                        var ansbr1 = object.Answer;
                        object.Answer = ansbr1.substring(
                          ansbr1.indexOf("-") + 1
                        );
                        break;
                      case "Religion":
                        var ansbr2 = object.Answer;
                        object.Answer = ansbr2.substring(
                          ansbr2.indexOf("-") + 1
                        );
                        break;
                      case "Category":
                        var ansbr3 = object.Answer;
                        object.Answer = ansbr3.substring(
                          ansbr3.indexOf("-") + 1
                        );
                        break;
                      case "Annual Income":
                        var ansbr4 = object.Answer;
                        object.Answer = ansbr4.substring(
                          ansbr4.indexOf("-") + 1
                        );
                        break;
                      case "Education":
                        //var splt = object.Answer.split('-');
                        //if (splt != null && splt.length > 0 && splt[0] == "01") {
                        //    object.Answer = object.Answer.split('-')[1].trim() + "-" + object.Answer.split('-')[2].trim();
                        //} else {
                        //    object.Answer = (object.Answer != null ? object.Answer.split('-')[1].trim() : "");
                        //}
                        var ansbr5 = object.Answer;
                        object.Answer = ansbr5.substring(
                          ansbr5.indexOf("-") + 1
                        );
                        break;
                      case "Occupation":
                        var ansbr6 = object.Answer;
                        object.Answer = ansbr6.substring(
                          ansbr6.indexOf("-") + 1
                        );
                        break;
                      case "Product type":
                        var ansbr7 = object.Answer;
                        object.Answer = ansbr7.substring(
                          ansbr7.indexOf("-") + 1
                        );
                        break;
                    }
                  }
                }
                // if(object.Answer){
                // arr.push(object);
                // }
                if (object.Answer != undefined) {
                  if (object.Answer != "") {
                    arr.push(object);
                  }
                } else if (object.Answer == undefined) {
                  // to not send empty data to backend
                }

                // else if(object.Answer == undefined && (object.Question != "Account Class(Current)" && object.Question != "Account Class(Savings)" && object.Question != "Account Class(Call)" && object.Question != "Source of Funds(SelfEmployed)" && object.Question != "Source of Funds(Employed)" && object.Question != "Source of Funds(Pensioner)" && object.Question != "Source of Funds(UnEmployed)" )){
                //     arr.push(object);
                // }
              }
            }

            var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
            var userToken = "";
            if (genzdata != null && genzdata.length != 0) {
              userToken = genzdata[0].token;
              if (typeof genzdata[0].consentForm != "undefined") {
                object = new Object();
                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = 10002;
                object.QuestionID = 1000000;
                object.Question = "Consent for account opening";
                object.QuestionType = "CheckBox";
                object.Answer = "I AGREE";
                arr.push(object);
              }

              if (typeof genzdata[0].termsandCondition != "undefined") {
                object = new Object();
                object.SurveyID = SurveyId;
                object.SurveyName = surveyName;
                object.SectionId = 10003;
                object.QuestionID = 1000001;
                object.Question = "Terms and Condition";
                object.QuestionType = "CheckBox";
                object.Answer = "I AGREE";
                arr.push(object);
              }
            }

            /* image upload Section  Starts*/
            objectImage = new Object();
            if (arrImage != null && arrImage.length > 0) {
              for (var imgcount = 0; imgcount < arrImage.length; imgcount++) {
                var base64data = await this.blobToBase64(
                  arrImage[imgcount].Image
                );
                switch (arrImage[imgcount].Name) {
                  case "PhotoofCustomer":
                    objectImage.PhotoofCustomer = base64data.split(",")[1];
                    break;
                  case "Signature":
                    objectImage.Signature = base64data.split(",")[1];
                    break;
                  case "FullKYCSignature":
                    objectImage.FullKYCSignature = base64data.split(",")[1];
                    break;
                  case "LiteKYCSignature":
                    objectImage.LiteKYCSignature = base64data.split(",")[1];
                    break;
                  case "UploadDeclaration":
                    objectImage.UploadDeclaration = base64data.split(",")[1];
                    break;
                  case "ProofOfResidence":
                    objectImage.ProofOfResidence = base64data.split(",")[1];
                    break;
                  case "CaptureImage":
                    objectImage.CaptureImage = base64data.split(",")[1];
                    break;
                  case "ProofOfUtilityBill":
                    objectImage.ProofOfUtilityBill = base64data.split(",")[1];
                    break;
                  case "ProofForSourceOfFunds":
                    objectImage.ProofForSourceOfFunds =
                      base64data.split(",")[1];
                    break;
                }
              }
            }

            // objectImage.FormPdf = await AutoGeneratePDF(SurveyId, FormID, userToken);
            // console.log(objectImage.FormPdf);

            var isIos = "False";
            var deviceAgent = navigator.userAgent.toLowerCase();
            var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
            if (agentID) {
              isIos = "True";
            }

            console.log("arr two", arr);

            // let firstNameObj = arr.find((q) => q.Question === "First Name");
            // let middleNameObj = arr.find((q) => q.Question === "Middle Name");
            // let surnameObj = arr.find((q) => q.Question === "Surname");

            // let firstName = firstNameObj ? firstNameObj.Answer : "";
            // let middleName = middleNameObj ? middleNameObj.Answer : "";
            // let surname = surnameObj ? surnameObj.Answer : "";

            // let arrNew = arr.map((item) => {
            //   if (item.Question.startsWith("Account Class")) {
            //     let fullName = [surname, firstName, middleName]
            //       .filter((name) => name.trim())
            //       .join(" ");
            //     return { ...item, Answer: fullName };
            //   }
            //   return item;
            // });

            try {
              //console.log(JSON.stringify(arr));
              var formDataImage = new FormData();
              genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
              // formDataImage.append('clientUserId', userToken);
              formDataImage.append("isios", isIos);
              formImage.push(objectImage);
              // formImage('data', { objectImage });
              var stringifyjson = JSON.stringify(objectImage);
              formDataImage.append("data", stringifyjson);
              formDataImage.append("userid", userToken);
              formDataImage.append("UploadType", "notKycData");
              // formDataImage.append(
              //   "PWAUserSessionId",
              //   genzdata[0].PWAUserSessionId
              // );
              formDataImage.append(
                "PWAUserSessionId",
                getSessionId()
              );

              $.ajax({
                url: externalURL + "uploadmultiple/",
                type: "POST",
                data: formDataImage,
                headers: {
                     'DSAUserId': genzdata[0].DSAUserId
                },
                processData: false,
                contentType: false,
                success: function (dataupload) {
                  //console.log(dataupload)
                if(dataupload.PPWAUserSessionStatus){
                  if (dataupload.PWAUserSessionStatus == "expired") {
                    setTimeout(() => {
                      self.PreLoader = false;
                    }, 500);
                    sunidhi.logoutBtnDisp = false;
                    router.push({ name: "SessionTimeout" });
                  }
                }
                if(dataupload.DSAAuthenticationStatus){
                  if (dataupload.DSAAuthenticationStatus == "81") {
                     if (sunidhi.handleAuthFailure(dataupload, self)) {
                        return;
                      }
                  } 
                }
                },
                error: function (ex) {
                  console.log(ex);
                  setTimeout(() => {
                    self.PreLoader = false;
                  }, 500);
                  alert(
                    "Network error: Something is wrong with your internet connection. Please try again after restoring the connection."
                  );
                },
              });

              /* image upload Section Ends */
              var jsondata = JSON.stringify(arr);

              jsondata = '{"customerdetails":' + jsondata + "}";

              var data = new FormData();
              genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

              data.append("formjson", jsondata);
              data.append("UserId", userToken);
              data.append("PWADSAUserId", genzdata[0].DSAUserId);
              data.append("PWAUserType", this.PwaUserType);
              data.append("interimSave", "1");
              // data.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
              data.append("PWAUserSessionId", getSessionId());
              data.append("PWAUserBranchCode", genzdata[0].PWAUserBranchCode);

              let response = await fetch(
                externalURL + "CreateRefIdForApplication/",
                {
                  //mode: "no-cors",
                  method: "POST",
                  //body: 'formjson=' + jsondata,
                  body: data,
                   headers: { 'DSAUserId': genzdata[0].DSAUserId }
                }
              );

              let result = await response.json();
              if (response.statusText == "OK") {
                if (result.Message == "Success") {
                  console.log("");
                }
              } 
              if(result.DSAAuthenticationStatus == '81'){
               if (sunidhi.handleAuthFailure(result, self)) {
                       return
                    }
                  }
              else {
                return result;
              }
              return result;
            } catch (err) {
              setTimeout(() => {
                self.PreLoader = false;
              }, 500);
              alert(
                "Service Unavailable due to network issue. Please try again later.3"
              );
            }
          }
        }
      },

      async LogouttheApplication() {
        var self = this;
        // this.isDispLogoutPopUp = true;
        sunidhi.logoutBtnDisp = false;
        // self.logoutBtnDisp = false;
        var formdata = new FormData();
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

        // formdata.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
        formdata.append("PWAUserSessionId", getSessionId());
        formdata.append("LogoutFlag", "FINALLOGOUT");

        try {
          $.ajax({
            url: externalURL + "Logout/",
            type: "POST",
            data: formdata,
            headers: {
                      'DSAUserId': genzdata[0].DSAUserId
                    },
            processData: false,
            contentType: false,
            success: async function (data) {
              console.log("logout", data);

              if (data.DSAAuthenticationStatus !== "01") {
                if (data.Message == "Success") {
                  router.push({ name: "LoginPage" });
                  // this.deleteDBData();
                  location.reload(true);
                }
              } else {
                alert(data.message);
                sunidhi.logoutBtnDisp = true;
              }
            },
          });
        } catch (err) {
          console.log("Logout error", err);
          alert(
            "Service Unavailable due to network issue. Please try again later.4"
          );
        }
      },

      async formsSessionTimeout() {
        var self = this;
        // debugger
        var formdata = new FormData();
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

        // formdata.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
        formdata.append("PWAUserSessionId", getSessionId());

        try {
          $.ajax({
            url: externalURL + "Logout/",
            type: "POST",
            data: formdata,
            headers: {
                      'DSAUserId': genzdata[0].DSAUserId
                    },
            processData: false,
            contentType: false,
            success: async function (data) {
              if (data.PWAUserSessionStatus == "expired") {
                sunidhi.logoutBtnDisp = false;
                router.push({ name: "SessionTimeout" });
                return true;
              } else {
                return false;
              }
            },
          });
        } catch (err) {
          console.log(err);
        }
      },

       handleAuthFailure(response, self) {
          if (
          response &&
          String(response.DSAAuthenticationStatus) === '81'
        ) {
            alert(
              'Your session is active in another device or tab. Please login again.'
            )

            sessionStorage.removeItem('PWAUserSessionId')

           
              router.push({ name: "LoginPage" });
                  // this.deleteDBData();
                  location.reload(true);
           

            return true
          }

          return false
        },
      

      async validateResponseSessionId(data) {
        if (
          data.PWAUserSessionId === null ||
          data.PWAUserSessionId === "" ||
          data.PWAUserSessionId === undefined
        ) {
          return false;
        } else {
          return true;
        }
      },
    });

    // app.config.globalProperties.$sunidhi = sunidhi;

    Vue.prototype.$sunidhi = sunidhi;
  },
};
